function Hc(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const l in r)
        if (l !== "default" && !(l in e)) {
          const o = Object.getOwnPropertyDescriptor(r, l);
          o &&
            Object.defineProperty(
              e,
              l,
              o.get ? o : { enumerable: !0, get: () => r[l] },
            );
        }
    }
  }
  return Object.freeze(
    Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
  );
}
(function () {
  const t = document.createElement("link").relList;
  if (t && t.supports && t.supports("modulepreload")) return;
  for (const l of document.querySelectorAll('link[rel="modulepreload"]')) r(l);
  new MutationObserver((l) => {
    for (const o of l)
      if (o.type === "childList")
        for (const i of o.addedNodes)
          i.tagName === "LINK" && i.rel === "modulepreload" && r(i);
  }).observe(document, { childList: !0, subtree: !0 });
  function n(l) {
    const o = {};
    return (
      l.integrity && (o.integrity = l.integrity),
      l.referrerPolicy && (o.referrerPolicy = l.referrerPolicy),
      l.crossOrigin === "use-credentials"
        ? (o.credentials = "include")
        : l.crossOrigin === "anonymous"
          ? (o.credentials = "omit")
          : (o.credentials = "same-origin"),
      o
    );
  }
  function r(l) {
    if (l.ep) return;
    l.ep = !0;
    const o = n(l);
    fetch(l.href, o);
  }
})();
function Qc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default")
    ? e.default
    : e;
}
var ga = { exports: {} },
  yl = {},
  va = { exports: {} },
  b = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var cr = Symbol.for("react.element"),
  Gc = Symbol.for("react.portal"),
  Kc = Symbol.for("react.fragment"),
  qc = Symbol.for("react.strict_mode"),
  Yc = Symbol.for("react.profiler"),
  Xc = Symbol.for("react.provider"),
  Zc = Symbol.for("react.context"),
  Jc = Symbol.for("react.forward_ref"),
  ed = Symbol.for("react.suspense"),
  td = Symbol.for("react.memo"),
  nd = Symbol.for("react.lazy"),
  es = Symbol.iterator;
function rd(e) {
  return e === null || typeof e != "object"
    ? null
    : ((e = (es && e[es]) || e["@@iterator"]),
      typeof e == "function" ? e : null);
}
var ya = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {},
  },
  wa = Object.assign,
  xa = {};
function wn(e, t, n) {
  ((this.props = e),
    (this.context = t),
    (this.refs = xa),
    (this.updater = n || ya));
}
wn.prototype.isReactComponent = {};
wn.prototype.setState = function (e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null)
    throw Error(
      "setState(...): takes an object of state variables to update or a function which returns an object of state variables.",
    );
  this.updater.enqueueSetState(this, e, t, "setState");
};
wn.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function Sa() {}
Sa.prototype = wn.prototype;
function li(e, t, n) {
  ((this.props = e),
    (this.context = t),
    (this.refs = xa),
    (this.updater = n || ya));
}
var oi = (li.prototype = new Sa());
oi.constructor = li;
wa(oi, wn.prototype);
oi.isPureReactComponent = !0;
var ts = Array.isArray,
  ka = Object.prototype.hasOwnProperty,
  ii = { current: null },
  Ca = { key: !0, ref: !0, __self: !0, __source: !0 };
function Ea(e, t, n) {
  var r,
    l = {},
    o = null,
    i = null;
  if (t != null)
    for (r in (t.ref !== void 0 && (i = t.ref),
    t.key !== void 0 && (o = "" + t.key),
    t))
      ka.call(t, r) && !Ca.hasOwnProperty(r) && (l[r] = t[r]);
  var s = arguments.length - 2;
  if (s === 1) l.children = n;
  else if (1 < s) {
    for (var a = Array(s), c = 0; c < s; c++) a[c] = arguments[c + 2];
    l.children = a;
  }
  if (e && e.defaultProps)
    for (r in ((s = e.defaultProps), s)) l[r] === void 0 && (l[r] = s[r]);
  return {
    $$typeof: cr,
    type: e,
    key: o,
    ref: i,
    props: l,
    _owner: ii.current,
  };
}
function ld(e, t) {
  return {
    $$typeof: cr,
    type: e.type,
    key: t,
    ref: e.ref,
    props: e.props,
    _owner: e._owner,
  };
}
function si(e) {
  return typeof e == "object" && e !== null && e.$$typeof === cr;
}
function od(e) {
  var t = { "=": "=0", ":": "=2" };
  return (
    "$" +
    e.replace(/[=:]/g, function (n) {
      return t[n];
    })
  );
}
var ns = /\/+/g;
function Ol(e, t) {
  return typeof e == "object" && e !== null && e.key != null
    ? od("" + e.key)
    : t.toString(36);
}
function Mr(e, t, n, r, l) {
  var o = typeof e;
  (o === "undefined" || o === "boolean") && (e = null);
  var i = !1;
  if (e === null) i = !0;
  else
    switch (o) {
      case "string":
      case "number":
        i = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case cr:
          case Gc:
            i = !0;
        }
    }
  if (i)
    return (
      (i = e),
      (l = l(i)),
      (e = r === "" ? "." + Ol(i, 0) : r),
      ts(l)
        ? ((n = ""),
          e != null && (n = e.replace(ns, "$&/") + "/"),
          Mr(l, t, n, "", function (c) {
            return c;
          }))
        : l != null &&
          (si(l) &&
            (l = ld(
              l,
              n +
                (!l.key || (i && i.key === l.key)
                  ? ""
                  : ("" + l.key).replace(ns, "$&/") + "/") +
                e,
            )),
          t.push(l)),
      1
    );
  if (((i = 0), (r = r === "" ? "." : r + ":"), ts(e)))
    for (var s = 0; s < e.length; s++) {
      o = e[s];
      var a = r + Ol(o, s);
      i += Mr(o, t, n, a, l);
    }
  else if (((a = rd(e)), typeof a == "function"))
    for (e = a.call(e), s = 0; !(o = e.next()).done; )
      ((o = o.value), (a = r + Ol(o, s++)), (i += Mr(o, t, n, a, l)));
  else if (o === "object")
    throw (
      (t = String(e)),
      Error(
        "Objects are not valid as a React child (found: " +
          (t === "[object Object]"
            ? "object with keys {" + Object.keys(e).join(", ") + "}"
            : t) +
          "). If you meant to render a collection of children, use an array instead.",
      )
    );
  return i;
}
function yr(e, t, n) {
  if (e == null) return e;
  var r = [],
    l = 0;
  return (
    Mr(e, r, "", "", function (o) {
      return t.call(n, o, l++);
    }),
    r
  );
}
function id(e) {
  if (e._status === -1) {
    var t = e._result;
    ((t = t()),
      t.then(
        function (n) {
          (e._status === 0 || e._status === -1) &&
            ((e._status = 1), (e._result = n));
        },
        function (n) {
          (e._status === 0 || e._status === -1) &&
            ((e._status = 2), (e._result = n));
        },
      ),
      e._status === -1 && ((e._status = 0), (e._result = t)));
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var fe = { current: null },
  Ar = { transition: null },
  sd = {
    ReactCurrentDispatcher: fe,
    ReactCurrentBatchConfig: Ar,
    ReactCurrentOwner: ii,
  };
function Pa() {
  throw Error("act(...) is not supported in production builds of React.");
}
b.Children = {
  map: yr,
  forEach: function (e, t, n) {
    yr(
      e,
      function () {
        t.apply(this, arguments);
      },
      n,
    );
  },
  count: function (e) {
    var t = 0;
    return (
      yr(e, function () {
        t++;
      }),
      t
    );
  },
  toArray: function (e) {
    return (
      yr(e, function (t) {
        return t;
      }) || []
    );
  },
  only: function (e) {
    if (!si(e))
      throw Error(
        "React.Children.only expected to receive a single React element child.",
      );
    return e;
  },
};
b.Component = wn;
b.Fragment = Kc;
b.Profiler = Yc;
b.PureComponent = li;
b.StrictMode = qc;
b.Suspense = ed;
b.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sd;
b.act = Pa;
b.cloneElement = function (e, t, n) {
  if (e == null)
    throw Error(
      "React.cloneElement(...): The argument must be a React element, but you passed " +
        e +
        ".",
    );
  var r = wa({}, e.props),
    l = e.key,
    o = e.ref,
    i = e._owner;
  if (t != null) {
    if (
      (t.ref !== void 0 && ((o = t.ref), (i = ii.current)),
      t.key !== void 0 && (l = "" + t.key),
      e.type && e.type.defaultProps)
    )
      var s = e.type.defaultProps;
    for (a in t)
      ka.call(t, a) &&
        !Ca.hasOwnProperty(a) &&
        (r[a] = t[a] === void 0 && s !== void 0 ? s[a] : t[a]);
  }
  var a = arguments.length - 2;
  if (a === 1) r.children = n;
  else if (1 < a) {
    s = Array(a);
    for (var c = 0; c < a; c++) s[c] = arguments[c + 2];
    r.children = s;
  }
  return { $$typeof: cr, type: e.type, key: l, ref: o, props: r, _owner: i };
};
b.createContext = function (e) {
  return (
    (e = {
      $$typeof: Zc,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null,
      _defaultValue: null,
      _globalName: null,
    }),
    (e.Provider = { $$typeof: Xc, _context: e }),
    (e.Consumer = e)
  );
};
b.createElement = Ea;
b.createFactory = function (e) {
  var t = Ea.bind(null, e);
  return ((t.type = e), t);
};
b.createRef = function () {
  return { current: null };
};
b.forwardRef = function (e) {
  return { $$typeof: Jc, render: e };
};
b.isValidElement = si;
b.lazy = function (e) {
  return { $$typeof: nd, _payload: { _status: -1, _result: e }, _init: id };
};
b.memo = function (e, t) {
  return { $$typeof: td, type: e, compare: t === void 0 ? null : t };
};
b.startTransition = function (e) {
  var t = Ar.transition;
  Ar.transition = {};
  try {
    e();
  } finally {
    Ar.transition = t;
  }
};
b.unstable_act = Pa;
b.useCallback = function (e, t) {
  return fe.current.useCallback(e, t);
};
b.useContext = function (e) {
  return fe.current.useContext(e);
};
b.useDebugValue = function () {};
b.useDeferredValue = function (e) {
  return fe.current.useDeferredValue(e);
};
b.useEffect = function (e, t) {
  return fe.current.useEffect(e, t);
};
b.useId = function () {
  return fe.current.useId();
};
b.useImperativeHandle = function (e, t, n) {
  return fe.current.useImperativeHandle(e, t, n);
};
b.useInsertionEffect = function (e, t) {
  return fe.current.useInsertionEffect(e, t);
};
b.useLayoutEffect = function (e, t) {
  return fe.current.useLayoutEffect(e, t);
};
b.useMemo = function (e, t) {
  return fe.current.useMemo(e, t);
};
b.useReducer = function (e, t, n) {
  return fe.current.useReducer(e, t, n);
};
b.useRef = function (e) {
  return fe.current.useRef(e);
};
b.useState = function (e) {
  return fe.current.useState(e);
};
b.useSyncExternalStore = function (e, t, n) {
  return fe.current.useSyncExternalStore(e, t, n);
};
b.useTransition = function () {
  return fe.current.useTransition();
};
b.version = "18.3.1";
va.exports = b;
var F = va.exports;
const ad = Qc(F),
  ud = Hc({ __proto__: null, default: ad }, [F]);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var cd = F,
  dd = Symbol.for("react.element"),
  fd = Symbol.for("react.fragment"),
  pd = Object.prototype.hasOwnProperty,
  md = cd.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  hd = { key: !0, ref: !0, __self: !0, __source: !0 };
function Na(e, t, n) {
  var r,
    l = {},
    o = null,
    i = null;
  (n !== void 0 && (o = "" + n),
    t.key !== void 0 && (o = "" + t.key),
    t.ref !== void 0 && (i = t.ref));
  for (r in t) pd.call(t, r) && !hd.hasOwnProperty(r) && (l[r] = t[r]);
  if (e && e.defaultProps)
    for (r in ((t = e.defaultProps), t)) l[r] === void 0 && (l[r] = t[r]);
  return {
    $$typeof: dd,
    type: e,
    key: o,
    ref: i,
    props: l,
    _owner: md.current,
  };
}
yl.Fragment = fd;
yl.jsx = Na;
yl.jsxs = Na;
ga.exports = yl;
var S = ga.exports,
  _a = { exports: {} },
  Ce = {},
  za = { exports: {} },
  Ta = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function (e) {
  function t(P, T) {
    var j = P.length;
    P.push(T);
    e: for (; 0 < j; ) {
      var M = (j - 1) >>> 1,
        J = P[M];
      if (0 < l(J, T)) ((P[M] = T), (P[j] = J), (j = M));
      else break e;
    }
  }
  function n(P) {
    return P.length === 0 ? null : P[0];
  }
  function r(P) {
    if (P.length === 0) return null;
    var T = P[0],
      j = P.pop();
    if (j !== T) {
      P[0] = j;
      e: for (var M = 0, J = P.length, gr = J >>> 1; M < gr; ) {
        var _t = 2 * (M + 1) - 1,
          Fl = P[_t],
          zt = _t + 1,
          vr = P[zt];
        if (0 > l(Fl, j))
          zt < J && 0 > l(vr, Fl)
            ? ((P[M] = vr), (P[zt] = j), (M = zt))
            : ((P[M] = Fl), (P[_t] = j), (M = _t));
        else if (zt < J && 0 > l(vr, j)) ((P[M] = vr), (P[zt] = j), (M = zt));
        else break e;
      }
    }
    return T;
  }
  function l(P, T) {
    var j = P.sortIndex - T.sortIndex;
    return j !== 0 ? j : P.id - T.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var o = performance;
    e.unstable_now = function () {
      return o.now();
    };
  } else {
    var i = Date,
      s = i.now();
    e.unstable_now = function () {
      return i.now() - s;
    };
  }
  var a = [],
    c = [],
    p = 1,
    h = null,
    m = 3,
    v = !1,
    w = !1,
    g = !1,
    E = typeof setTimeout == "function" ? setTimeout : null,
    d = typeof clearTimeout == "function" ? clearTimeout : null,
    u = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" &&
    navigator.scheduling !== void 0 &&
    navigator.scheduling.isInputPending !== void 0 &&
    navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function f(P) {
    for (var T = n(c); T !== null; ) {
      if (T.callback === null) r(c);
      else if (T.startTime <= P)
        (r(c), (T.sortIndex = T.expirationTime), t(a, T));
      else break;
      T = n(c);
    }
  }
  function y(P) {
    if (((g = !1), f(P), !w))
      if (n(a) !== null) ((w = !0), rt(C));
      else {
        var T = n(c);
        T !== null && Wt(y, T.startTime - P);
      }
  }
  function C(P, T) {
    ((w = !1), g && ((g = !1), d(z), (z = -1)), (v = !0));
    var j = m;
    try {
      for (
        f(T), h = n(a);
        h !== null && (!(h.expirationTime > T) || (P && !ue()));

      ) {
        var M = h.callback;
        if (typeof M == "function") {
          ((h.callback = null), (m = h.priorityLevel));
          var J = M(h.expirationTime <= T);
          ((T = e.unstable_now()),
            typeof J == "function" ? (h.callback = J) : h === n(a) && r(a),
            f(T));
        } else r(a);
        h = n(a);
      }
      if (h !== null) var gr = !0;
      else {
        var _t = n(c);
        (_t !== null && Wt(y, _t.startTime - T), (gr = !1));
      }
      return gr;
    } finally {
      ((h = null), (m = j), (v = !1));
    }
  }
  var k = !1,
    N = null,
    z = -1,
    $ = 5,
    R = -1;
  function ue() {
    return !(e.unstable_now() - R < $);
  }
  function A() {
    if (N !== null) {
      var P = e.unstable_now();
      R = P;
      var T = !0;
      try {
        T = N(!0, P);
      } finally {
        T ? nt() : ((k = !1), (N = null));
      }
    } else k = !1;
  }
  var nt;
  if (typeof u == "function")
    nt = function () {
      u(A);
    };
  else if (typeof MessageChannel < "u") {
    var Nt = new MessageChannel(),
      hr = Nt.port2;
    ((Nt.port1.onmessage = A),
      (nt = function () {
        hr.postMessage(null);
      }));
  } else
    nt = function () {
      E(A, 0);
    };
  function rt(P) {
    ((N = P), k || ((k = !0), nt()));
  }
  function Wt(P, T) {
    z = E(function () {
      P(e.unstable_now());
    }, T);
  }
  ((e.unstable_IdlePriority = 5),
    (e.unstable_ImmediatePriority = 1),
    (e.unstable_LowPriority = 4),
    (e.unstable_NormalPriority = 3),
    (e.unstable_Profiling = null),
    (e.unstable_UserBlockingPriority = 2),
    (e.unstable_cancelCallback = function (P) {
      P.callback = null;
    }),
    (e.unstable_continueExecution = function () {
      w || v || ((w = !0), rt(C));
    }),
    (e.unstable_forceFrameRate = function (P) {
      0 > P || 125 < P
        ? console.error(
            "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
          )
        : ($ = 0 < P ? Math.floor(1e3 / P) : 5);
    }),
    (e.unstable_getCurrentPriorityLevel = function () {
      return m;
    }),
    (e.unstable_getFirstCallbackNode = function () {
      return n(a);
    }),
    (e.unstable_next = function (P) {
      switch (m) {
        case 1:
        case 2:
        case 3:
          var T = 3;
          break;
        default:
          T = m;
      }
      var j = m;
      m = T;
      try {
        return P();
      } finally {
        m = j;
      }
    }),
    (e.unstable_pauseExecution = function () {}),
    (e.unstable_requestPaint = function () {}),
    (e.unstable_runWithPriority = function (P, T) {
      switch (P) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          P = 3;
      }
      var j = m;
      m = P;
      try {
        return T();
      } finally {
        m = j;
      }
    }),
    (e.unstable_scheduleCallback = function (P, T, j) {
      var M = e.unstable_now();
      switch (
        (typeof j == "object" && j !== null
          ? ((j = j.delay), (j = typeof j == "number" && 0 < j ? M + j : M))
          : (j = M),
        P)
      ) {
        case 1:
          var J = -1;
          break;
        case 2:
          J = 250;
          break;
        case 5:
          J = 1073741823;
          break;
        case 4:
          J = 1e4;
          break;
        default:
          J = 5e3;
      }
      return (
        (J = j + J),
        (P = {
          id: p++,
          callback: T,
          priorityLevel: P,
          startTime: j,
          expirationTime: J,
          sortIndex: -1,
        }),
        j > M
          ? ((P.sortIndex = j),
            t(c, P),
            n(a) === null &&
              P === n(c) &&
              (g ? (d(z), (z = -1)) : (g = !0), Wt(y, j - M)))
          : ((P.sortIndex = J), t(a, P), w || v || ((w = !0), rt(C))),
        P
      );
    }),
    (e.unstable_shouldYield = ue),
    (e.unstable_wrapCallback = function (P) {
      var T = m;
      return function () {
        var j = m;
        m = T;
        try {
          return P.apply(this, arguments);
        } finally {
          m = j;
        }
      };
    }));
})(Ta);
za.exports = Ta;
var gd = za.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var vd = F,
  ke = gd;
function x(e) {
  for (
    var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1;
    n < arguments.length;
    n++
  )
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return (
    "Minified React error #" +
    e +
    "; visit " +
    t +
    " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
  );
}
var ja = new Set(),
  Gn = {};
function Bt(e, t) {
  (fn(e, t), fn(e + "Capture", t));
}
function fn(e, t) {
  for (Gn[e] = t, e = 0; e < t.length; e++) ja.add(t[e]);
}
var Xe = !(
    typeof window > "u" ||
    typeof window.document > "u" ||
    typeof window.document.createElement > "u"
  ),
  ao = Object.prototype.hasOwnProperty,
  yd =
    /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  rs = {},
  ls = {};
function wd(e) {
  return ao.call(ls, e)
    ? !0
    : ao.call(rs, e)
      ? !1
      : yd.test(e)
        ? (ls[e] = !0)
        : ((rs[e] = !0), !1);
}
function xd(e, t, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r
        ? !1
        : n !== null
          ? !n.acceptsBooleans
          : ((e = e.toLowerCase().slice(0, 5)), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function Sd(e, t, n, r) {
  if (t === null || typeof t > "u" || xd(e, t, n, r)) return !0;
  if (r) return !1;
  if (n !== null)
    switch (n.type) {
      case 3:
        return !t;
      case 4:
        return t === !1;
      case 5:
        return isNaN(t);
      case 6:
        return isNaN(t) || 1 > t;
    }
  return !1;
}
function pe(e, t, n, r, l, o, i) {
  ((this.acceptsBooleans = t === 2 || t === 3 || t === 4),
    (this.attributeName = r),
    (this.attributeNamespace = l),
    (this.mustUseProperty = n),
    (this.propertyName = e),
    (this.type = t),
    (this.sanitizeURL = o),
    (this.removeEmptyString = i));
}
var le = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
  .split(" ")
  .forEach(function (e) {
    le[e] = new pe(e, 0, !1, e, null, !1, !1);
  });
[
  ["acceptCharset", "accept-charset"],
  ["className", "class"],
  ["htmlFor", "for"],
  ["httpEquiv", "http-equiv"],
].forEach(function (e) {
  var t = e[0];
  le[t] = new pe(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
  le[e] = new pe(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
[
  "autoReverse",
  "externalResourcesRequired",
  "focusable",
  "preserveAlpha",
].forEach(function (e) {
  le[e] = new pe(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
  .split(" ")
  .forEach(function (e) {
    le[e] = new pe(e, 3, !1, e.toLowerCase(), null, !1, !1);
  });
["checked", "multiple", "muted", "selected"].forEach(function (e) {
  le[e] = new pe(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function (e) {
  le[e] = new pe(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (e) {
  le[e] = new pe(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function (e) {
  le[e] = new pe(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var ai = /[\-:]([a-z])/g;
function ui(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
  .split(" ")
  .forEach(function (e) {
    var t = e.replace(ai, ui);
    le[t] = new pe(t, 1, !1, e, null, !1, !1);
  });
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
  .split(" ")
  .forEach(function (e) {
    var t = e.replace(ai, ui);
    le[t] = new pe(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
  });
["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
  var t = e.replace(ai, ui);
  le[t] = new pe(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (e) {
  le[e] = new pe(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
le.xlinkHref = new pe(
  "xlinkHref",
  1,
  !1,
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  !0,
  !1,
);
["src", "href", "action", "formAction"].forEach(function (e) {
  le[e] = new pe(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function ci(e, t, n, r) {
  var l = le.hasOwnProperty(t) ? le[t] : null;
  (l !== null
    ? l.type !== 0
    : r ||
      !(2 < t.length) ||
      (t[0] !== "o" && t[0] !== "O") ||
      (t[1] !== "n" && t[1] !== "N")) &&
    (Sd(t, n, l, r) && (n = null),
    r || l === null
      ? wd(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n))
      : l.mustUseProperty
        ? (e[l.propertyName] = n === null ? (l.type === 3 ? !1 : "") : n)
        : ((t = l.attributeName),
          (r = l.attributeNamespace),
          n === null
            ? e.removeAttribute(t)
            : ((l = l.type),
              (n = l === 3 || (l === 4 && n === !0) ? "" : "" + n),
              r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var tt = vd.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  wr = Symbol.for("react.element"),
  Qt = Symbol.for("react.portal"),
  Gt = Symbol.for("react.fragment"),
  di = Symbol.for("react.strict_mode"),
  uo = Symbol.for("react.profiler"),
  La = Symbol.for("react.provider"),
  Ra = Symbol.for("react.context"),
  fi = Symbol.for("react.forward_ref"),
  co = Symbol.for("react.suspense"),
  fo = Symbol.for("react.suspense_list"),
  pi = Symbol.for("react.memo"),
  st = Symbol.for("react.lazy"),
  ba = Symbol.for("react.offscreen"),
  os = Symbol.iterator;
function Cn(e) {
  return e === null || typeof e != "object"
    ? null
    : ((e = (os && e[os]) || e["@@iterator"]),
      typeof e == "function" ? e : null);
}
var G = Object.assign,
  Ml;
function bn(e) {
  if (Ml === void 0)
    try {
      throw Error();
    } catch (n) {
      var t = n.stack.trim().match(/\n( *(at )?)/);
      Ml = (t && t[1]) || "";
    }
  return (
    `
` +
    Ml +
    e
  );
}
var Al = !1;
function Dl(e, t) {
  if (!e || Al) return "";
  Al = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t)
      if (
        ((t = function () {
          throw Error();
        }),
        Object.defineProperty(t.prototype, "props", {
          set: function () {
            throw Error();
          },
        }),
        typeof Reflect == "object" && Reflect.construct)
      ) {
        try {
          Reflect.construct(t, []);
        } catch (c) {
          var r = c;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (c) {
          r = c;
        }
        e.call(t.prototype);
      }
    else {
      try {
        throw Error();
      } catch (c) {
        r = c;
      }
      e();
    }
  } catch (c) {
    if (c && r && typeof c.stack == "string") {
      for (
        var l = c.stack.split(`
`),
          o = r.stack.split(`
`),
          i = l.length - 1,
          s = o.length - 1;
        1 <= i && 0 <= s && l[i] !== o[s];

      )
        s--;
      for (; 1 <= i && 0 <= s; i--, s--)
        if (l[i] !== o[s]) {
          if (i !== 1 || s !== 1)
            do
              if ((i--, s--, 0 > s || l[i] !== o[s])) {
                var a =
                  `
` + l[i].replace(" at new ", " at ");
                return (
                  e.displayName &&
                    a.includes("<anonymous>") &&
                    (a = a.replace("<anonymous>", e.displayName)),
                  a
                );
              }
            while (1 <= i && 0 <= s);
          break;
        }
    }
  } finally {
    ((Al = !1), (Error.prepareStackTrace = n));
  }
  return (e = e ? e.displayName || e.name : "") ? bn(e) : "";
}
function kd(e) {
  switch (e.tag) {
    case 5:
      return bn(e.type);
    case 16:
      return bn("Lazy");
    case 13:
      return bn("Suspense");
    case 19:
      return bn("SuspenseList");
    case 0:
    case 2:
    case 15:
      return ((e = Dl(e.type, !1)), e);
    case 11:
      return ((e = Dl(e.type.render, !1)), e);
    case 1:
      return ((e = Dl(e.type, !0)), e);
    default:
      return "";
  }
}
function po(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case Gt:
      return "Fragment";
    case Qt:
      return "Portal";
    case uo:
      return "Profiler";
    case di:
      return "StrictMode";
    case co:
      return "Suspense";
    case fo:
      return "SuspenseList";
  }
  if (typeof e == "object")
    switch (e.$$typeof) {
      case Ra:
        return (e.displayName || "Context") + ".Consumer";
      case La:
        return (e._context.displayName || "Context") + ".Provider";
      case fi:
        var t = e.render;
        return (
          (e = e.displayName),
          e ||
            ((e = t.displayName || t.name || ""),
            (e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef")),
          e
        );
      case pi:
        return (
          (t = e.displayName || null),
          t !== null ? t : po(e.type) || "Memo"
        );
      case st:
        ((t = e._payload), (e = e._init));
        try {
          return po(e(t));
        } catch {}
    }
  return null;
}
function Cd(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return (
        (e = t.render),
        (e = e.displayName || e.name || ""),
        t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef")
      );
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return po(t);
    case 8:
      return t === di ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function St(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function Fa(e) {
  var t = e.type;
  return (
    (e = e.nodeName) &&
    e.toLowerCase() === "input" &&
    (t === "checkbox" || t === "radio")
  );
}
function Ed(e) {
  var t = Fa(e) ? "checked" : "value",
    n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
    r = "" + e[t];
  if (
    !e.hasOwnProperty(t) &&
    typeof n < "u" &&
    typeof n.get == "function" &&
    typeof n.set == "function"
  ) {
    var l = n.get,
      o = n.set;
    return (
      Object.defineProperty(e, t, {
        configurable: !0,
        get: function () {
          return l.call(this);
        },
        set: function (i) {
          ((r = "" + i), o.call(this, i));
        },
      }),
      Object.defineProperty(e, t, { enumerable: n.enumerable }),
      {
        getValue: function () {
          return r;
        },
        setValue: function (i) {
          r = "" + i;
        },
        stopTracking: function () {
          ((e._valueTracker = null), delete e[t]);
        },
      }
    );
  }
}
function xr(e) {
  e._valueTracker || (e._valueTracker = Ed(e));
}
function Oa(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(),
    r = "";
  return (
    e && (r = Fa(e) ? (e.checked ? "true" : "false") : e.value),
    (e = r),
    e !== n ? (t.setValue(e), !0) : !1
  );
}
function Kr(e) {
  if (((e = e || (typeof document < "u" ? document : void 0)), typeof e > "u"))
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function mo(e, t) {
  var n = t.checked;
  return G({}, t, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: n ?? e._wrapperState.initialChecked,
  });
}
function is(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue,
    r = t.checked != null ? t.checked : t.defaultChecked;
  ((n = St(t.value != null ? t.value : n)),
    (e._wrapperState = {
      initialChecked: r,
      initialValue: n,
      controlled:
        t.type === "checkbox" || t.type === "radio"
          ? t.checked != null
          : t.value != null,
    }));
}
function Ma(e, t) {
  ((t = t.checked), t != null && ci(e, "checked", t, !1));
}
function ho(e, t) {
  Ma(e, t);
  var n = St(t.value),
    r = t.type;
  if (n != null)
    r === "number"
      ? ((n === 0 && e.value === "") || e.value != n) && (e.value = "" + n)
      : e.value !== "" + n && (e.value = "" + n);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  (t.hasOwnProperty("value")
    ? go(e, t.type, n)
    : t.hasOwnProperty("defaultValue") && go(e, t.type, St(t.defaultValue)),
    t.checked == null &&
      t.defaultChecked != null &&
      (e.defaultChecked = !!t.defaultChecked));
}
function ss(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (
      !(
        (r !== "submit" && r !== "reset") ||
        (t.value !== void 0 && t.value !== null)
      )
    )
      return;
    ((t = "" + e._wrapperState.initialValue),
      n || t === e.value || (e.value = t),
      (e.defaultValue = t));
  }
  ((n = e.name),
    n !== "" && (e.name = ""),
    (e.defaultChecked = !!e._wrapperState.initialChecked),
    n !== "" && (e.name = n));
}
function go(e, t, n) {
  (t !== "number" || Kr(e.ownerDocument) !== e) &&
    (n == null
      ? (e.defaultValue = "" + e._wrapperState.initialValue)
      : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var Fn = Array.isArray;
function ln(e, t, n, r) {
  if (((e = e.options), t)) {
    t = {};
    for (var l = 0; l < n.length; l++) t["$" + n[l]] = !0;
    for (n = 0; n < e.length; n++)
      ((l = t.hasOwnProperty("$" + e[n].value)),
        e[n].selected !== l && (e[n].selected = l),
        l && r && (e[n].defaultSelected = !0));
  } else {
    for (n = "" + St(n), t = null, l = 0; l < e.length; l++) {
      if (e[l].value === n) {
        ((e[l].selected = !0), r && (e[l].defaultSelected = !0));
        return;
      }
      t !== null || e[l].disabled || (t = e[l]);
    }
    t !== null && (t.selected = !0);
  }
}
function vo(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(x(91));
  return G({}, t, {
    value: void 0,
    defaultValue: void 0,
    children: "" + e._wrapperState.initialValue,
  });
}
function as(e, t) {
  var n = t.value;
  if (n == null) {
    if (((n = t.children), (t = t.defaultValue), n != null)) {
      if (t != null) throw Error(x(92));
      if (Fn(n)) {
        if (1 < n.length) throw Error(x(93));
        n = n[0];
      }
      t = n;
    }
    (t == null && (t = ""), (n = t));
  }
  e._wrapperState = { initialValue: St(n) };
}
function Aa(e, t) {
  var n = St(t.value),
    r = St(t.defaultValue);
  (n != null &&
    ((n = "" + n),
    n !== e.value && (e.value = n),
    t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)),
    r != null && (e.defaultValue = "" + r));
}
function us(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function Da(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function yo(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml"
    ? Da(t)
    : e === "http://www.w3.org/2000/svg" && t === "foreignObject"
      ? "http://www.w3.org/1999/xhtml"
      : e;
}
var Sr,
  Ia = (function (e) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction
      ? function (t, n, r, l) {
          MSApp.execUnsafeLocalFunction(function () {
            return e(t, n, r, l);
          });
        }
      : e;
  })(function (e, t) {
    if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e)
      e.innerHTML = t;
    else {
      for (
        Sr = Sr || document.createElement("div"),
          Sr.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>",
          t = Sr.firstChild;
        e.firstChild;

      )
        e.removeChild(e.firstChild);
      for (; t.firstChild; ) e.appendChild(t.firstChild);
    }
  });
function Kn(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var An = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0,
  },
  Pd = ["Webkit", "ms", "Moz", "O"];
Object.keys(An).forEach(function (e) {
  Pd.forEach(function (t) {
    ((t = t + e.charAt(0).toUpperCase() + e.substring(1)), (An[t] = An[e]));
  });
});
function $a(e, t, n) {
  return t == null || typeof t == "boolean" || t === ""
    ? ""
    : n || typeof t != "number" || t === 0 || (An.hasOwnProperty(e) && An[e])
      ? ("" + t).trim()
      : t + "px";
}
function Ba(e, t) {
  e = e.style;
  for (var n in t)
    if (t.hasOwnProperty(n)) {
      var r = n.indexOf("--") === 0,
        l = $a(n, t[n], r);
      (n === "float" && (n = "cssFloat"), r ? e.setProperty(n, l) : (e[n] = l));
    }
}
var Nd = G(
  { menuitem: !0 },
  {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0,
  },
);
function wo(e, t) {
  if (t) {
    if (Nd[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
      throw Error(x(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(x(60));
      if (
        typeof t.dangerouslySetInnerHTML != "object" ||
        !("__html" in t.dangerouslySetInnerHTML)
      )
        throw Error(x(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(x(62));
  }
}
function xo(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var So = null;
function mi(e) {
  return (
    (e = e.target || e.srcElement || window),
    e.correspondingUseElement && (e = e.correspondingUseElement),
    e.nodeType === 3 ? e.parentNode : e
  );
}
var ko = null,
  on = null,
  sn = null;
function cs(e) {
  if ((e = pr(e))) {
    if (typeof ko != "function") throw Error(x(280));
    var t = e.stateNode;
    t && ((t = Cl(t)), ko(e.stateNode, e.type, t));
  }
}
function Va(e) {
  on ? (sn ? sn.push(e) : (sn = [e])) : (on = e);
}
function Ua() {
  if (on) {
    var e = on,
      t = sn;
    if (((sn = on = null), cs(e), t)) for (e = 0; e < t.length; e++) cs(t[e]);
  }
}
function Wa(e, t) {
  return e(t);
}
function Ha() {}
var Il = !1;
function Qa(e, t, n) {
  if (Il) return e(t, n);
  Il = !0;
  try {
    return Wa(e, t, n);
  } finally {
    ((Il = !1), (on !== null || sn !== null) && (Ha(), Ua()));
  }
}
function qn(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var r = Cl(n);
  if (r === null) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      ((r = !r.disabled) ||
        ((e = e.type),
        (r = !(
          e === "button" ||
          e === "input" ||
          e === "select" ||
          e === "textarea"
        ))),
        (e = !r));
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != "function") throw Error(x(231, t, typeof n));
  return n;
}
var Co = !1;
if (Xe)
  try {
    var En = {};
    (Object.defineProperty(En, "passive", {
      get: function () {
        Co = !0;
      },
    }),
      window.addEventListener("test", En, En),
      window.removeEventListener("test", En, En));
  } catch {
    Co = !1;
  }
function _d(e, t, n, r, l, o, i, s, a) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (p) {
    this.onError(p);
  }
}
var Dn = !1,
  qr = null,
  Yr = !1,
  Eo = null,
  zd = {
    onError: function (e) {
      ((Dn = !0), (qr = e));
    },
  };
function Td(e, t, n, r, l, o, i, s, a) {
  ((Dn = !1), (qr = null), _d.apply(zd, arguments));
}
function jd(e, t, n, r, l, o, i, s, a) {
  if ((Td.apply(this, arguments), Dn)) {
    if (Dn) {
      var c = qr;
      ((Dn = !1), (qr = null));
    } else throw Error(x(198));
    Yr || ((Yr = !0), (Eo = c));
  }
}
function Vt(e) {
  var t = e,
    n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do ((t = e), t.flags & 4098 && (n = t.return), (e = t.return));
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function Ga(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (
      (t === null && ((e = e.alternate), e !== null && (t = e.memoizedState)),
      t !== null)
    )
      return t.dehydrated;
  }
  return null;
}
function ds(e) {
  if (Vt(e) !== e) throw Error(x(188));
}
function Ld(e) {
  var t = e.alternate;
  if (!t) {
    if (((t = Vt(e)), t === null)) throw Error(x(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t; ; ) {
    var l = n.return;
    if (l === null) break;
    var o = l.alternate;
    if (o === null) {
      if (((r = l.return), r !== null)) {
        n = r;
        continue;
      }
      break;
    }
    if (l.child === o.child) {
      for (o = l.child; o; ) {
        if (o === n) return (ds(l), e);
        if (o === r) return (ds(l), t);
        o = o.sibling;
      }
      throw Error(x(188));
    }
    if (n.return !== r.return) ((n = l), (r = o));
    else {
      for (var i = !1, s = l.child; s; ) {
        if (s === n) {
          ((i = !0), (n = l), (r = o));
          break;
        }
        if (s === r) {
          ((i = !0), (r = l), (n = o));
          break;
        }
        s = s.sibling;
      }
      if (!i) {
        for (s = o.child; s; ) {
          if (s === n) {
            ((i = !0), (n = o), (r = l));
            break;
          }
          if (s === r) {
            ((i = !0), (r = o), (n = l));
            break;
          }
          s = s.sibling;
        }
        if (!i) throw Error(x(189));
      }
    }
    if (n.alternate !== r) throw Error(x(190));
  }
  if (n.tag !== 3) throw Error(x(188));
  return n.stateNode.current === n ? e : t;
}
function Ka(e) {
  return ((e = Ld(e)), e !== null ? qa(e) : null);
}
function qa(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = qa(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var Ya = ke.unstable_scheduleCallback,
  fs = ke.unstable_cancelCallback,
  Rd = ke.unstable_shouldYield,
  bd = ke.unstable_requestPaint,
  q = ke.unstable_now,
  Fd = ke.unstable_getCurrentPriorityLevel,
  hi = ke.unstable_ImmediatePriority,
  Xa = ke.unstable_UserBlockingPriority,
  Xr = ke.unstable_NormalPriority,
  Od = ke.unstable_LowPriority,
  Za = ke.unstable_IdlePriority,
  wl = null,
  Ue = null;
function Md(e) {
  if (Ue && typeof Ue.onCommitFiberRoot == "function")
    try {
      Ue.onCommitFiberRoot(wl, e, void 0, (e.current.flags & 128) === 128);
    } catch {}
}
var Me = Math.clz32 ? Math.clz32 : Id,
  Ad = Math.log,
  Dd = Math.LN2;
function Id(e) {
  return ((e >>>= 0), e === 0 ? 32 : (31 - ((Ad(e) / Dd) | 0)) | 0);
}
var kr = 64,
  Cr = 4194304;
function On(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function Zr(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var r = 0,
    l = e.suspendedLanes,
    o = e.pingedLanes,
    i = n & 268435455;
  if (i !== 0) {
    var s = i & ~l;
    s !== 0 ? (r = On(s)) : ((o &= i), o !== 0 && (r = On(o)));
  } else ((i = n & ~l), i !== 0 ? (r = On(i)) : o !== 0 && (r = On(o)));
  if (r === 0) return 0;
  if (
    t !== 0 &&
    t !== r &&
    !(t & l) &&
    ((l = r & -r), (o = t & -t), l >= o || (l === 16 && (o & 4194240) !== 0))
  )
    return t;
  if ((r & 4 && (r |= n & 16), (t = e.entangledLanes), t !== 0))
    for (e = e.entanglements, t &= r; 0 < t; )
      ((n = 31 - Me(t)), (l = 1 << n), (r |= e[n]), (t &= ~l));
  return r;
}
function $d(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function Bd(e, t) {
  for (
    var n = e.suspendedLanes,
      r = e.pingedLanes,
      l = e.expirationTimes,
      o = e.pendingLanes;
    0 < o;

  ) {
    var i = 31 - Me(o),
      s = 1 << i,
      a = l[i];
    (a === -1
      ? (!(s & n) || s & r) && (l[i] = $d(s, t))
      : a <= t && (e.expiredLanes |= s),
      (o &= ~s));
  }
}
function Po(e) {
  return (
    (e = e.pendingLanes & -1073741825),
    e !== 0 ? e : e & 1073741824 ? 1073741824 : 0
  );
}
function Ja() {
  var e = kr;
  return ((kr <<= 1), !(kr & 4194240) && (kr = 64), e);
}
function $l(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function dr(e, t, n) {
  ((e.pendingLanes |= t),
    t !== 536870912 && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
    (e = e.eventTimes),
    (t = 31 - Me(t)),
    (e[t] = n));
}
function Vd(e, t) {
  var n = e.pendingLanes & ~t;
  ((e.pendingLanes = t),
    (e.suspendedLanes = 0),
    (e.pingedLanes = 0),
    (e.expiredLanes &= t),
    (e.mutableReadLanes &= t),
    (e.entangledLanes &= t),
    (t = e.entanglements));
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var l = 31 - Me(n),
      o = 1 << l;
    ((t[l] = 0), (r[l] = -1), (e[l] = -1), (n &= ~o));
  }
}
function gi(e, t) {
  var n = (e.entangledLanes |= t);
  for (e = e.entanglements; n; ) {
    var r = 31 - Me(n),
      l = 1 << r;
    ((l & t) | (e[r] & t) && (e[r] |= t), (n &= ~l));
  }
}
var D = 0;
function eu(e) {
  return (
    (e &= -e),
    1 < e ? (4 < e ? (e & 268435455 ? 16 : 536870912) : 4) : 1
  );
}
var tu,
  vi,
  nu,
  ru,
  lu,
  No = !1,
  Er = [],
  pt = null,
  mt = null,
  ht = null,
  Yn = new Map(),
  Xn = new Map(),
  ut = [],
  Ud =
    "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
      " ",
    );
function ps(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      pt = null;
      break;
    case "dragenter":
    case "dragleave":
      mt = null;
      break;
    case "mouseover":
    case "mouseout":
      ht = null;
      break;
    case "pointerover":
    case "pointerout":
      Yn.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Xn.delete(t.pointerId);
  }
}
function Pn(e, t, n, r, l, o) {
  return e === null || e.nativeEvent !== o
    ? ((e = {
        blockedOn: t,
        domEventName: n,
        eventSystemFlags: r,
        nativeEvent: o,
        targetContainers: [l],
      }),
      t !== null && ((t = pr(t)), t !== null && vi(t)),
      e)
    : ((e.eventSystemFlags |= r),
      (t = e.targetContainers),
      l !== null && t.indexOf(l) === -1 && t.push(l),
      e);
}
function Wd(e, t, n, r, l) {
  switch (t) {
    case "focusin":
      return ((pt = Pn(pt, e, t, n, r, l)), !0);
    case "dragenter":
      return ((mt = Pn(mt, e, t, n, r, l)), !0);
    case "mouseover":
      return ((ht = Pn(ht, e, t, n, r, l)), !0);
    case "pointerover":
      var o = l.pointerId;
      return (Yn.set(o, Pn(Yn.get(o) || null, e, t, n, r, l)), !0);
    case "gotpointercapture":
      return (
        (o = l.pointerId),
        Xn.set(o, Pn(Xn.get(o) || null, e, t, n, r, l)),
        !0
      );
  }
  return !1;
}
function ou(e) {
  var t = Lt(e.target);
  if (t !== null) {
    var n = Vt(t);
    if (n !== null) {
      if (((t = n.tag), t === 13)) {
        if (((t = Ga(n)), t !== null)) {
          ((e.blockedOn = t),
            lu(e.priority, function () {
              nu(n);
            }));
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function Dr(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = _o(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      ((So = r), n.target.dispatchEvent(r), (So = null));
    } else return ((t = pr(n)), t !== null && vi(t), (e.blockedOn = n), !1);
    t.shift();
  }
  return !0;
}
function ms(e, t, n) {
  Dr(e) && n.delete(t);
}
function Hd() {
  ((No = !1),
    pt !== null && Dr(pt) && (pt = null),
    mt !== null && Dr(mt) && (mt = null),
    ht !== null && Dr(ht) && (ht = null),
    Yn.forEach(ms),
    Xn.forEach(ms));
}
function Nn(e, t) {
  e.blockedOn === t &&
    ((e.blockedOn = null),
    No ||
      ((No = !0),
      ke.unstable_scheduleCallback(ke.unstable_NormalPriority, Hd)));
}
function Zn(e) {
  function t(l) {
    return Nn(l, e);
  }
  if (0 < Er.length) {
    Nn(Er[0], e);
    for (var n = 1; n < Er.length; n++) {
      var r = Er[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (
    pt !== null && Nn(pt, e),
      mt !== null && Nn(mt, e),
      ht !== null && Nn(ht, e),
      Yn.forEach(t),
      Xn.forEach(t),
      n = 0;
    n < ut.length;
    n++
  )
    ((r = ut[n]), r.blockedOn === e && (r.blockedOn = null));
  for (; 0 < ut.length && ((n = ut[0]), n.blockedOn === null); )
    (ou(n), n.blockedOn === null && ut.shift());
}
var an = tt.ReactCurrentBatchConfig,
  Jr = !0;
function Qd(e, t, n, r) {
  var l = D,
    o = an.transition;
  an.transition = null;
  try {
    ((D = 1), yi(e, t, n, r));
  } finally {
    ((D = l), (an.transition = o));
  }
}
function Gd(e, t, n, r) {
  var l = D,
    o = an.transition;
  an.transition = null;
  try {
    ((D = 4), yi(e, t, n, r));
  } finally {
    ((D = l), (an.transition = o));
  }
}
function yi(e, t, n, r) {
  if (Jr) {
    var l = _o(e, t, n, r);
    if (l === null) (Yl(e, t, r, el, n), ps(e, r));
    else if (Wd(l, e, t, n, r)) r.stopPropagation();
    else if ((ps(e, r), t & 4 && -1 < Ud.indexOf(e))) {
      for (; l !== null; ) {
        var o = pr(l);
        if (
          (o !== null && tu(o),
          (o = _o(e, t, n, r)),
          o === null && Yl(e, t, r, el, n),
          o === l)
        )
          break;
        l = o;
      }
      l !== null && r.stopPropagation();
    } else Yl(e, t, r, null, n);
  }
}
var el = null;
function _o(e, t, n, r) {
  if (((el = null), (e = mi(r)), (e = Lt(e)), e !== null))
    if (((t = Vt(e)), t === null)) e = null;
    else if (((n = t.tag), n === 13)) {
      if (((e = Ga(t)), e !== null)) return e;
      e = null;
    } else if (n === 3) {
      if (t.stateNode.current.memoizedState.isDehydrated)
        return t.tag === 3 ? t.stateNode.containerInfo : null;
      e = null;
    } else t !== e && (e = null);
  return ((el = e), null);
}
function iu(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (Fd()) {
        case hi:
          return 1;
        case Xa:
          return 4;
        case Xr:
        case Od:
          return 16;
        case Za:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var dt = null,
  wi = null,
  Ir = null;
function su() {
  if (Ir) return Ir;
  var e,
    t = wi,
    n = t.length,
    r,
    l = "value" in dt ? dt.value : dt.textContent,
    o = l.length;
  for (e = 0; e < n && t[e] === l[e]; e++);
  var i = n - e;
  for (r = 1; r <= i && t[n - r] === l[o - r]; r++);
  return (Ir = l.slice(e, 1 < r ? 1 - r : void 0));
}
function $r(e) {
  var t = e.keyCode;
  return (
    "charCode" in e
      ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
      : (e = t),
    e === 10 && (e = 13),
    32 <= e || e === 13 ? e : 0
  );
}
function Pr() {
  return !0;
}
function hs() {
  return !1;
}
function Ee(e) {
  function t(n, r, l, o, i) {
    ((this._reactName = n),
      (this._targetInst = l),
      (this.type = r),
      (this.nativeEvent = o),
      (this.target = i),
      (this.currentTarget = null));
    for (var s in e)
      e.hasOwnProperty(s) && ((n = e[s]), (this[s] = n ? n(o) : o[s]));
    return (
      (this.isDefaultPrevented = (
        o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1
      )
        ? Pr
        : hs),
      (this.isPropagationStopped = hs),
      this
    );
  }
  return (
    G(t.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n &&
          (n.preventDefault
            ? n.preventDefault()
            : typeof n.returnValue != "unknown" && (n.returnValue = !1),
          (this.isDefaultPrevented = Pr));
      },
      stopPropagation: function () {
        var n = this.nativeEvent;
        n &&
          (n.stopPropagation
            ? n.stopPropagation()
            : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0),
          (this.isPropagationStopped = Pr));
      },
      persist: function () {},
      isPersistent: Pr,
    }),
    t
  );
}
var xn = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0,
  },
  xi = Ee(xn),
  fr = G({}, xn, { view: 0, detail: 0 }),
  Kd = Ee(fr),
  Bl,
  Vl,
  _n,
  xl = G({}, fr, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Si,
    button: 0,
    buttons: 0,
    relatedTarget: function (e) {
      return e.relatedTarget === void 0
        ? e.fromElement === e.srcElement
          ? e.toElement
          : e.fromElement
        : e.relatedTarget;
    },
    movementX: function (e) {
      return "movementX" in e
        ? e.movementX
        : (e !== _n &&
            (_n && e.type === "mousemove"
              ? ((Bl = e.screenX - _n.screenX), (Vl = e.screenY - _n.screenY))
              : (Vl = Bl = 0),
            (_n = e)),
          Bl);
    },
    movementY: function (e) {
      return "movementY" in e ? e.movementY : Vl;
    },
  }),
  gs = Ee(xl),
  qd = G({}, xl, { dataTransfer: 0 }),
  Yd = Ee(qd),
  Xd = G({}, fr, { relatedTarget: 0 }),
  Ul = Ee(Xd),
  Zd = G({}, xn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
  Jd = Ee(Zd),
  ef = G({}, xn, {
    clipboardData: function (e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    },
  }),
  tf = Ee(ef),
  nf = G({}, xn, { data: 0 }),
  vs = Ee(nf),
  rf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified",
  },
  lf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta",
  },
  of = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey",
  };
function sf(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = of[e]) ? !!t[e] : !1;
}
function Si() {
  return sf;
}
var af = G({}, fr, {
    key: function (e) {
      if (e.key) {
        var t = rf[e.key] || e.key;
        if (t !== "Unidentified") return t;
      }
      return e.type === "keypress"
        ? ((e = $r(e)), e === 13 ? "Enter" : String.fromCharCode(e))
        : e.type === "keydown" || e.type === "keyup"
          ? lf[e.keyCode] || "Unidentified"
          : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Si,
    charCode: function (e) {
      return e.type === "keypress" ? $r(e) : 0;
    },
    keyCode: function (e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function (e) {
      return e.type === "keypress"
        ? $r(e)
        : e.type === "keydown" || e.type === "keyup"
          ? e.keyCode
          : 0;
    },
  }),
  uf = Ee(af),
  cf = G({}, xl, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0,
  }),
  ys = Ee(cf),
  df = G({}, fr, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Si,
  }),
  ff = Ee(df),
  pf = G({}, xn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
  mf = Ee(pf),
  hf = G({}, xl, {
    deltaX: function (e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function (e) {
      return "deltaY" in e
        ? e.deltaY
        : "wheelDeltaY" in e
          ? -e.wheelDeltaY
          : "wheelDelta" in e
            ? -e.wheelDelta
            : 0;
    },
    deltaZ: 0,
    deltaMode: 0,
  }),
  gf = Ee(hf),
  vf = [9, 13, 27, 32],
  ki = Xe && "CompositionEvent" in window,
  In = null;
Xe && "documentMode" in document && (In = document.documentMode);
var yf = Xe && "TextEvent" in window && !In,
  au = Xe && (!ki || (In && 8 < In && 11 >= In)),
  ws = " ",
  xs = !1;
function uu(e, t) {
  switch (e) {
    case "keyup":
      return vf.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function cu(e) {
  return ((e = e.detail), typeof e == "object" && "data" in e ? e.data : null);
}
var Kt = !1;
function wf(e, t) {
  switch (e) {
    case "compositionend":
      return cu(t);
    case "keypress":
      return t.which !== 32 ? null : ((xs = !0), ws);
    case "textInput":
      return ((e = t.data), e === ws && xs ? null : e);
    default:
      return null;
  }
}
function xf(e, t) {
  if (Kt)
    return e === "compositionend" || (!ki && uu(e, t))
      ? ((e = su()), (Ir = wi = dt = null), (Kt = !1), e)
      : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return au && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var Sf = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0,
};
function Ss(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!Sf[e.type] : t === "textarea";
}
function du(e, t, n, r) {
  (Va(r),
    (t = tl(t, "onChange")),
    0 < t.length &&
      ((n = new xi("onChange", "change", null, n, r)),
      e.push({ event: n, listeners: t })));
}
var $n = null,
  Jn = null;
function kf(e) {
  ku(e, 0);
}
function Sl(e) {
  var t = Xt(e);
  if (Oa(t)) return e;
}
function Cf(e, t) {
  if (e === "change") return t;
}
var fu = !1;
if (Xe) {
  var Wl;
  if (Xe) {
    var Hl = "oninput" in document;
    if (!Hl) {
      var ks = document.createElement("div");
      (ks.setAttribute("oninput", "return;"),
        (Hl = typeof ks.oninput == "function"));
    }
    Wl = Hl;
  } else Wl = !1;
  fu = Wl && (!document.documentMode || 9 < document.documentMode);
}
function Cs() {
  $n && ($n.detachEvent("onpropertychange", pu), (Jn = $n = null));
}
function pu(e) {
  if (e.propertyName === "value" && Sl(Jn)) {
    var t = [];
    (du(t, Jn, e, mi(e)), Qa(kf, t));
  }
}
function Ef(e, t, n) {
  e === "focusin"
    ? (Cs(), ($n = t), (Jn = n), $n.attachEvent("onpropertychange", pu))
    : e === "focusout" && Cs();
}
function Pf(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown")
    return Sl(Jn);
}
function Nf(e, t) {
  if (e === "click") return Sl(t);
}
function _f(e, t) {
  if (e === "input" || e === "change") return Sl(t);
}
function zf(e, t) {
  return (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t);
}
var De = typeof Object.is == "function" ? Object.is : zf;
function er(e, t) {
  if (De(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e),
    r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) {
    var l = n[r];
    if (!ao.call(t, l) || !De(e[l], t[l])) return !1;
  }
  return !0;
}
function Es(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function Ps(e, t) {
  var n = Es(e);
  e = 0;
  for (var r; n; ) {
    if (n.nodeType === 3) {
      if (((r = e + n.textContent.length), e <= t && r >= t))
        return { node: n, offset: t - e };
      e = r;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = Es(n);
  }
}
function mu(e, t) {
  return e && t
    ? e === t
      ? !0
      : e && e.nodeType === 3
        ? !1
        : t && t.nodeType === 3
          ? mu(e, t.parentNode)
          : "contains" in e
            ? e.contains(t)
            : e.compareDocumentPosition
              ? !!(e.compareDocumentPosition(t) & 16)
              : !1
    : !1;
}
function hu() {
  for (var e = window, t = Kr(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = Kr(e.document);
  }
  return t;
}
function Ci(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return (
    t &&
    ((t === "input" &&
      (e.type === "text" ||
        e.type === "search" ||
        e.type === "tel" ||
        e.type === "url" ||
        e.type === "password")) ||
      t === "textarea" ||
      e.contentEditable === "true")
  );
}
function Tf(e) {
  var t = hu(),
    n = e.focusedElem,
    r = e.selectionRange;
  if (
    t !== n &&
    n &&
    n.ownerDocument &&
    mu(n.ownerDocument.documentElement, n)
  ) {
    if (r !== null && Ci(n)) {
      if (
        ((t = r.start),
        (e = r.end),
        e === void 0 && (e = t),
        "selectionStart" in n)
      )
        ((n.selectionStart = t),
          (n.selectionEnd = Math.min(e, n.value.length)));
      else if (
        ((e = ((t = n.ownerDocument || document) && t.defaultView) || window),
        e.getSelection)
      ) {
        e = e.getSelection();
        var l = n.textContent.length,
          o = Math.min(r.start, l);
        ((r = r.end === void 0 ? o : Math.min(r.end, l)),
          !e.extend && o > r && ((l = r), (r = o), (o = l)),
          (l = Ps(n, o)));
        var i = Ps(n, r);
        l &&
          i &&
          (e.rangeCount !== 1 ||
            e.anchorNode !== l.node ||
            e.anchorOffset !== l.offset ||
            e.focusNode !== i.node ||
            e.focusOffset !== i.offset) &&
          ((t = t.createRange()),
          t.setStart(l.node, l.offset),
          e.removeAllRanges(),
          o > r
            ? (e.addRange(t), e.extend(i.node, i.offset))
            : (t.setEnd(i.node, i.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; (e = e.parentNode); )
      e.nodeType === 1 &&
        t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++)
      ((e = t[n]),
        (e.element.scrollLeft = e.left),
        (e.element.scrollTop = e.top));
  }
}
var jf = Xe && "documentMode" in document && 11 >= document.documentMode,
  qt = null,
  zo = null,
  Bn = null,
  To = !1;
function Ns(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  To ||
    qt == null ||
    qt !== Kr(r) ||
    ((r = qt),
    "selectionStart" in r && Ci(r)
      ? (r = { start: r.selectionStart, end: r.selectionEnd })
      : ((r = (
          (r.ownerDocument && r.ownerDocument.defaultView) ||
          window
        ).getSelection()),
        (r = {
          anchorNode: r.anchorNode,
          anchorOffset: r.anchorOffset,
          focusNode: r.focusNode,
          focusOffset: r.focusOffset,
        })),
    (Bn && er(Bn, r)) ||
      ((Bn = r),
      (r = tl(zo, "onSelect")),
      0 < r.length &&
        ((t = new xi("onSelect", "select", null, t, n)),
        e.push({ event: t, listeners: r }),
        (t.target = qt))));
}
function Nr(e, t) {
  var n = {};
  return (
    (n[e.toLowerCase()] = t.toLowerCase()),
    (n["Webkit" + e] = "webkit" + t),
    (n["Moz" + e] = "moz" + t),
    n
  );
}
var Yt = {
    animationend: Nr("Animation", "AnimationEnd"),
    animationiteration: Nr("Animation", "AnimationIteration"),
    animationstart: Nr("Animation", "AnimationStart"),
    transitionend: Nr("Transition", "TransitionEnd"),
  },
  Ql = {},
  gu = {};
Xe &&
  ((gu = document.createElement("div").style),
  "AnimationEvent" in window ||
    (delete Yt.animationend.animation,
    delete Yt.animationiteration.animation,
    delete Yt.animationstart.animation),
  "TransitionEvent" in window || delete Yt.transitionend.transition);
function kl(e) {
  if (Ql[e]) return Ql[e];
  if (!Yt[e]) return e;
  var t = Yt[e],
    n;
  for (n in t) if (t.hasOwnProperty(n) && n in gu) return (Ql[e] = t[n]);
  return e;
}
var vu = kl("animationend"),
  yu = kl("animationiteration"),
  wu = kl("animationstart"),
  xu = kl("transitionend"),
  Su = new Map(),
  _s =
    "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " ",
    );
function Ct(e, t) {
  (Su.set(e, t), Bt(t, [e]));
}
for (var Gl = 0; Gl < _s.length; Gl++) {
  var Kl = _s[Gl],
    Lf = Kl.toLowerCase(),
    Rf = Kl[0].toUpperCase() + Kl.slice(1);
  Ct(Lf, "on" + Rf);
}
Ct(vu, "onAnimationEnd");
Ct(yu, "onAnimationIteration");
Ct(wu, "onAnimationStart");
Ct("dblclick", "onDoubleClick");
Ct("focusin", "onFocus");
Ct("focusout", "onBlur");
Ct(xu, "onTransitionEnd");
fn("onMouseEnter", ["mouseout", "mouseover"]);
fn("onMouseLeave", ["mouseout", "mouseover"]);
fn("onPointerEnter", ["pointerout", "pointerover"]);
fn("onPointerLeave", ["pointerout", "pointerover"]);
Bt(
  "onChange",
  "change click focusin focusout input keydown keyup selectionchange".split(
    " ",
  ),
);
Bt(
  "onSelect",
  "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
    " ",
  ),
);
Bt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
Bt(
  "onCompositionEnd",
  "compositionend focusout keydown keypress keyup mousedown".split(" "),
);
Bt(
  "onCompositionStart",
  "compositionstart focusout keydown keypress keyup mousedown".split(" "),
);
Bt(
  "onCompositionUpdate",
  "compositionupdate focusout keydown keypress keyup mousedown".split(" "),
);
var Mn =
    "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " ",
    ),
  bf = new Set("cancel close invalid load scroll toggle".split(" ").concat(Mn));
function zs(e, t, n) {
  var r = e.type || "unknown-event";
  ((e.currentTarget = n), jd(r, t, void 0, e), (e.currentTarget = null));
}
function ku(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n],
      l = r.event;
    r = r.listeners;
    e: {
      var o = void 0;
      if (t)
        for (var i = r.length - 1; 0 <= i; i--) {
          var s = r[i],
            a = s.instance,
            c = s.currentTarget;
          if (((s = s.listener), a !== o && l.isPropagationStopped())) break e;
          (zs(l, s, c), (o = a));
        }
      else
        for (i = 0; i < r.length; i++) {
          if (
            ((s = r[i]),
            (a = s.instance),
            (c = s.currentTarget),
            (s = s.listener),
            a !== o && l.isPropagationStopped())
          )
            break e;
          (zs(l, s, c), (o = a));
        }
    }
  }
  if (Yr) throw ((e = Eo), (Yr = !1), (Eo = null), e);
}
function V(e, t) {
  var n = t[Fo];
  n === void 0 && (n = t[Fo] = new Set());
  var r = e + "__bubble";
  n.has(r) || (Cu(t, e, 2, !1), n.add(r));
}
function ql(e, t, n) {
  var r = 0;
  (t && (r |= 4), Cu(n, e, r, t));
}
var _r = "_reactListening" + Math.random().toString(36).slice(2);
function tr(e) {
  if (!e[_r]) {
    ((e[_r] = !0),
      ja.forEach(function (n) {
        n !== "selectionchange" && (bf.has(n) || ql(n, !1, e), ql(n, !0, e));
      }));
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[_r] || ((t[_r] = !0), ql("selectionchange", !1, t));
  }
}
function Cu(e, t, n, r) {
  switch (iu(t)) {
    case 1:
      var l = Qd;
      break;
    case 4:
      l = Gd;
      break;
    default:
      l = yi;
  }
  ((n = l.bind(null, t, n, e)),
    (l = void 0),
    !Co ||
      (t !== "touchstart" && t !== "touchmove" && t !== "wheel") ||
      (l = !0),
    r
      ? l !== void 0
        ? e.addEventListener(t, n, { capture: !0, passive: l })
        : e.addEventListener(t, n, !0)
      : l !== void 0
        ? e.addEventListener(t, n, { passive: l })
        : e.addEventListener(t, n, !1));
}
function Yl(e, t, n, r, l) {
  var o = r;
  if (!(t & 1) && !(t & 2) && r !== null)
    e: for (;;) {
      if (r === null) return;
      var i = r.tag;
      if (i === 3 || i === 4) {
        var s = r.stateNode.containerInfo;
        if (s === l || (s.nodeType === 8 && s.parentNode === l)) break;
        if (i === 4)
          for (i = r.return; i !== null; ) {
            var a = i.tag;
            if (
              (a === 3 || a === 4) &&
              ((a = i.stateNode.containerInfo),
              a === l || (a.nodeType === 8 && a.parentNode === l))
            )
              return;
            i = i.return;
          }
        for (; s !== null; ) {
          if (((i = Lt(s)), i === null)) return;
          if (((a = i.tag), a === 5 || a === 6)) {
            r = o = i;
            continue e;
          }
          s = s.parentNode;
        }
      }
      r = r.return;
    }
  Qa(function () {
    var c = o,
      p = mi(n),
      h = [];
    e: {
      var m = Su.get(e);
      if (m !== void 0) {
        var v = xi,
          w = e;
        switch (e) {
          case "keypress":
            if ($r(n) === 0) break e;
          case "keydown":
          case "keyup":
            v = uf;
            break;
          case "focusin":
            ((w = "focus"), (v = Ul));
            break;
          case "focusout":
            ((w = "blur"), (v = Ul));
            break;
          case "beforeblur":
          case "afterblur":
            v = Ul;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            v = gs;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            v = Yd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            v = ff;
            break;
          case vu:
          case yu:
          case wu:
            v = Jd;
            break;
          case xu:
            v = mf;
            break;
          case "scroll":
            v = Kd;
            break;
          case "wheel":
            v = gf;
            break;
          case "copy":
          case "cut":
          case "paste":
            v = tf;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            v = ys;
        }
        var g = (t & 4) !== 0,
          E = !g && e === "scroll",
          d = g ? (m !== null ? m + "Capture" : null) : m;
        g = [];
        for (var u = c, f; u !== null; ) {
          f = u;
          var y = f.stateNode;
          if (
            (f.tag === 5 &&
              y !== null &&
              ((f = y),
              d !== null && ((y = qn(u, d)), y != null && g.push(nr(u, y, f)))),
            E)
          )
            break;
          u = u.return;
        }
        0 < g.length &&
          ((m = new v(m, w, null, n, p)), h.push({ event: m, listeners: g }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (
          ((m = e === "mouseover" || e === "pointerover"),
          (v = e === "mouseout" || e === "pointerout"),
          m &&
            n !== So &&
            (w = n.relatedTarget || n.fromElement) &&
            (Lt(w) || w[Ze]))
        )
          break e;
        if (
          (v || m) &&
          ((m =
            p.window === p
              ? p
              : (m = p.ownerDocument)
                ? m.defaultView || m.parentWindow
                : window),
          v
            ? ((w = n.relatedTarget || n.toElement),
              (v = c),
              (w = w ? Lt(w) : null),
              w !== null &&
                ((E = Vt(w)), w !== E || (w.tag !== 5 && w.tag !== 6)) &&
                (w = null))
            : ((v = null), (w = c)),
          v !== w)
        ) {
          if (
            ((g = gs),
            (y = "onMouseLeave"),
            (d = "onMouseEnter"),
            (u = "mouse"),
            (e === "pointerout" || e === "pointerover") &&
              ((g = ys),
              (y = "onPointerLeave"),
              (d = "onPointerEnter"),
              (u = "pointer")),
            (E = v == null ? m : Xt(v)),
            (f = w == null ? m : Xt(w)),
            (m = new g(y, u + "leave", v, n, p)),
            (m.target = E),
            (m.relatedTarget = f),
            (y = null),
            Lt(p) === c &&
              ((g = new g(d, u + "enter", w, n, p)),
              (g.target = f),
              (g.relatedTarget = E),
              (y = g)),
            (E = y),
            v && w)
          )
            t: {
              for (g = v, d = w, u = 0, f = g; f; f = Ht(f)) u++;
              for (f = 0, y = d; y; y = Ht(y)) f++;
              for (; 0 < u - f; ) ((g = Ht(g)), u--);
              for (; 0 < f - u; ) ((d = Ht(d)), f--);
              for (; u--; ) {
                if (g === d || (d !== null && g === d.alternate)) break t;
                ((g = Ht(g)), (d = Ht(d)));
              }
              g = null;
            }
          else g = null;
          (v !== null && Ts(h, m, v, g, !1),
            w !== null && E !== null && Ts(h, E, w, g, !0));
        }
      }
      e: {
        if (
          ((m = c ? Xt(c) : window),
          (v = m.nodeName && m.nodeName.toLowerCase()),
          v === "select" || (v === "input" && m.type === "file"))
        )
          var C = Cf;
        else if (Ss(m))
          if (fu) C = _f;
          else {
            C = Pf;
            var k = Ef;
          }
        else
          (v = m.nodeName) &&
            v.toLowerCase() === "input" &&
            (m.type === "checkbox" || m.type === "radio") &&
            (C = Nf);
        if (C && (C = C(e, c))) {
          du(h, C, n, p);
          break e;
        }
        (k && k(e, m, c),
          e === "focusout" &&
            (k = m._wrapperState) &&
            k.controlled &&
            m.type === "number" &&
            go(m, "number", m.value));
      }
      switch (((k = c ? Xt(c) : window), e)) {
        case "focusin":
          (Ss(k) || k.contentEditable === "true") &&
            ((qt = k), (zo = c), (Bn = null));
          break;
        case "focusout":
          Bn = zo = qt = null;
          break;
        case "mousedown":
          To = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          ((To = !1), Ns(h, n, p));
          break;
        case "selectionchange":
          if (jf) break;
        case "keydown":
        case "keyup":
          Ns(h, n, p);
      }
      var N;
      if (ki)
        e: {
          switch (e) {
            case "compositionstart":
              var z = "onCompositionStart";
              break e;
            case "compositionend":
              z = "onCompositionEnd";
              break e;
            case "compositionupdate":
              z = "onCompositionUpdate";
              break e;
          }
          z = void 0;
        }
      else
        Kt
          ? uu(e, n) && (z = "onCompositionEnd")
          : e === "keydown" && n.keyCode === 229 && (z = "onCompositionStart");
      (z &&
        (au &&
          n.locale !== "ko" &&
          (Kt || z !== "onCompositionStart"
            ? z === "onCompositionEnd" && Kt && (N = su())
            : ((dt = p),
              (wi = "value" in dt ? dt.value : dt.textContent),
              (Kt = !0))),
        (k = tl(c, z)),
        0 < k.length &&
          ((z = new vs(z, e, null, n, p)),
          h.push({ event: z, listeners: k }),
          N ? (z.data = N) : ((N = cu(n)), N !== null && (z.data = N)))),
        (N = yf ? wf(e, n) : xf(e, n)) &&
          ((c = tl(c, "onBeforeInput")),
          0 < c.length &&
            ((p = new vs("onBeforeInput", "beforeinput", null, n, p)),
            h.push({ event: p, listeners: c }),
            (p.data = N))));
    }
    ku(h, t);
  });
}
function nr(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function tl(e, t) {
  for (var n = t + "Capture", r = []; e !== null; ) {
    var l = e,
      o = l.stateNode;
    (l.tag === 5 &&
      o !== null &&
      ((l = o),
      (o = qn(e, n)),
      o != null && r.unshift(nr(e, o, l)),
      (o = qn(e, t)),
      o != null && r.push(nr(e, o, l))),
      (e = e.return));
  }
  return r;
}
function Ht(e) {
  if (e === null) return null;
  do e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function Ts(e, t, n, r, l) {
  for (var o = t._reactName, i = []; n !== null && n !== r; ) {
    var s = n,
      a = s.alternate,
      c = s.stateNode;
    if (a !== null && a === r) break;
    (s.tag === 5 &&
      c !== null &&
      ((s = c),
      l
        ? ((a = qn(n, o)), a != null && i.unshift(nr(n, a, s)))
        : l || ((a = qn(n, o)), a != null && i.push(nr(n, a, s)))),
      (n = n.return));
  }
  i.length !== 0 && e.push({ event: t, listeners: i });
}
var Ff = /\r\n?/g,
  Of = /\u0000|\uFFFD/g;
function js(e) {
  return (typeof e == "string" ? e : "" + e)
    .replace(
      Ff,
      `
`,
    )
    .replace(Of, "");
}
function zr(e, t, n) {
  if (((t = js(t)), js(e) !== t && n)) throw Error(x(425));
}
function nl() {}
var jo = null,
  Lo = null;
function Ro(e, t) {
  return (
    e === "textarea" ||
    e === "noscript" ||
    typeof t.children == "string" ||
    typeof t.children == "number" ||
    (typeof t.dangerouslySetInnerHTML == "object" &&
      t.dangerouslySetInnerHTML !== null &&
      t.dangerouslySetInnerHTML.__html != null)
  );
}
var bo = typeof setTimeout == "function" ? setTimeout : void 0,
  Mf = typeof clearTimeout == "function" ? clearTimeout : void 0,
  Ls = typeof Promise == "function" ? Promise : void 0,
  Af =
    typeof queueMicrotask == "function"
      ? queueMicrotask
      : typeof Ls < "u"
        ? function (e) {
            return Ls.resolve(null).then(e).catch(Df);
          }
        : bo;
function Df(e) {
  setTimeout(function () {
    throw e;
  });
}
function Xl(e, t) {
  var n = t,
    r = 0;
  do {
    var l = n.nextSibling;
    if ((e.removeChild(n), l && l.nodeType === 8))
      if (((n = l.data), n === "/$")) {
        if (r === 0) {
          (e.removeChild(l), Zn(t));
          return;
        }
        r--;
      } else (n !== "$" && n !== "$?" && n !== "$!") || r++;
    n = l;
  } while (n);
  Zn(t);
}
function gt(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (((t = e.data), t === "$" || t === "$!" || t === "$?")) break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function Rs(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0) return e;
        t--;
      } else n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var Sn = Math.random().toString(36).slice(2),
  Ve = "__reactFiber$" + Sn,
  rr = "__reactProps$" + Sn,
  Ze = "__reactContainer$" + Sn,
  Fo = "__reactEvents$" + Sn,
  If = "__reactListeners$" + Sn,
  $f = "__reactHandles$" + Sn;
function Lt(e) {
  var t = e[Ve];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if ((t = n[Ze] || n[Ve])) {
      if (
        ((n = t.alternate),
        t.child !== null || (n !== null && n.child !== null))
      )
        for (e = Rs(e); e !== null; ) {
          if ((n = e[Ve])) return n;
          e = Rs(e);
        }
      return t;
    }
    ((e = n), (n = e.parentNode));
  }
  return null;
}
function pr(e) {
  return (
    (e = e[Ve] || e[Ze]),
    !e || (e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3) ? null : e
  );
}
function Xt(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(x(33));
}
function Cl(e) {
  return e[rr] || null;
}
var Oo = [],
  Zt = -1;
function Et(e) {
  return { current: e };
}
function U(e) {
  0 > Zt || ((e.current = Oo[Zt]), (Oo[Zt] = null), Zt--);
}
function I(e, t) {
  (Zt++, (Oo[Zt] = e.current), (e.current = t));
}
var kt = {},
  ae = Et(kt),
  ge = Et(!1),
  Mt = kt;
function pn(e, t) {
  var n = e.type.contextTypes;
  if (!n) return kt;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
    return r.__reactInternalMemoizedMaskedChildContext;
  var l = {},
    o;
  for (o in n) l[o] = t[o];
  return (
    r &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = t),
      (e.__reactInternalMemoizedMaskedChildContext = l)),
    l
  );
}
function ve(e) {
  return ((e = e.childContextTypes), e != null);
}
function rl() {
  (U(ge), U(ae));
}
function bs(e, t, n) {
  if (ae.current !== kt) throw Error(x(168));
  (I(ae, t), I(ge, n));
}
function Eu(e, t, n) {
  var r = e.stateNode;
  if (((t = t.childContextTypes), typeof r.getChildContext != "function"))
    return n;
  r = r.getChildContext();
  for (var l in r) if (!(l in t)) throw Error(x(108, Cd(e) || "Unknown", l));
  return G({}, n, r);
}
function ll(e) {
  return (
    (e =
      ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || kt),
    (Mt = ae.current),
    I(ae, e),
    I(ge, ge.current),
    !0
  );
}
function Fs(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(x(169));
  (n
    ? ((e = Eu(e, t, Mt)),
      (r.__reactInternalMemoizedMergedChildContext = e),
      U(ge),
      U(ae),
      I(ae, e))
    : U(ge),
    I(ge, n));
}
var Ge = null,
  El = !1,
  Zl = !1;
function Pu(e) {
  Ge === null ? (Ge = [e]) : Ge.push(e);
}
function Bf(e) {
  ((El = !0), Pu(e));
}
function Pt() {
  if (!Zl && Ge !== null) {
    Zl = !0;
    var e = 0,
      t = D;
    try {
      var n = Ge;
      for (D = 1; e < n.length; e++) {
        var r = n[e];
        do r = r(!0);
        while (r !== null);
      }
      ((Ge = null), (El = !1));
    } catch (l) {
      throw (Ge !== null && (Ge = Ge.slice(e + 1)), Ya(hi, Pt), l);
    } finally {
      ((D = t), (Zl = !1));
    }
  }
  return null;
}
var Jt = [],
  en = 0,
  ol = null,
  il = 0,
  Pe = [],
  Ne = 0,
  At = null,
  Ke = 1,
  qe = "";
function Tt(e, t) {
  ((Jt[en++] = il), (Jt[en++] = ol), (ol = e), (il = t));
}
function Nu(e, t, n) {
  ((Pe[Ne++] = Ke), (Pe[Ne++] = qe), (Pe[Ne++] = At), (At = e));
  var r = Ke;
  e = qe;
  var l = 32 - Me(r) - 1;
  ((r &= ~(1 << l)), (n += 1));
  var o = 32 - Me(t) + l;
  if (30 < o) {
    var i = l - (l % 5);
    ((o = (r & ((1 << i) - 1)).toString(32)),
      (r >>= i),
      (l -= i),
      (Ke = (1 << (32 - Me(t) + l)) | (n << l) | r),
      (qe = o + e));
  } else ((Ke = (1 << o) | (n << l) | r), (qe = e));
}
function Ei(e) {
  e.return !== null && (Tt(e, 1), Nu(e, 1, 0));
}
function Pi(e) {
  for (; e === ol; )
    ((ol = Jt[--en]), (Jt[en] = null), (il = Jt[--en]), (Jt[en] = null));
  for (; e === At; )
    ((At = Pe[--Ne]),
      (Pe[Ne] = null),
      (qe = Pe[--Ne]),
      (Pe[Ne] = null),
      (Ke = Pe[--Ne]),
      (Pe[Ne] = null));
}
var Se = null,
  xe = null,
  W = !1,
  Oe = null;
function _u(e, t) {
  var n = ze(5, null, null, 0);
  ((n.elementType = "DELETED"),
    (n.stateNode = t),
    (n.return = e),
    (t = e.deletions),
    t === null ? ((e.deletions = [n]), (e.flags |= 16)) : t.push(n));
}
function Os(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return (
        (t =
          t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase()
            ? null
            : t),
        t !== null
          ? ((e.stateNode = t), (Se = e), (xe = gt(t.firstChild)), !0)
          : !1
      );
    case 6:
      return (
        (t = e.pendingProps === "" || t.nodeType !== 3 ? null : t),
        t !== null ? ((e.stateNode = t), (Se = e), (xe = null), !0) : !1
      );
    case 13:
      return (
        (t = t.nodeType !== 8 ? null : t),
        t !== null
          ? ((n = At !== null ? { id: Ke, overflow: qe } : null),
            (e.memoizedState = {
              dehydrated: t,
              treeContext: n,
              retryLane: 1073741824,
            }),
            (n = ze(18, null, null, 0)),
            (n.stateNode = t),
            (n.return = e),
            (e.child = n),
            (Se = e),
            (xe = null),
            !0)
          : !1
      );
    default:
      return !1;
  }
}
function Mo(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function Ao(e) {
  if (W) {
    var t = xe;
    if (t) {
      var n = t;
      if (!Os(e, t)) {
        if (Mo(e)) throw Error(x(418));
        t = gt(n.nextSibling);
        var r = Se;
        t && Os(e, t)
          ? _u(r, n)
          : ((e.flags = (e.flags & -4097) | 2), (W = !1), (Se = e));
      }
    } else {
      if (Mo(e)) throw Error(x(418));
      ((e.flags = (e.flags & -4097) | 2), (W = !1), (Se = e));
    }
  }
}
function Ms(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; )
    e = e.return;
  Se = e;
}
function Tr(e) {
  if (e !== Se) return !1;
  if (!W) return (Ms(e), (W = !0), !1);
  var t;
  if (
    ((t = e.tag !== 3) &&
      !(t = e.tag !== 5) &&
      ((t = e.type),
      (t = t !== "head" && t !== "body" && !Ro(e.type, e.memoizedProps))),
    t && (t = xe))
  ) {
    if (Mo(e)) throw (zu(), Error(x(418)));
    for (; t; ) (_u(e, t), (t = gt(t.nextSibling)));
  }
  if ((Ms(e), e.tag === 13)) {
    if (((e = e.memoizedState), (e = e !== null ? e.dehydrated : null), !e))
      throw Error(x(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              xe = gt(e.nextSibling);
              break e;
            }
            t--;
          } else (n !== "$" && n !== "$!" && n !== "$?") || t++;
        }
        e = e.nextSibling;
      }
      xe = null;
    }
  } else xe = Se ? gt(e.stateNode.nextSibling) : null;
  return !0;
}
function zu() {
  for (var e = xe; e; ) e = gt(e.nextSibling);
}
function mn() {
  ((xe = Se = null), (W = !1));
}
function Ni(e) {
  Oe === null ? (Oe = [e]) : Oe.push(e);
}
var Vf = tt.ReactCurrentBatchConfig;
function zn(e, t, n) {
  if (
    ((e = n.ref), e !== null && typeof e != "function" && typeof e != "object")
  ) {
    if (n._owner) {
      if (((n = n._owner), n)) {
        if (n.tag !== 1) throw Error(x(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(x(147, e));
      var l = r,
        o = "" + e;
      return t !== null &&
        t.ref !== null &&
        typeof t.ref == "function" &&
        t.ref._stringRef === o
        ? t.ref
        : ((t = function (i) {
            var s = l.refs;
            i === null ? delete s[o] : (s[o] = i);
          }),
          (t._stringRef = o),
          t);
    }
    if (typeof e != "string") throw Error(x(284));
    if (!n._owner) throw Error(x(290, e));
  }
  return e;
}
function jr(e, t) {
  throw (
    (e = Object.prototype.toString.call(t)),
    Error(
      x(
        31,
        e === "[object Object]"
          ? "object with keys {" + Object.keys(t).join(", ") + "}"
          : e,
      ),
    )
  );
}
function As(e) {
  var t = e._init;
  return t(e._payload);
}
function Tu(e) {
  function t(d, u) {
    if (e) {
      var f = d.deletions;
      f === null ? ((d.deletions = [u]), (d.flags |= 16)) : f.push(u);
    }
  }
  function n(d, u) {
    if (!e) return null;
    for (; u !== null; ) (t(d, u), (u = u.sibling));
    return null;
  }
  function r(d, u) {
    for (d = new Map(); u !== null; )
      (u.key !== null ? d.set(u.key, u) : d.set(u.index, u), (u = u.sibling));
    return d;
  }
  function l(d, u) {
    return ((d = xt(d, u)), (d.index = 0), (d.sibling = null), d);
  }
  function o(d, u, f) {
    return (
      (d.index = f),
      e
        ? ((f = d.alternate),
          f !== null
            ? ((f = f.index), f < u ? ((d.flags |= 2), u) : f)
            : ((d.flags |= 2), u))
        : ((d.flags |= 1048576), u)
    );
  }
  function i(d) {
    return (e && d.alternate === null && (d.flags |= 2), d);
  }
  function s(d, u, f, y) {
    return u === null || u.tag !== 6
      ? ((u = oo(f, d.mode, y)), (u.return = d), u)
      : ((u = l(u, f)), (u.return = d), u);
  }
  function a(d, u, f, y) {
    var C = f.type;
    return C === Gt
      ? p(d, u, f.props.children, y, f.key)
      : u !== null &&
          (u.elementType === C ||
            (typeof C == "object" &&
              C !== null &&
              C.$$typeof === st &&
              As(C) === u.type))
        ? ((y = l(u, f.props)), (y.ref = zn(d, u, f)), (y.return = d), y)
        : ((y = Gr(f.type, f.key, f.props, null, d.mode, y)),
          (y.ref = zn(d, u, f)),
          (y.return = d),
          y);
  }
  function c(d, u, f, y) {
    return u === null ||
      u.tag !== 4 ||
      u.stateNode.containerInfo !== f.containerInfo ||
      u.stateNode.implementation !== f.implementation
      ? ((u = io(f, d.mode, y)), (u.return = d), u)
      : ((u = l(u, f.children || [])), (u.return = d), u);
  }
  function p(d, u, f, y, C) {
    return u === null || u.tag !== 7
      ? ((u = Ot(f, d.mode, y, C)), (u.return = d), u)
      : ((u = l(u, f)), (u.return = d), u);
  }
  function h(d, u, f) {
    if ((typeof u == "string" && u !== "") || typeof u == "number")
      return ((u = oo("" + u, d.mode, f)), (u.return = d), u);
    if (typeof u == "object" && u !== null) {
      switch (u.$$typeof) {
        case wr:
          return (
            (f = Gr(u.type, u.key, u.props, null, d.mode, f)),
            (f.ref = zn(d, null, u)),
            (f.return = d),
            f
          );
        case Qt:
          return ((u = io(u, d.mode, f)), (u.return = d), u);
        case st:
          var y = u._init;
          return h(d, y(u._payload), f);
      }
      if (Fn(u) || Cn(u))
        return ((u = Ot(u, d.mode, f, null)), (u.return = d), u);
      jr(d, u);
    }
    return null;
  }
  function m(d, u, f, y) {
    var C = u !== null ? u.key : null;
    if ((typeof f == "string" && f !== "") || typeof f == "number")
      return C !== null ? null : s(d, u, "" + f, y);
    if (typeof f == "object" && f !== null) {
      switch (f.$$typeof) {
        case wr:
          return f.key === C ? a(d, u, f, y) : null;
        case Qt:
          return f.key === C ? c(d, u, f, y) : null;
        case st:
          return ((C = f._init), m(d, u, C(f._payload), y));
      }
      if (Fn(f) || Cn(f)) return C !== null ? null : p(d, u, f, y, null);
      jr(d, f);
    }
    return null;
  }
  function v(d, u, f, y, C) {
    if ((typeof y == "string" && y !== "") || typeof y == "number")
      return ((d = d.get(f) || null), s(u, d, "" + y, C));
    if (typeof y == "object" && y !== null) {
      switch (y.$$typeof) {
        case wr:
          return (
            (d = d.get(y.key === null ? f : y.key) || null),
            a(u, d, y, C)
          );
        case Qt:
          return (
            (d = d.get(y.key === null ? f : y.key) || null),
            c(u, d, y, C)
          );
        case st:
          var k = y._init;
          return v(d, u, f, k(y._payload), C);
      }
      if (Fn(y) || Cn(y)) return ((d = d.get(f) || null), p(u, d, y, C, null));
      jr(u, y);
    }
    return null;
  }
  function w(d, u, f, y) {
    for (
      var C = null, k = null, N = u, z = (u = 0), $ = null;
      N !== null && z < f.length;
      z++
    ) {
      N.index > z ? (($ = N), (N = null)) : ($ = N.sibling);
      var R = m(d, N, f[z], y);
      if (R === null) {
        N === null && (N = $);
        break;
      }
      (e && N && R.alternate === null && t(d, N),
        (u = o(R, u, z)),
        k === null ? (C = R) : (k.sibling = R),
        (k = R),
        (N = $));
    }
    if (z === f.length) return (n(d, N), W && Tt(d, z), C);
    if (N === null) {
      for (; z < f.length; z++)
        ((N = h(d, f[z], y)),
          N !== null &&
            ((u = o(N, u, z)),
            k === null ? (C = N) : (k.sibling = N),
            (k = N)));
      return (W && Tt(d, z), C);
    }
    for (N = r(d, N); z < f.length; z++)
      (($ = v(N, d, z, f[z], y)),
        $ !== null &&
          (e && $.alternate !== null && N.delete($.key === null ? z : $.key),
          (u = o($, u, z)),
          k === null ? (C = $) : (k.sibling = $),
          (k = $)));
    return (
      e &&
        N.forEach(function (ue) {
          return t(d, ue);
        }),
      W && Tt(d, z),
      C
    );
  }
  function g(d, u, f, y) {
    var C = Cn(f);
    if (typeof C != "function") throw Error(x(150));
    if (((f = C.call(f)), f == null)) throw Error(x(151));
    for (
      var k = (C = null), N = u, z = (u = 0), $ = null, R = f.next();
      N !== null && !R.done;
      z++, R = f.next()
    ) {
      N.index > z ? (($ = N), (N = null)) : ($ = N.sibling);
      var ue = m(d, N, R.value, y);
      if (ue === null) {
        N === null && (N = $);
        break;
      }
      (e && N && ue.alternate === null && t(d, N),
        (u = o(ue, u, z)),
        k === null ? (C = ue) : (k.sibling = ue),
        (k = ue),
        (N = $));
    }
    if (R.done) return (n(d, N), W && Tt(d, z), C);
    if (N === null) {
      for (; !R.done; z++, R = f.next())
        ((R = h(d, R.value, y)),
          R !== null &&
            ((u = o(R, u, z)),
            k === null ? (C = R) : (k.sibling = R),
            (k = R)));
      return (W && Tt(d, z), C);
    }
    for (N = r(d, N); !R.done; z++, R = f.next())
      ((R = v(N, d, z, R.value, y)),
        R !== null &&
          (e && R.alternate !== null && N.delete(R.key === null ? z : R.key),
          (u = o(R, u, z)),
          k === null ? (C = R) : (k.sibling = R),
          (k = R)));
    return (
      e &&
        N.forEach(function (A) {
          return t(d, A);
        }),
      W && Tt(d, z),
      C
    );
  }
  function E(d, u, f, y) {
    if (
      (typeof f == "object" &&
        f !== null &&
        f.type === Gt &&
        f.key === null &&
        (f = f.props.children),
      typeof f == "object" && f !== null)
    ) {
      switch (f.$$typeof) {
        case wr:
          e: {
            for (var C = f.key, k = u; k !== null; ) {
              if (k.key === C) {
                if (((C = f.type), C === Gt)) {
                  if (k.tag === 7) {
                    (n(d, k.sibling),
                      (u = l(k, f.props.children)),
                      (u.return = d),
                      (d = u));
                    break e;
                  }
                } else if (
                  k.elementType === C ||
                  (typeof C == "object" &&
                    C !== null &&
                    C.$$typeof === st &&
                    As(C) === k.type)
                ) {
                  (n(d, k.sibling),
                    (u = l(k, f.props)),
                    (u.ref = zn(d, k, f)),
                    (u.return = d),
                    (d = u));
                  break e;
                }
                n(d, k);
                break;
              } else t(d, k);
              k = k.sibling;
            }
            f.type === Gt
              ? ((u = Ot(f.props.children, d.mode, y, f.key)),
                (u.return = d),
                (d = u))
              : ((y = Gr(f.type, f.key, f.props, null, d.mode, y)),
                (y.ref = zn(d, u, f)),
                (y.return = d),
                (d = y));
          }
          return i(d);
        case Qt:
          e: {
            for (k = f.key; u !== null; ) {
              if (u.key === k)
                if (
                  u.tag === 4 &&
                  u.stateNode.containerInfo === f.containerInfo &&
                  u.stateNode.implementation === f.implementation
                ) {
                  (n(d, u.sibling),
                    (u = l(u, f.children || [])),
                    (u.return = d),
                    (d = u));
                  break e;
                } else {
                  n(d, u);
                  break;
                }
              else t(d, u);
              u = u.sibling;
            }
            ((u = io(f, d.mode, y)), (u.return = d), (d = u));
          }
          return i(d);
        case st:
          return ((k = f._init), E(d, u, k(f._payload), y));
      }
      if (Fn(f)) return w(d, u, f, y);
      if (Cn(f)) return g(d, u, f, y);
      jr(d, f);
    }
    return (typeof f == "string" && f !== "") || typeof f == "number"
      ? ((f = "" + f),
        u !== null && u.tag === 6
          ? (n(d, u.sibling), (u = l(u, f)), (u.return = d), (d = u))
          : (n(d, u), (u = oo(f, d.mode, y)), (u.return = d), (d = u)),
        i(d))
      : n(d, u);
  }
  return E;
}
var hn = Tu(!0),
  ju = Tu(!1),
  sl = Et(null),
  al = null,
  tn = null,
  _i = null;
function zi() {
  _i = tn = al = null;
}
function Ti(e) {
  var t = sl.current;
  (U(sl), (e._currentValue = t));
}
function Do(e, t, n) {
  for (; e !== null; ) {
    var r = e.alternate;
    if (
      ((e.childLanes & t) !== t
        ? ((e.childLanes |= t), r !== null && (r.childLanes |= t))
        : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t),
      e === n)
    )
      break;
    e = e.return;
  }
}
function un(e, t) {
  ((al = e),
    (_i = tn = null),
    (e = e.dependencies),
    e !== null &&
      e.firstContext !== null &&
      (e.lanes & t && (he = !0), (e.firstContext = null)));
}
function je(e) {
  var t = e._currentValue;
  if (_i !== e)
    if (((e = { context: e, memoizedValue: t, next: null }), tn === null)) {
      if (al === null) throw Error(x(308));
      ((tn = e), (al.dependencies = { lanes: 0, firstContext: e }));
    } else tn = tn.next = e;
  return t;
}
var Rt = null;
function ji(e) {
  Rt === null ? (Rt = [e]) : Rt.push(e);
}
function Lu(e, t, n, r) {
  var l = t.interleaved;
  return (
    l === null ? ((n.next = n), ji(t)) : ((n.next = l.next), (l.next = n)),
    (t.interleaved = n),
    Je(e, r)
  );
}
function Je(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; )
    ((e.childLanes |= t),
      (n = e.alternate),
      n !== null && (n.childLanes |= t),
      (n = e),
      (e = e.return));
  return n.tag === 3 ? n.stateNode : null;
}
var at = !1;
function Li(e) {
  e.updateQueue = {
    baseState: e.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: { pending: null, interleaved: null, lanes: 0 },
    effects: null,
  };
}
function Ru(e, t) {
  ((e = e.updateQueue),
    t.updateQueue === e &&
      (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        effects: e.effects,
      }));
}
function Ye(e, t) {
  return {
    eventTime: e,
    lane: t,
    tag: 0,
    payload: null,
    callback: null,
    next: null,
  };
}
function vt(e, t, n) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (((r = r.shared), O & 2)) {
    var l = r.pending;
    return (
      l === null ? (t.next = t) : ((t.next = l.next), (l.next = t)),
      (r.pending = t),
      Je(e, n)
    );
  }
  return (
    (l = r.interleaved),
    l === null ? ((t.next = t), ji(r)) : ((t.next = l.next), (l.next = t)),
    (r.interleaved = t),
    Je(e, n)
  );
}
function Br(e, t, n) {
  if (
    ((t = t.updateQueue), t !== null && ((t = t.shared), (n & 4194240) !== 0))
  ) {
    var r = t.lanes;
    ((r &= e.pendingLanes), (n |= r), (t.lanes = n), gi(e, n));
  }
}
function Ds(e, t) {
  var n = e.updateQueue,
    r = e.alternate;
  if (r !== null && ((r = r.updateQueue), n === r)) {
    var l = null,
      o = null;
    if (((n = n.firstBaseUpdate), n !== null)) {
      do {
        var i = {
          eventTime: n.eventTime,
          lane: n.lane,
          tag: n.tag,
          payload: n.payload,
          callback: n.callback,
          next: null,
        };
        (o === null ? (l = o = i) : (o = o.next = i), (n = n.next));
      } while (n !== null);
      o === null ? (l = o = t) : (o = o.next = t);
    } else l = o = t;
    ((n = {
      baseState: r.baseState,
      firstBaseUpdate: l,
      lastBaseUpdate: o,
      shared: r.shared,
      effects: r.effects,
    }),
      (e.updateQueue = n));
    return;
  }
  ((e = n.lastBaseUpdate),
    e === null ? (n.firstBaseUpdate = t) : (e.next = t),
    (n.lastBaseUpdate = t));
}
function ul(e, t, n, r) {
  var l = e.updateQueue;
  at = !1;
  var o = l.firstBaseUpdate,
    i = l.lastBaseUpdate,
    s = l.shared.pending;
  if (s !== null) {
    l.shared.pending = null;
    var a = s,
      c = a.next;
    ((a.next = null), i === null ? (o = c) : (i.next = c), (i = a));
    var p = e.alternate;
    p !== null &&
      ((p = p.updateQueue),
      (s = p.lastBaseUpdate),
      s !== i &&
        (s === null ? (p.firstBaseUpdate = c) : (s.next = c),
        (p.lastBaseUpdate = a)));
  }
  if (o !== null) {
    var h = l.baseState;
    ((i = 0), (p = c = a = null), (s = o));
    do {
      var m = s.lane,
        v = s.eventTime;
      if ((r & m) === m) {
        p !== null &&
          (p = p.next =
            {
              eventTime: v,
              lane: 0,
              tag: s.tag,
              payload: s.payload,
              callback: s.callback,
              next: null,
            });
        e: {
          var w = e,
            g = s;
          switch (((m = t), (v = n), g.tag)) {
            case 1:
              if (((w = g.payload), typeof w == "function")) {
                h = w.call(v, h, m);
                break e;
              }
              h = w;
              break e;
            case 3:
              w.flags = (w.flags & -65537) | 128;
            case 0:
              if (
                ((w = g.payload),
                (m = typeof w == "function" ? w.call(v, h, m) : w),
                m == null)
              )
                break e;
              h = G({}, h, m);
              break e;
            case 2:
              at = !0;
          }
        }
        s.callback !== null &&
          s.lane !== 0 &&
          ((e.flags |= 64),
          (m = l.effects),
          m === null ? (l.effects = [s]) : m.push(s));
      } else
        ((v = {
          eventTime: v,
          lane: m,
          tag: s.tag,
          payload: s.payload,
          callback: s.callback,
          next: null,
        }),
          p === null ? ((c = p = v), (a = h)) : (p = p.next = v),
          (i |= m));
      if (((s = s.next), s === null)) {
        if (((s = l.shared.pending), s === null)) break;
        ((m = s),
          (s = m.next),
          (m.next = null),
          (l.lastBaseUpdate = m),
          (l.shared.pending = null));
      }
    } while (!0);
    if (
      (p === null && (a = h),
      (l.baseState = a),
      (l.firstBaseUpdate = c),
      (l.lastBaseUpdate = p),
      (t = l.shared.interleaved),
      t !== null)
    ) {
      l = t;
      do ((i |= l.lane), (l = l.next));
      while (l !== t);
    } else o === null && (l.shared.lanes = 0);
    ((It |= i), (e.lanes = i), (e.memoizedState = h));
  }
}
function Is(e, t, n) {
  if (((e = t.effects), (t.effects = null), e !== null))
    for (t = 0; t < e.length; t++) {
      var r = e[t],
        l = r.callback;
      if (l !== null) {
        if (((r.callback = null), (r = n), typeof l != "function"))
          throw Error(x(191, l));
        l.call(r);
      }
    }
}
var mr = {},
  We = Et(mr),
  lr = Et(mr),
  or = Et(mr);
function bt(e) {
  if (e === mr) throw Error(x(174));
  return e;
}
function Ri(e, t) {
  switch ((I(or, t), I(lr, e), I(We, mr), (e = t.nodeType), e)) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : yo(null, "");
      break;
    default:
      ((e = e === 8 ? t.parentNode : t),
        (t = e.namespaceURI || null),
        (e = e.tagName),
        (t = yo(t, e)));
  }
  (U(We), I(We, t));
}
function gn() {
  (U(We), U(lr), U(or));
}
function bu(e) {
  bt(or.current);
  var t = bt(We.current),
    n = yo(t, e.type);
  t !== n && (I(lr, e), I(We, n));
}
function bi(e) {
  lr.current === e && (U(We), U(lr));
}
var H = Et(0);
function cl(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (
        n !== null &&
        ((n = n.dehydrated), n === null || n.data === "$?" || n.data === "$!")
      )
        return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      ((t.child.return = t), (t = t.child));
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    ((t.sibling.return = t.return), (t = t.sibling));
  }
  return null;
}
var Jl = [];
function Fi() {
  for (var e = 0; e < Jl.length; e++)
    Jl[e]._workInProgressVersionPrimary = null;
  Jl.length = 0;
}
var Vr = tt.ReactCurrentDispatcher,
  eo = tt.ReactCurrentBatchConfig,
  Dt = 0,
  Q = null,
  X = null,
  ee = null,
  dl = !1,
  Vn = !1,
  ir = 0,
  Uf = 0;
function oe() {
  throw Error(x(321));
}
function Oi(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++)
    if (!De(e[n], t[n])) return !1;
  return !0;
}
function Mi(e, t, n, r, l, o) {
  if (
    ((Dt = o),
    (Q = t),
    (t.memoizedState = null),
    (t.updateQueue = null),
    (t.lanes = 0),
    (Vr.current = e === null || e.memoizedState === null ? Gf : Kf),
    (e = n(r, l)),
    Vn)
  ) {
    o = 0;
    do {
      if (((Vn = !1), (ir = 0), 25 <= o)) throw Error(x(301));
      ((o += 1),
        (ee = X = null),
        (t.updateQueue = null),
        (Vr.current = qf),
        (e = n(r, l)));
    } while (Vn);
  }
  if (
    ((Vr.current = fl),
    (t = X !== null && X.next !== null),
    (Dt = 0),
    (ee = X = Q = null),
    (dl = !1),
    t)
  )
    throw Error(x(300));
  return e;
}
function Ai() {
  var e = ir !== 0;
  return ((ir = 0), e);
}
function Be() {
  var e = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null,
  };
  return (ee === null ? (Q.memoizedState = ee = e) : (ee = ee.next = e), ee);
}
function Le() {
  if (X === null) {
    var e = Q.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = X.next;
  var t = ee === null ? Q.memoizedState : ee.next;
  if (t !== null) ((ee = t), (X = e));
  else {
    if (e === null) throw Error(x(310));
    ((X = e),
      (e = {
        memoizedState: X.memoizedState,
        baseState: X.baseState,
        baseQueue: X.baseQueue,
        queue: X.queue,
        next: null,
      }),
      ee === null ? (Q.memoizedState = ee = e) : (ee = ee.next = e));
  }
  return ee;
}
function sr(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function to(e) {
  var t = Le(),
    n = t.queue;
  if (n === null) throw Error(x(311));
  n.lastRenderedReducer = e;
  var r = X,
    l = r.baseQueue,
    o = n.pending;
  if (o !== null) {
    if (l !== null) {
      var i = l.next;
      ((l.next = o.next), (o.next = i));
    }
    ((r.baseQueue = l = o), (n.pending = null));
  }
  if (l !== null) {
    ((o = l.next), (r = r.baseState));
    var s = (i = null),
      a = null,
      c = o;
    do {
      var p = c.lane;
      if ((Dt & p) === p)
        (a !== null &&
          (a = a.next =
            {
              lane: 0,
              action: c.action,
              hasEagerState: c.hasEagerState,
              eagerState: c.eagerState,
              next: null,
            }),
          (r = c.hasEagerState ? c.eagerState : e(r, c.action)));
      else {
        var h = {
          lane: p,
          action: c.action,
          hasEagerState: c.hasEagerState,
          eagerState: c.eagerState,
          next: null,
        };
        (a === null ? ((s = a = h), (i = r)) : (a = a.next = h),
          (Q.lanes |= p),
          (It |= p));
      }
      c = c.next;
    } while (c !== null && c !== o);
    (a === null ? (i = r) : (a.next = s),
      De(r, t.memoizedState) || (he = !0),
      (t.memoizedState = r),
      (t.baseState = i),
      (t.baseQueue = a),
      (n.lastRenderedState = r));
  }
  if (((e = n.interleaved), e !== null)) {
    l = e;
    do ((o = l.lane), (Q.lanes |= o), (It |= o), (l = l.next));
    while (l !== e);
  } else l === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function no(e) {
  var t = Le(),
    n = t.queue;
  if (n === null) throw Error(x(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch,
    l = n.pending,
    o = t.memoizedState;
  if (l !== null) {
    n.pending = null;
    var i = (l = l.next);
    do ((o = e(o, i.action)), (i = i.next));
    while (i !== l);
    (De(o, t.memoizedState) || (he = !0),
      (t.memoizedState = o),
      t.baseQueue === null && (t.baseState = o),
      (n.lastRenderedState = o));
  }
  return [o, r];
}
function Fu() {}
function Ou(e, t) {
  var n = Q,
    r = Le(),
    l = t(),
    o = !De(r.memoizedState, l);
  if (
    (o && ((r.memoizedState = l), (he = !0)),
    (r = r.queue),
    Di(Du.bind(null, n, r, e), [e]),
    r.getSnapshot !== t || o || (ee !== null && ee.memoizedState.tag & 1))
  ) {
    if (
      ((n.flags |= 2048),
      ar(9, Au.bind(null, n, r, l, t), void 0, null),
      te === null)
    )
      throw Error(x(349));
    Dt & 30 || Mu(n, t, l);
  }
  return l;
}
function Mu(e, t, n) {
  ((e.flags |= 16384),
    (e = { getSnapshot: t, value: n }),
    (t = Q.updateQueue),
    t === null
      ? ((t = { lastEffect: null, stores: null }),
        (Q.updateQueue = t),
        (t.stores = [e]))
      : ((n = t.stores), n === null ? (t.stores = [e]) : n.push(e)));
}
function Au(e, t, n, r) {
  ((t.value = n), (t.getSnapshot = r), Iu(t) && $u(e));
}
function Du(e, t, n) {
  return n(function () {
    Iu(t) && $u(e);
  });
}
function Iu(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !De(e, n);
  } catch {
    return !0;
  }
}
function $u(e) {
  var t = Je(e, 1);
  t !== null && Ae(t, e, 1, -1);
}
function $s(e) {
  var t = Be();
  return (
    typeof e == "function" && (e = e()),
    (t.memoizedState = t.baseState = e),
    (e = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: sr,
      lastRenderedState: e,
    }),
    (t.queue = e),
    (e = e.dispatch = Qf.bind(null, Q, e)),
    [t.memoizedState, e]
  );
}
function ar(e, t, n, r) {
  return (
    (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
    (t = Q.updateQueue),
    t === null
      ? ((t = { lastEffect: null, stores: null }),
        (Q.updateQueue = t),
        (t.lastEffect = e.next = e))
      : ((n = t.lastEffect),
        n === null
          ? (t.lastEffect = e.next = e)
          : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e))),
    e
  );
}
function Bu() {
  return Le().memoizedState;
}
function Ur(e, t, n, r) {
  var l = Be();
  ((Q.flags |= e),
    (l.memoizedState = ar(1 | t, n, void 0, r === void 0 ? null : r)));
}
function Pl(e, t, n, r) {
  var l = Le();
  r = r === void 0 ? null : r;
  var o = void 0;
  if (X !== null) {
    var i = X.memoizedState;
    if (((o = i.destroy), r !== null && Oi(r, i.deps))) {
      l.memoizedState = ar(t, n, o, r);
      return;
    }
  }
  ((Q.flags |= e), (l.memoizedState = ar(1 | t, n, o, r)));
}
function Bs(e, t) {
  return Ur(8390656, 8, e, t);
}
function Di(e, t) {
  return Pl(2048, 8, e, t);
}
function Vu(e, t) {
  return Pl(4, 2, e, t);
}
function Uu(e, t) {
  return Pl(4, 4, e, t);
}
function Wu(e, t) {
  if (typeof t == "function")
    return (
      (e = e()),
      t(e),
      function () {
        t(null);
      }
    );
  if (t != null)
    return (
      (e = e()),
      (t.current = e),
      function () {
        t.current = null;
      }
    );
}
function Hu(e, t, n) {
  return (
    (n = n != null ? n.concat([e]) : null),
    Pl(4, 4, Wu.bind(null, t, e), n)
  );
}
function Ii() {}
function Qu(e, t) {
  var n = Le();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && Oi(t, r[1])
    ? r[0]
    : ((n.memoizedState = [e, t]), e);
}
function Gu(e, t) {
  var n = Le();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && Oi(t, r[1])
    ? r[0]
    : ((e = e()), (n.memoizedState = [e, t]), e);
}
function Ku(e, t, n) {
  return Dt & 21
    ? (De(n, t) || ((n = Ja()), (Q.lanes |= n), (It |= n), (e.baseState = !0)),
      t)
    : (e.baseState && ((e.baseState = !1), (he = !0)), (e.memoizedState = n));
}
function Wf(e, t) {
  var n = D;
  ((D = n !== 0 && 4 > n ? n : 4), e(!0));
  var r = eo.transition;
  eo.transition = {};
  try {
    (e(!1), t());
  } finally {
    ((D = n), (eo.transition = r));
  }
}
function qu() {
  return Le().memoizedState;
}
function Hf(e, t, n) {
  var r = wt(e);
  if (
    ((n = {
      lane: r,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    }),
    Yu(e))
  )
    Xu(t, n);
  else if (((n = Lu(e, t, n, r)), n !== null)) {
    var l = de();
    (Ae(n, e, r, l), Zu(n, t, r));
  }
}
function Qf(e, t, n) {
  var r = wt(e),
    l = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (Yu(e)) Xu(t, l);
  else {
    var o = e.alternate;
    if (
      e.lanes === 0 &&
      (o === null || o.lanes === 0) &&
      ((o = t.lastRenderedReducer), o !== null)
    )
      try {
        var i = t.lastRenderedState,
          s = o(i, n);
        if (((l.hasEagerState = !0), (l.eagerState = s), De(s, i))) {
          var a = t.interleaved;
          (a === null
            ? ((l.next = l), ji(t))
            : ((l.next = a.next), (a.next = l)),
            (t.interleaved = l));
          return;
        }
      } catch {
      } finally {
      }
    ((n = Lu(e, t, l, r)),
      n !== null && ((l = de()), Ae(n, e, r, l), Zu(n, t, r)));
  }
}
function Yu(e) {
  var t = e.alternate;
  return e === Q || (t !== null && t === Q);
}
function Xu(e, t) {
  Vn = dl = !0;
  var n = e.pending;
  (n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)),
    (e.pending = t));
}
function Zu(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    ((r &= e.pendingLanes), (n |= r), (t.lanes = n), gi(e, n));
  }
}
var fl = {
    readContext: je,
    useCallback: oe,
    useContext: oe,
    useEffect: oe,
    useImperativeHandle: oe,
    useInsertionEffect: oe,
    useLayoutEffect: oe,
    useMemo: oe,
    useReducer: oe,
    useRef: oe,
    useState: oe,
    useDebugValue: oe,
    useDeferredValue: oe,
    useTransition: oe,
    useMutableSource: oe,
    useSyncExternalStore: oe,
    useId: oe,
    unstable_isNewReconciler: !1,
  },
  Gf = {
    readContext: je,
    useCallback: function (e, t) {
      return ((Be().memoizedState = [e, t === void 0 ? null : t]), e);
    },
    useContext: je,
    useEffect: Bs,
    useImperativeHandle: function (e, t, n) {
      return (
        (n = n != null ? n.concat([e]) : null),
        Ur(4194308, 4, Wu.bind(null, t, e), n)
      );
    },
    useLayoutEffect: function (e, t) {
      return Ur(4194308, 4, e, t);
    },
    useInsertionEffect: function (e, t) {
      return Ur(4, 2, e, t);
    },
    useMemo: function (e, t) {
      var n = Be();
      return (
        (t = t === void 0 ? null : t),
        (e = e()),
        (n.memoizedState = [e, t]),
        e
      );
    },
    useReducer: function (e, t, n) {
      var r = Be();
      return (
        (t = n !== void 0 ? n(t) : t),
        (r.memoizedState = r.baseState = t),
        (e = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: e,
          lastRenderedState: t,
        }),
        (r.queue = e),
        (e = e.dispatch = Hf.bind(null, Q, e)),
        [r.memoizedState, e]
      );
    },
    useRef: function (e) {
      var t = Be();
      return ((e = { current: e }), (t.memoizedState = e));
    },
    useState: $s,
    useDebugValue: Ii,
    useDeferredValue: function (e) {
      return (Be().memoizedState = e);
    },
    useTransition: function () {
      var e = $s(!1),
        t = e[0];
      return ((e = Wf.bind(null, e[1])), (Be().memoizedState = e), [t, e]);
    },
    useMutableSource: function () {},
    useSyncExternalStore: function (e, t, n) {
      var r = Q,
        l = Be();
      if (W) {
        if (n === void 0) throw Error(x(407));
        n = n();
      } else {
        if (((n = t()), te === null)) throw Error(x(349));
        Dt & 30 || Mu(r, t, n);
      }
      l.memoizedState = n;
      var o = { value: n, getSnapshot: t };
      return (
        (l.queue = o),
        Bs(Du.bind(null, r, o, e), [e]),
        (r.flags |= 2048),
        ar(9, Au.bind(null, r, o, n, t), void 0, null),
        n
      );
    },
    useId: function () {
      var e = Be(),
        t = te.identifierPrefix;
      if (W) {
        var n = qe,
          r = Ke;
        ((n = (r & ~(1 << (32 - Me(r) - 1))).toString(32) + n),
          (t = ":" + t + "R" + n),
          (n = ir++),
          0 < n && (t += "H" + n.toString(32)),
          (t += ":"));
      } else ((n = Uf++), (t = ":" + t + "r" + n.toString(32) + ":"));
      return (e.memoizedState = t);
    },
    unstable_isNewReconciler: !1,
  },
  Kf = {
    readContext: je,
    useCallback: Qu,
    useContext: je,
    useEffect: Di,
    useImperativeHandle: Hu,
    useInsertionEffect: Vu,
    useLayoutEffect: Uu,
    useMemo: Gu,
    useReducer: to,
    useRef: Bu,
    useState: function () {
      return to(sr);
    },
    useDebugValue: Ii,
    useDeferredValue: function (e) {
      var t = Le();
      return Ku(t, X.memoizedState, e);
    },
    useTransition: function () {
      var e = to(sr)[0],
        t = Le().memoizedState;
      return [e, t];
    },
    useMutableSource: Fu,
    useSyncExternalStore: Ou,
    useId: qu,
    unstable_isNewReconciler: !1,
  },
  qf = {
    readContext: je,
    useCallback: Qu,
    useContext: je,
    useEffect: Di,
    useImperativeHandle: Hu,
    useInsertionEffect: Vu,
    useLayoutEffect: Uu,
    useMemo: Gu,
    useReducer: no,
    useRef: Bu,
    useState: function () {
      return no(sr);
    },
    useDebugValue: Ii,
    useDeferredValue: function (e) {
      var t = Le();
      return X === null ? (t.memoizedState = e) : Ku(t, X.memoizedState, e);
    },
    useTransition: function () {
      var e = no(sr)[0],
        t = Le().memoizedState;
      return [e, t];
    },
    useMutableSource: Fu,
    useSyncExternalStore: Ou,
    useId: qu,
    unstable_isNewReconciler: !1,
  };
function be(e, t) {
  if (e && e.defaultProps) {
    ((t = G({}, t)), (e = e.defaultProps));
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
function Io(e, t, n, r) {
  ((t = e.memoizedState),
    (n = n(r, t)),
    (n = n == null ? t : G({}, t, n)),
    (e.memoizedState = n),
    e.lanes === 0 && (e.updateQueue.baseState = n));
}
var Nl = {
  isMounted: function (e) {
    return (e = e._reactInternals) ? Vt(e) === e : !1;
  },
  enqueueSetState: function (e, t, n) {
    e = e._reactInternals;
    var r = de(),
      l = wt(e),
      o = Ye(r, l);
    ((o.payload = t),
      n != null && (o.callback = n),
      (t = vt(e, o, l)),
      t !== null && (Ae(t, e, l, r), Br(t, e, l)));
  },
  enqueueReplaceState: function (e, t, n) {
    e = e._reactInternals;
    var r = de(),
      l = wt(e),
      o = Ye(r, l);
    ((o.tag = 1),
      (o.payload = t),
      n != null && (o.callback = n),
      (t = vt(e, o, l)),
      t !== null && (Ae(t, e, l, r), Br(t, e, l)));
  },
  enqueueForceUpdate: function (e, t) {
    e = e._reactInternals;
    var n = de(),
      r = wt(e),
      l = Ye(n, r);
    ((l.tag = 2),
      t != null && (l.callback = t),
      (t = vt(e, l, r)),
      t !== null && (Ae(t, e, r, n), Br(t, e, r)));
  },
};
function Vs(e, t, n, r, l, o, i) {
  return (
    (e = e.stateNode),
    typeof e.shouldComponentUpdate == "function"
      ? e.shouldComponentUpdate(r, o, i)
      : t.prototype && t.prototype.isPureReactComponent
        ? !er(n, r) || !er(l, o)
        : !0
  );
}
function Ju(e, t, n) {
  var r = !1,
    l = kt,
    o = t.contextType;
  return (
    typeof o == "object" && o !== null
      ? (o = je(o))
      : ((l = ve(t) ? Mt : ae.current),
        (r = t.contextTypes),
        (o = (r = r != null) ? pn(e, l) : kt)),
    (t = new t(n, o)),
    (e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null),
    (t.updater = Nl),
    (e.stateNode = t),
    (t._reactInternals = e),
    r &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = l),
      (e.__reactInternalMemoizedMaskedChildContext = o)),
    t
  );
}
function Us(e, t, n, r) {
  ((e = t.state),
    typeof t.componentWillReceiveProps == "function" &&
      t.componentWillReceiveProps(n, r),
    typeof t.UNSAFE_componentWillReceiveProps == "function" &&
      t.UNSAFE_componentWillReceiveProps(n, r),
    t.state !== e && Nl.enqueueReplaceState(t, t.state, null));
}
function $o(e, t, n, r) {
  var l = e.stateNode;
  ((l.props = n), (l.state = e.memoizedState), (l.refs = {}), Li(e));
  var o = t.contextType;
  (typeof o == "object" && o !== null
    ? (l.context = je(o))
    : ((o = ve(t) ? Mt : ae.current), (l.context = pn(e, o))),
    (l.state = e.memoizedState),
    (o = t.getDerivedStateFromProps),
    typeof o == "function" && (Io(e, t, o, n), (l.state = e.memoizedState)),
    typeof t.getDerivedStateFromProps == "function" ||
      typeof l.getSnapshotBeforeUpdate == "function" ||
      (typeof l.UNSAFE_componentWillMount != "function" &&
        typeof l.componentWillMount != "function") ||
      ((t = l.state),
      typeof l.componentWillMount == "function" && l.componentWillMount(),
      typeof l.UNSAFE_componentWillMount == "function" &&
        l.UNSAFE_componentWillMount(),
      t !== l.state && Nl.enqueueReplaceState(l, l.state, null),
      ul(e, n, l, r),
      (l.state = e.memoizedState)),
    typeof l.componentDidMount == "function" && (e.flags |= 4194308));
}
function vn(e, t) {
  try {
    var n = "",
      r = t;
    do ((n += kd(r)), (r = r.return));
    while (r);
    var l = n;
  } catch (o) {
    l =
      `
Error generating stack: ` +
      o.message +
      `
` +
      o.stack;
  }
  return { value: e, source: t, stack: l, digest: null };
}
function ro(e, t, n) {
  return { value: e, source: null, stack: n ?? null, digest: t ?? null };
}
function Bo(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function () {
      throw n;
    });
  }
}
var Yf = typeof WeakMap == "function" ? WeakMap : Map;
function ec(e, t, n) {
  ((n = Ye(-1, n)), (n.tag = 3), (n.payload = { element: null }));
  var r = t.value;
  return (
    (n.callback = function () {
      (ml || ((ml = !0), (Xo = r)), Bo(e, t));
    }),
    n
  );
}
function tc(e, t, n) {
  ((n = Ye(-1, n)), (n.tag = 3));
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var l = t.value;
    ((n.payload = function () {
      return r(l);
    }),
      (n.callback = function () {
        Bo(e, t);
      }));
  }
  var o = e.stateNode;
  return (
    o !== null &&
      typeof o.componentDidCatch == "function" &&
      (n.callback = function () {
        (Bo(e, t),
          typeof r != "function" &&
            (yt === null ? (yt = new Set([this])) : yt.add(this)));
        var i = t.stack;
        this.componentDidCatch(t.value, {
          componentStack: i !== null ? i : "",
        });
      }),
    n
  );
}
function Ws(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new Yf();
    var l = new Set();
    r.set(t, l);
  } else ((l = r.get(t)), l === void 0 && ((l = new Set()), r.set(t, l)));
  l.has(n) || (l.add(n), (e = cp.bind(null, e, t, n)), t.then(e, e));
}
function Hs(e) {
  do {
    var t;
    if (
      ((t = e.tag === 13) &&
        ((t = e.memoizedState), (t = t !== null ? t.dehydrated !== null : !0)),
      t)
    )
      return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function Qs(e, t, n, r, l) {
  return e.mode & 1
    ? ((e.flags |= 65536), (e.lanes = l), e)
    : (e === t
        ? (e.flags |= 65536)
        : ((e.flags |= 128),
          (n.flags |= 131072),
          (n.flags &= -52805),
          n.tag === 1 &&
            (n.alternate === null
              ? (n.tag = 17)
              : ((t = Ye(-1, 1)), (t.tag = 2), vt(n, t, 1))),
          (n.lanes |= 1)),
      e);
}
var Xf = tt.ReactCurrentOwner,
  he = !1;
function ce(e, t, n, r) {
  t.child = e === null ? ju(t, null, n, r) : hn(t, e.child, n, r);
}
function Gs(e, t, n, r, l) {
  n = n.render;
  var o = t.ref;
  return (
    un(t, l),
    (r = Mi(e, t, n, r, o, l)),
    (n = Ai()),
    e !== null && !he
      ? ((t.updateQueue = e.updateQueue),
        (t.flags &= -2053),
        (e.lanes &= ~l),
        et(e, t, l))
      : (W && n && Ei(t), (t.flags |= 1), ce(e, t, r, l), t.child)
  );
}
function Ks(e, t, n, r, l) {
  if (e === null) {
    var o = n.type;
    return typeof o == "function" &&
      !Gi(o) &&
      o.defaultProps === void 0 &&
      n.compare === null &&
      n.defaultProps === void 0
      ? ((t.tag = 15), (t.type = o), nc(e, t, o, r, l))
      : ((e = Gr(n.type, null, r, t, t.mode, l)),
        (e.ref = t.ref),
        (e.return = t),
        (t.child = e));
  }
  if (((o = e.child), !(e.lanes & l))) {
    var i = o.memoizedProps;
    if (
      ((n = n.compare), (n = n !== null ? n : er), n(i, r) && e.ref === t.ref)
    )
      return et(e, t, l);
  }
  return (
    (t.flags |= 1),
    (e = xt(o, r)),
    (e.ref = t.ref),
    (e.return = t),
    (t.child = e)
  );
}
function nc(e, t, n, r, l) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (er(o, r) && e.ref === t.ref)
      if (((he = !1), (t.pendingProps = r = o), (e.lanes & l) !== 0))
        e.flags & 131072 && (he = !0);
      else return ((t.lanes = e.lanes), et(e, t, l));
  }
  return Vo(e, t, n, r, l);
}
function rc(e, t, n) {
  var r = t.pendingProps,
    l = r.children,
    o = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden")
    if (!(t.mode & 1))
      ((t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
        I(rn, we),
        (we |= n));
    else {
      if (!(n & 1073741824))
        return (
          (e = o !== null ? o.baseLanes | n : n),
          (t.lanes = t.childLanes = 1073741824),
          (t.memoizedState = {
            baseLanes: e,
            cachePool: null,
            transitions: null,
          }),
          (t.updateQueue = null),
          I(rn, we),
          (we |= e),
          null
        );
      ((t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
        (r = o !== null ? o.baseLanes : n),
        I(rn, we),
        (we |= r));
    }
  else
    (o !== null ? ((r = o.baseLanes | n), (t.memoizedState = null)) : (r = n),
      I(rn, we),
      (we |= r));
  return (ce(e, t, l, n), t.child);
}
function lc(e, t) {
  var n = t.ref;
  ((e === null && n !== null) || (e !== null && e.ref !== n)) &&
    ((t.flags |= 512), (t.flags |= 2097152));
}
function Vo(e, t, n, r, l) {
  var o = ve(n) ? Mt : ae.current;
  return (
    (o = pn(t, o)),
    un(t, l),
    (n = Mi(e, t, n, r, o, l)),
    (r = Ai()),
    e !== null && !he
      ? ((t.updateQueue = e.updateQueue),
        (t.flags &= -2053),
        (e.lanes &= ~l),
        et(e, t, l))
      : (W && r && Ei(t), (t.flags |= 1), ce(e, t, n, l), t.child)
  );
}
function qs(e, t, n, r, l) {
  if (ve(n)) {
    var o = !0;
    ll(t);
  } else o = !1;
  if ((un(t, l), t.stateNode === null))
    (Wr(e, t), Ju(t, n, r), $o(t, n, r, l), (r = !0));
  else if (e === null) {
    var i = t.stateNode,
      s = t.memoizedProps;
    i.props = s;
    var a = i.context,
      c = n.contextType;
    typeof c == "object" && c !== null
      ? (c = je(c))
      : ((c = ve(n) ? Mt : ae.current), (c = pn(t, c)));
    var p = n.getDerivedStateFromProps,
      h =
        typeof p == "function" ||
        typeof i.getSnapshotBeforeUpdate == "function";
    (h ||
      (typeof i.UNSAFE_componentWillReceiveProps != "function" &&
        typeof i.componentWillReceiveProps != "function") ||
      ((s !== r || a !== c) && Us(t, i, r, c)),
      (at = !1));
    var m = t.memoizedState;
    ((i.state = m),
      ul(t, r, i, l),
      (a = t.memoizedState),
      s !== r || m !== a || ge.current || at
        ? (typeof p == "function" && (Io(t, n, p, r), (a = t.memoizedState)),
          (s = at || Vs(t, n, s, r, m, a, c))
            ? (h ||
                (typeof i.UNSAFE_componentWillMount != "function" &&
                  typeof i.componentWillMount != "function") ||
                (typeof i.componentWillMount == "function" &&
                  i.componentWillMount(),
                typeof i.UNSAFE_componentWillMount == "function" &&
                  i.UNSAFE_componentWillMount()),
              typeof i.componentDidMount == "function" && (t.flags |= 4194308))
            : (typeof i.componentDidMount == "function" && (t.flags |= 4194308),
              (t.memoizedProps = r),
              (t.memoizedState = a)),
          (i.props = r),
          (i.state = a),
          (i.context = c),
          (r = s))
        : (typeof i.componentDidMount == "function" && (t.flags |= 4194308),
          (r = !1)));
  } else {
    ((i = t.stateNode),
      Ru(e, t),
      (s = t.memoizedProps),
      (c = t.type === t.elementType ? s : be(t.type, s)),
      (i.props = c),
      (h = t.pendingProps),
      (m = i.context),
      (a = n.contextType),
      typeof a == "object" && a !== null
        ? (a = je(a))
        : ((a = ve(n) ? Mt : ae.current), (a = pn(t, a))));
    var v = n.getDerivedStateFromProps;
    ((p =
      typeof v == "function" ||
      typeof i.getSnapshotBeforeUpdate == "function") ||
      (typeof i.UNSAFE_componentWillReceiveProps != "function" &&
        typeof i.componentWillReceiveProps != "function") ||
      ((s !== h || m !== a) && Us(t, i, r, a)),
      (at = !1),
      (m = t.memoizedState),
      (i.state = m),
      ul(t, r, i, l));
    var w = t.memoizedState;
    s !== h || m !== w || ge.current || at
      ? (typeof v == "function" && (Io(t, n, v, r), (w = t.memoizedState)),
        (c = at || Vs(t, n, c, r, m, w, a) || !1)
          ? (p ||
              (typeof i.UNSAFE_componentWillUpdate != "function" &&
                typeof i.componentWillUpdate != "function") ||
              (typeof i.componentWillUpdate == "function" &&
                i.componentWillUpdate(r, w, a),
              typeof i.UNSAFE_componentWillUpdate == "function" &&
                i.UNSAFE_componentWillUpdate(r, w, a)),
            typeof i.componentDidUpdate == "function" && (t.flags |= 4),
            typeof i.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024))
          : (typeof i.componentDidUpdate != "function" ||
              (s === e.memoizedProps && m === e.memoizedState) ||
              (t.flags |= 4),
            typeof i.getSnapshotBeforeUpdate != "function" ||
              (s === e.memoizedProps && m === e.memoizedState) ||
              (t.flags |= 1024),
            (t.memoizedProps = r),
            (t.memoizedState = w)),
        (i.props = r),
        (i.state = w),
        (i.context = a),
        (r = c))
      : (typeof i.componentDidUpdate != "function" ||
          (s === e.memoizedProps && m === e.memoizedState) ||
          (t.flags |= 4),
        typeof i.getSnapshotBeforeUpdate != "function" ||
          (s === e.memoizedProps && m === e.memoizedState) ||
          (t.flags |= 1024),
        (r = !1));
  }
  return Uo(e, t, n, r, o, l);
}
function Uo(e, t, n, r, l, o) {
  lc(e, t);
  var i = (t.flags & 128) !== 0;
  if (!r && !i) return (l && Fs(t, n, !1), et(e, t, o));
  ((r = t.stateNode), (Xf.current = t));
  var s =
    i && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return (
    (t.flags |= 1),
    e !== null && i
      ? ((t.child = hn(t, e.child, null, o)), (t.child = hn(t, null, s, o)))
      : ce(e, t, s, o),
    (t.memoizedState = r.state),
    l && Fs(t, n, !0),
    t.child
  );
}
function oc(e) {
  var t = e.stateNode;
  (t.pendingContext
    ? bs(e, t.pendingContext, t.pendingContext !== t.context)
    : t.context && bs(e, t.context, !1),
    Ri(e, t.containerInfo));
}
function Ys(e, t, n, r, l) {
  return (mn(), Ni(l), (t.flags |= 256), ce(e, t, n, r), t.child);
}
var Wo = { dehydrated: null, treeContext: null, retryLane: 0 };
function Ho(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function ic(e, t, n) {
  var r = t.pendingProps,
    l = H.current,
    o = !1,
    i = (t.flags & 128) !== 0,
    s;
  if (
    ((s = i) ||
      (s = e !== null && e.memoizedState === null ? !1 : (l & 2) !== 0),
    s
      ? ((o = !0), (t.flags &= -129))
      : (e === null || e.memoizedState !== null) && (l |= 1),
    I(H, l & 1),
    e === null)
  )
    return (
      Ao(t),
      (e = t.memoizedState),
      e !== null && ((e = e.dehydrated), e !== null)
        ? (t.mode & 1
            ? e.data === "$!"
              ? (t.lanes = 8)
              : (t.lanes = 1073741824)
            : (t.lanes = 1),
          null)
        : ((i = r.children),
          (e = r.fallback),
          o
            ? ((r = t.mode),
              (o = t.child),
              (i = { mode: "hidden", children: i }),
              !(r & 1) && o !== null
                ? ((o.childLanes = 0), (o.pendingProps = i))
                : (o = Tl(i, r, 0, null)),
              (e = Ot(e, r, n, null)),
              (o.return = t),
              (e.return = t),
              (o.sibling = e),
              (t.child = o),
              (t.child.memoizedState = Ho(n)),
              (t.memoizedState = Wo),
              e)
            : $i(t, i))
    );
  if (((l = e.memoizedState), l !== null && ((s = l.dehydrated), s !== null)))
    return Zf(e, t, i, r, s, l, n);
  if (o) {
    ((o = r.fallback), (i = t.mode), (l = e.child), (s = l.sibling));
    var a = { mode: "hidden", children: r.children };
    return (
      !(i & 1) && t.child !== l
        ? ((r = t.child),
          (r.childLanes = 0),
          (r.pendingProps = a),
          (t.deletions = null))
        : ((r = xt(l, a)), (r.subtreeFlags = l.subtreeFlags & 14680064)),
      s !== null ? (o = xt(s, o)) : ((o = Ot(o, i, n, null)), (o.flags |= 2)),
      (o.return = t),
      (r.return = t),
      (r.sibling = o),
      (t.child = r),
      (r = o),
      (o = t.child),
      (i = e.child.memoizedState),
      (i =
        i === null
          ? Ho(n)
          : {
              baseLanes: i.baseLanes | n,
              cachePool: null,
              transitions: i.transitions,
            }),
      (o.memoizedState = i),
      (o.childLanes = e.childLanes & ~n),
      (t.memoizedState = Wo),
      r
    );
  }
  return (
    (o = e.child),
    (e = o.sibling),
    (r = xt(o, { mode: "visible", children: r.children })),
    !(t.mode & 1) && (r.lanes = n),
    (r.return = t),
    (r.sibling = null),
    e !== null &&
      ((n = t.deletions),
      n === null ? ((t.deletions = [e]), (t.flags |= 16)) : n.push(e)),
    (t.child = r),
    (t.memoizedState = null),
    r
  );
}
function $i(e, t) {
  return (
    (t = Tl({ mode: "visible", children: t }, e.mode, 0, null)),
    (t.return = e),
    (e.child = t)
  );
}
function Lr(e, t, n, r) {
  return (
    r !== null && Ni(r),
    hn(t, e.child, null, n),
    (e = $i(t, t.pendingProps.children)),
    (e.flags |= 2),
    (t.memoizedState = null),
    e
  );
}
function Zf(e, t, n, r, l, o, i) {
  if (n)
    return t.flags & 256
      ? ((t.flags &= -257), (r = ro(Error(x(422)))), Lr(e, t, i, r))
      : t.memoizedState !== null
        ? ((t.child = e.child), (t.flags |= 128), null)
        : ((o = r.fallback),
          (l = t.mode),
          (r = Tl({ mode: "visible", children: r.children }, l, 0, null)),
          (o = Ot(o, l, i, null)),
          (o.flags |= 2),
          (r.return = t),
          (o.return = t),
          (r.sibling = o),
          (t.child = r),
          t.mode & 1 && hn(t, e.child, null, i),
          (t.child.memoizedState = Ho(i)),
          (t.memoizedState = Wo),
          o);
  if (!(t.mode & 1)) return Lr(e, t, i, null);
  if (l.data === "$!") {
    if (((r = l.nextSibling && l.nextSibling.dataset), r)) var s = r.dgst;
    return (
      (r = s),
      (o = Error(x(419))),
      (r = ro(o, r, void 0)),
      Lr(e, t, i, r)
    );
  }
  if (((s = (i & e.childLanes) !== 0), he || s)) {
    if (((r = te), r !== null)) {
      switch (i & -i) {
        case 4:
          l = 2;
          break;
        case 16:
          l = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          l = 32;
          break;
        case 536870912:
          l = 268435456;
          break;
        default:
          l = 0;
      }
      ((l = l & (r.suspendedLanes | i) ? 0 : l),
        l !== 0 &&
          l !== o.retryLane &&
          ((o.retryLane = l), Je(e, l), Ae(r, e, l, -1)));
    }
    return (Qi(), (r = ro(Error(x(421)))), Lr(e, t, i, r));
  }
  return l.data === "$?"
    ? ((t.flags |= 128),
      (t.child = e.child),
      (t = dp.bind(null, e)),
      (l._reactRetry = t),
      null)
    : ((e = o.treeContext),
      (xe = gt(l.nextSibling)),
      (Se = t),
      (W = !0),
      (Oe = null),
      e !== null &&
        ((Pe[Ne++] = Ke),
        (Pe[Ne++] = qe),
        (Pe[Ne++] = At),
        (Ke = e.id),
        (qe = e.overflow),
        (At = t)),
      (t = $i(t, r.children)),
      (t.flags |= 4096),
      t);
}
function Xs(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  (r !== null && (r.lanes |= t), Do(e.return, t, n));
}
function lo(e, t, n, r, l) {
  var o = e.memoizedState;
  o === null
    ? (e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: r,
        tail: n,
        tailMode: l,
      })
    : ((o.isBackwards = t),
      (o.rendering = null),
      (o.renderingStartTime = 0),
      (o.last = r),
      (o.tail = n),
      (o.tailMode = l));
}
function sc(e, t, n) {
  var r = t.pendingProps,
    l = r.revealOrder,
    o = r.tail;
  if ((ce(e, t, r.children, n), (r = H.current), r & 2))
    ((r = (r & 1) | 2), (t.flags |= 128));
  else {
    if (e !== null && e.flags & 128)
      e: for (e = t.child; e !== null; ) {
        if (e.tag === 13) e.memoizedState !== null && Xs(e, n, t);
        else if (e.tag === 19) Xs(e, n, t);
        else if (e.child !== null) {
          ((e.child.return = e), (e = e.child));
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) break e;
          e = e.return;
        }
        ((e.sibling.return = e.return), (e = e.sibling));
      }
    r &= 1;
  }
  if ((I(H, r), !(t.mode & 1))) t.memoizedState = null;
  else
    switch (l) {
      case "forwards":
        for (n = t.child, l = null; n !== null; )
          ((e = n.alternate),
            e !== null && cl(e) === null && (l = n),
            (n = n.sibling));
        ((n = l),
          n === null
            ? ((l = t.child), (t.child = null))
            : ((l = n.sibling), (n.sibling = null)),
          lo(t, !1, l, n, o));
        break;
      case "backwards":
        for (n = null, l = t.child, t.child = null; l !== null; ) {
          if (((e = l.alternate), e !== null && cl(e) === null)) {
            t.child = l;
            break;
          }
          ((e = l.sibling), (l.sibling = n), (n = l), (l = e));
        }
        lo(t, !0, n, null, o);
        break;
      case "together":
        lo(t, !1, null, null, void 0);
        break;
      default:
        t.memoizedState = null;
    }
  return t.child;
}
function Wr(e, t) {
  !(t.mode & 1) &&
    e !== null &&
    ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
}
function et(e, t, n) {
  if (
    (e !== null && (t.dependencies = e.dependencies),
    (It |= t.lanes),
    !(n & t.childLanes))
  )
    return null;
  if (e !== null && t.child !== e.child) throw Error(x(153));
  if (t.child !== null) {
    for (
      e = t.child, n = xt(e, e.pendingProps), t.child = n, n.return = t;
      e.sibling !== null;

    )
      ((e = e.sibling),
        (n = n.sibling = xt(e, e.pendingProps)),
        (n.return = t));
    n.sibling = null;
  }
  return t.child;
}
function Jf(e, t, n) {
  switch (t.tag) {
    case 3:
      (oc(t), mn());
      break;
    case 5:
      bu(t);
      break;
    case 1:
      ve(t.type) && ll(t);
      break;
    case 4:
      Ri(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context,
        l = t.memoizedProps.value;
      (I(sl, r._currentValue), (r._currentValue = l));
      break;
    case 13:
      if (((r = t.memoizedState), r !== null))
        return r.dehydrated !== null
          ? (I(H, H.current & 1), (t.flags |= 128), null)
          : n & t.child.childLanes
            ? ic(e, t, n)
            : (I(H, H.current & 1),
              (e = et(e, t, n)),
              e !== null ? e.sibling : null);
      I(H, H.current & 1);
      break;
    case 19:
      if (((r = (n & t.childLanes) !== 0), e.flags & 128)) {
        if (r) return sc(e, t, n);
        t.flags |= 128;
      }
      if (
        ((l = t.memoizedState),
        l !== null &&
          ((l.rendering = null), (l.tail = null), (l.lastEffect = null)),
        I(H, H.current),
        r)
      )
        break;
      return null;
    case 22:
    case 23:
      return ((t.lanes = 0), rc(e, t, n));
  }
  return et(e, t, n);
}
var ac, Qo, uc, cc;
ac = function (e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      ((n.child.return = n), (n = n.child));
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    ((n.sibling.return = n.return), (n = n.sibling));
  }
};
Qo = function () {};
uc = function (e, t, n, r) {
  var l = e.memoizedProps;
  if (l !== r) {
    ((e = t.stateNode), bt(We.current));
    var o = null;
    switch (n) {
      case "input":
        ((l = mo(e, l)), (r = mo(e, r)), (o = []));
        break;
      case "select":
        ((l = G({}, l, { value: void 0 })),
          (r = G({}, r, { value: void 0 })),
          (o = []));
        break;
      case "textarea":
        ((l = vo(e, l)), (r = vo(e, r)), (o = []));
        break;
      default:
        typeof l.onClick != "function" &&
          typeof r.onClick == "function" &&
          (e.onclick = nl);
    }
    wo(n, r);
    var i;
    n = null;
    for (c in l)
      if (!r.hasOwnProperty(c) && l.hasOwnProperty(c) && l[c] != null)
        if (c === "style") {
          var s = l[c];
          for (i in s) s.hasOwnProperty(i) && (n || (n = {}), (n[i] = ""));
        } else
          c !== "dangerouslySetInnerHTML" &&
            c !== "children" &&
            c !== "suppressContentEditableWarning" &&
            c !== "suppressHydrationWarning" &&
            c !== "autoFocus" &&
            (Gn.hasOwnProperty(c)
              ? o || (o = [])
              : (o = o || []).push(c, null));
    for (c in r) {
      var a = r[c];
      if (
        ((s = l != null ? l[c] : void 0),
        r.hasOwnProperty(c) && a !== s && (a != null || s != null))
      )
        if (c === "style")
          if (s) {
            for (i in s)
              !s.hasOwnProperty(i) ||
                (a && a.hasOwnProperty(i)) ||
                (n || (n = {}), (n[i] = ""));
            for (i in a)
              a.hasOwnProperty(i) &&
                s[i] !== a[i] &&
                (n || (n = {}), (n[i] = a[i]));
          } else (n || (o || (o = []), o.push(c, n)), (n = a));
        else
          c === "dangerouslySetInnerHTML"
            ? ((a = a ? a.__html : void 0),
              (s = s ? s.__html : void 0),
              a != null && s !== a && (o = o || []).push(c, a))
            : c === "children"
              ? (typeof a != "string" && typeof a != "number") ||
                (o = o || []).push(c, "" + a)
              : c !== "suppressContentEditableWarning" &&
                c !== "suppressHydrationWarning" &&
                (Gn.hasOwnProperty(c)
                  ? (a != null && c === "onScroll" && V("scroll", e),
                    o || s === a || (o = []))
                  : (o = o || []).push(c, a));
    }
    n && (o = o || []).push("style", n);
    var c = o;
    (t.updateQueue = c) && (t.flags |= 4);
  }
};
cc = function (e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function Tn(e, t) {
  if (!W)
    switch (e.tailMode) {
      case "hidden":
        t = e.tail;
        for (var n = null; t !== null; )
          (t.alternate !== null && (n = t), (t = t.sibling));
        n === null ? (e.tail = null) : (n.sibling = null);
        break;
      case "collapsed":
        n = e.tail;
        for (var r = null; n !== null; )
          (n.alternate !== null && (r = n), (n = n.sibling));
        r === null
          ? t || e.tail === null
            ? (e.tail = null)
            : (e.tail.sibling = null)
          : (r.sibling = null);
    }
}
function ie(e) {
  var t = e.alternate !== null && e.alternate.child === e.child,
    n = 0,
    r = 0;
  if (t)
    for (var l = e.child; l !== null; )
      ((n |= l.lanes | l.childLanes),
        (r |= l.subtreeFlags & 14680064),
        (r |= l.flags & 14680064),
        (l.return = e),
        (l = l.sibling));
  else
    for (l = e.child; l !== null; )
      ((n |= l.lanes | l.childLanes),
        (r |= l.subtreeFlags),
        (r |= l.flags),
        (l.return = e),
        (l = l.sibling));
  return ((e.subtreeFlags |= r), (e.childLanes = n), t);
}
function ep(e, t, n) {
  var r = t.pendingProps;
  switch ((Pi(t), t.tag)) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return (ie(t), null);
    case 1:
      return (ve(t.type) && rl(), ie(t), null);
    case 3:
      return (
        (r = t.stateNode),
        gn(),
        U(ge),
        U(ae),
        Fi(),
        r.pendingContext &&
          ((r.context = r.pendingContext), (r.pendingContext = null)),
        (e === null || e.child === null) &&
          (Tr(t)
            ? (t.flags |= 4)
            : e === null ||
              (e.memoizedState.isDehydrated && !(t.flags & 256)) ||
              ((t.flags |= 1024), Oe !== null && (ei(Oe), (Oe = null)))),
        Qo(e, t),
        ie(t),
        null
      );
    case 5:
      bi(t);
      var l = bt(or.current);
      if (((n = t.type), e !== null && t.stateNode != null))
        (uc(e, t, n, r, l),
          e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152)));
      else {
        if (!r) {
          if (t.stateNode === null) throw Error(x(166));
          return (ie(t), null);
        }
        if (((e = bt(We.current)), Tr(t))) {
          ((r = t.stateNode), (n = t.type));
          var o = t.memoizedProps;
          switch (((r[Ve] = t), (r[rr] = o), (e = (t.mode & 1) !== 0), n)) {
            case "dialog":
              (V("cancel", r), V("close", r));
              break;
            case "iframe":
            case "object":
            case "embed":
              V("load", r);
              break;
            case "video":
            case "audio":
              for (l = 0; l < Mn.length; l++) V(Mn[l], r);
              break;
            case "source":
              V("error", r);
              break;
            case "img":
            case "image":
            case "link":
              (V("error", r), V("load", r));
              break;
            case "details":
              V("toggle", r);
              break;
            case "input":
              (is(r, o), V("invalid", r));
              break;
            case "select":
              ((r._wrapperState = { wasMultiple: !!o.multiple }),
                V("invalid", r));
              break;
            case "textarea":
              (as(r, o), V("invalid", r));
          }
          (wo(n, o), (l = null));
          for (var i in o)
            if (o.hasOwnProperty(i)) {
              var s = o[i];
              i === "children"
                ? typeof s == "string"
                  ? r.textContent !== s &&
                    (o.suppressHydrationWarning !== !0 &&
                      zr(r.textContent, s, e),
                    (l = ["children", s]))
                  : typeof s == "number" &&
                    r.textContent !== "" + s &&
                    (o.suppressHydrationWarning !== !0 &&
                      zr(r.textContent, s, e),
                    (l = ["children", "" + s]))
                : Gn.hasOwnProperty(i) &&
                  s != null &&
                  i === "onScroll" &&
                  V("scroll", r);
            }
          switch (n) {
            case "input":
              (xr(r), ss(r, o, !0));
              break;
            case "textarea":
              (xr(r), us(r));
              break;
            case "select":
            case "option":
              break;
            default:
              typeof o.onClick == "function" && (r.onclick = nl);
          }
          ((r = l), (t.updateQueue = r), r !== null && (t.flags |= 4));
        } else {
          ((i = l.nodeType === 9 ? l : l.ownerDocument),
            e === "http://www.w3.org/1999/xhtml" && (e = Da(n)),
            e === "http://www.w3.org/1999/xhtml"
              ? n === "script"
                ? ((e = i.createElement("div")),
                  (e.innerHTML = "<script><\/script>"),
                  (e = e.removeChild(e.firstChild)))
                : typeof r.is == "string"
                  ? (e = i.createElement(n, { is: r.is }))
                  : ((e = i.createElement(n)),
                    n === "select" &&
                      ((i = e),
                      r.multiple
                        ? (i.multiple = !0)
                        : r.size && (i.size = r.size)))
              : (e = i.createElementNS(e, n)),
            (e[Ve] = t),
            (e[rr] = r),
            ac(e, t, !1, !1),
            (t.stateNode = e));
          e: {
            switch (((i = xo(n, r)), n)) {
              case "dialog":
                (V("cancel", e), V("close", e), (l = r));
                break;
              case "iframe":
              case "object":
              case "embed":
                (V("load", e), (l = r));
                break;
              case "video":
              case "audio":
                for (l = 0; l < Mn.length; l++) V(Mn[l], e);
                l = r;
                break;
              case "source":
                (V("error", e), (l = r));
                break;
              case "img":
              case "image":
              case "link":
                (V("error", e), V("load", e), (l = r));
                break;
              case "details":
                (V("toggle", e), (l = r));
                break;
              case "input":
                (is(e, r), (l = mo(e, r)), V("invalid", e));
                break;
              case "option":
                l = r;
                break;
              case "select":
                ((e._wrapperState = { wasMultiple: !!r.multiple }),
                  (l = G({}, r, { value: void 0 })),
                  V("invalid", e));
                break;
              case "textarea":
                (as(e, r), (l = vo(e, r)), V("invalid", e));
                break;
              default:
                l = r;
            }
            (wo(n, l), (s = l));
            for (o in s)
              if (s.hasOwnProperty(o)) {
                var a = s[o];
                o === "style"
                  ? Ba(e, a)
                  : o === "dangerouslySetInnerHTML"
                    ? ((a = a ? a.__html : void 0), a != null && Ia(e, a))
                    : o === "children"
                      ? typeof a == "string"
                        ? (n !== "textarea" || a !== "") && Kn(e, a)
                        : typeof a == "number" && Kn(e, "" + a)
                      : o !== "suppressContentEditableWarning" &&
                        o !== "suppressHydrationWarning" &&
                        o !== "autoFocus" &&
                        (Gn.hasOwnProperty(o)
                          ? a != null && o === "onScroll" && V("scroll", e)
                          : a != null && ci(e, o, a, i));
              }
            switch (n) {
              case "input":
                (xr(e), ss(e, r, !1));
                break;
              case "textarea":
                (xr(e), us(e));
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + St(r.value));
                break;
              case "select":
                ((e.multiple = !!r.multiple),
                  (o = r.value),
                  o != null
                    ? ln(e, !!r.multiple, o, !1)
                    : r.defaultValue != null &&
                      ln(e, !!r.multiple, r.defaultValue, !0));
                break;
              default:
                typeof l.onClick == "function" && (e.onclick = nl);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && ((t.flags |= 512), (t.flags |= 2097152));
      }
      return (ie(t), null);
    case 6:
      if (e && t.stateNode != null) cc(e, t, e.memoizedProps, r);
      else {
        if (typeof r != "string" && t.stateNode === null) throw Error(x(166));
        if (((n = bt(or.current)), bt(We.current), Tr(t))) {
          if (
            ((r = t.stateNode),
            (n = t.memoizedProps),
            (r[Ve] = t),
            (o = r.nodeValue !== n) && ((e = Se), e !== null))
          )
            switch (e.tag) {
              case 3:
                zr(r.nodeValue, n, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 &&
                  zr(r.nodeValue, n, (e.mode & 1) !== 0);
            }
          o && (t.flags |= 4);
        } else
          ((r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r)),
            (r[Ve] = t),
            (t.stateNode = r));
      }
      return (ie(t), null);
    case 13:
      if (
        (U(H),
        (r = t.memoizedState),
        e === null ||
          (e.memoizedState !== null && e.memoizedState.dehydrated !== null))
      ) {
        if (W && xe !== null && t.mode & 1 && !(t.flags & 128))
          (zu(), mn(), (t.flags |= 98560), (o = !1));
        else if (((o = Tr(t)), r !== null && r.dehydrated !== null)) {
          if (e === null) {
            if (!o) throw Error(x(318));
            if (
              ((o = t.memoizedState),
              (o = o !== null ? o.dehydrated : null),
              !o)
            )
              throw Error(x(317));
            o[Ve] = t;
          } else
            (mn(),
              !(t.flags & 128) && (t.memoizedState = null),
              (t.flags |= 4));
          (ie(t), (o = !1));
        } else (Oe !== null && (ei(Oe), (Oe = null)), (o = !0));
        if (!o) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128
        ? ((t.lanes = n), t)
        : ((r = r !== null),
          r !== (e !== null && e.memoizedState !== null) &&
            r &&
            ((t.child.flags |= 8192),
            t.mode & 1 &&
              (e === null || H.current & 1 ? Z === 0 && (Z = 3) : Qi())),
          t.updateQueue !== null && (t.flags |= 4),
          ie(t),
          null);
    case 4:
      return (
        gn(),
        Qo(e, t),
        e === null && tr(t.stateNode.containerInfo),
        ie(t),
        null
      );
    case 10:
      return (Ti(t.type._context), ie(t), null);
    case 17:
      return (ve(t.type) && rl(), ie(t), null);
    case 19:
      if ((U(H), (o = t.memoizedState), o === null)) return (ie(t), null);
      if (((r = (t.flags & 128) !== 0), (i = o.rendering), i === null))
        if (r) Tn(o, !1);
        else {
          if (Z !== 0 || (e !== null && e.flags & 128))
            for (e = t.child; e !== null; ) {
              if (((i = cl(e)), i !== null)) {
                for (
                  t.flags |= 128,
                    Tn(o, !1),
                    r = i.updateQueue,
                    r !== null && ((t.updateQueue = r), (t.flags |= 4)),
                    t.subtreeFlags = 0,
                    r = n,
                    n = t.child;
                  n !== null;

                )
                  ((o = n),
                    (e = r),
                    (o.flags &= 14680066),
                    (i = o.alternate),
                    i === null
                      ? ((o.childLanes = 0),
                        (o.lanes = e),
                        (o.child = null),
                        (o.subtreeFlags = 0),
                        (o.memoizedProps = null),
                        (o.memoizedState = null),
                        (o.updateQueue = null),
                        (o.dependencies = null),
                        (o.stateNode = null))
                      : ((o.childLanes = i.childLanes),
                        (o.lanes = i.lanes),
                        (o.child = i.child),
                        (o.subtreeFlags = 0),
                        (o.deletions = null),
                        (o.memoizedProps = i.memoizedProps),
                        (o.memoizedState = i.memoizedState),
                        (o.updateQueue = i.updateQueue),
                        (o.type = i.type),
                        (e = i.dependencies),
                        (o.dependencies =
                          e === null
                            ? null
                            : {
                                lanes: e.lanes,
                                firstContext: e.firstContext,
                              })),
                    (n = n.sibling));
                return (I(H, (H.current & 1) | 2), t.child);
              }
              e = e.sibling;
            }
          o.tail !== null &&
            q() > yn &&
            ((t.flags |= 128), (r = !0), Tn(o, !1), (t.lanes = 4194304));
        }
      else {
        if (!r)
          if (((e = cl(i)), e !== null)) {
            if (
              ((t.flags |= 128),
              (r = !0),
              (n = e.updateQueue),
              n !== null && ((t.updateQueue = n), (t.flags |= 4)),
              Tn(o, !0),
              o.tail === null && o.tailMode === "hidden" && !i.alternate && !W)
            )
              return (ie(t), null);
          } else
            2 * q() - o.renderingStartTime > yn &&
              n !== 1073741824 &&
              ((t.flags |= 128), (r = !0), Tn(o, !1), (t.lanes = 4194304));
        o.isBackwards
          ? ((i.sibling = t.child), (t.child = i))
          : ((n = o.last),
            n !== null ? (n.sibling = i) : (t.child = i),
            (o.last = i));
      }
      return o.tail !== null
        ? ((t = o.tail),
          (o.rendering = t),
          (o.tail = t.sibling),
          (o.renderingStartTime = q()),
          (t.sibling = null),
          (n = H.current),
          I(H, r ? (n & 1) | 2 : n & 1),
          t)
        : (ie(t), null);
    case 22:
    case 23:
      return (
        Hi(),
        (r = t.memoizedState !== null),
        e !== null && (e.memoizedState !== null) !== r && (t.flags |= 8192),
        r && t.mode & 1
          ? we & 1073741824 && (ie(t), t.subtreeFlags & 6 && (t.flags |= 8192))
          : ie(t),
        null
      );
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(x(156, t.tag));
}
function tp(e, t) {
  switch ((Pi(t), t.tag)) {
    case 1:
      return (
        ve(t.type) && rl(),
        (e = t.flags),
        e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
      );
    case 3:
      return (
        gn(),
        U(ge),
        U(ae),
        Fi(),
        (e = t.flags),
        e & 65536 && !(e & 128) ? ((t.flags = (e & -65537) | 128), t) : null
      );
    case 5:
      return (bi(t), null);
    case 13:
      if ((U(H), (e = t.memoizedState), e !== null && e.dehydrated !== null)) {
        if (t.alternate === null) throw Error(x(340));
        mn();
      }
      return (
        (e = t.flags),
        e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
      );
    case 19:
      return (U(H), null);
    case 4:
      return (gn(), null);
    case 10:
      return (Ti(t.type._context), null);
    case 22:
    case 23:
      return (Hi(), null);
    case 24:
      return null;
    default:
      return null;
  }
}
var Rr = !1,
  se = !1,
  np = typeof WeakSet == "function" ? WeakSet : Set,
  _ = null;
function nn(e, t) {
  var n = e.ref;
  if (n !== null)
    if (typeof n == "function")
      try {
        n(null);
      } catch (r) {
        K(e, t, r);
      }
    else n.current = null;
}
function Go(e, t, n) {
  try {
    n();
  } catch (r) {
    K(e, t, r);
  }
}
var Zs = !1;
function rp(e, t) {
  if (((jo = Jr), (e = hu()), Ci(e))) {
    if ("selectionStart" in e)
      var n = { start: e.selectionStart, end: e.selectionEnd };
    else
      e: {
        n = ((n = e.ownerDocument) && n.defaultView) || window;
        var r = n.getSelection && n.getSelection();
        if (r && r.rangeCount !== 0) {
          n = r.anchorNode;
          var l = r.anchorOffset,
            o = r.focusNode;
          r = r.focusOffset;
          try {
            (n.nodeType, o.nodeType);
          } catch {
            n = null;
            break e;
          }
          var i = 0,
            s = -1,
            a = -1,
            c = 0,
            p = 0,
            h = e,
            m = null;
          t: for (;;) {
            for (
              var v;
              h !== n || (l !== 0 && h.nodeType !== 3) || (s = i + l),
                h !== o || (r !== 0 && h.nodeType !== 3) || (a = i + r),
                h.nodeType === 3 && (i += h.nodeValue.length),
                (v = h.firstChild) !== null;

            )
              ((m = h), (h = v));
            for (;;) {
              if (h === e) break t;
              if (
                (m === n && ++c === l && (s = i),
                m === o && ++p === r && (a = i),
                (v = h.nextSibling) !== null)
              )
                break;
              ((h = m), (m = h.parentNode));
            }
            h = v;
          }
          n = s === -1 || a === -1 ? null : { start: s, end: a };
        } else n = null;
      }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (Lo = { focusedElem: e, selectionRange: n }, Jr = !1, _ = t; _ !== null; )
    if (((t = _), (e = t.child), (t.subtreeFlags & 1028) !== 0 && e !== null))
      ((e.return = t), (_ = e));
    else
      for (; _ !== null; ) {
        t = _;
        try {
          var w = t.alternate;
          if (t.flags & 1024)
            switch (t.tag) {
              case 0:
              case 11:
              case 15:
                break;
              case 1:
                if (w !== null) {
                  var g = w.memoizedProps,
                    E = w.memoizedState,
                    d = t.stateNode,
                    u = d.getSnapshotBeforeUpdate(
                      t.elementType === t.type ? g : be(t.type, g),
                      E,
                    );
                  d.__reactInternalSnapshotBeforeUpdate = u;
                }
                break;
              case 3:
                var f = t.stateNode.containerInfo;
                f.nodeType === 1
                  ? (f.textContent = "")
                  : f.nodeType === 9 &&
                    f.documentElement &&
                    f.removeChild(f.documentElement);
                break;
              case 5:
              case 6:
              case 4:
              case 17:
                break;
              default:
                throw Error(x(163));
            }
        } catch (y) {
          K(t, t.return, y);
        }
        if (((e = t.sibling), e !== null)) {
          ((e.return = t.return), (_ = e));
          break;
        }
        _ = t.return;
      }
  return ((w = Zs), (Zs = !1), w);
}
function Un(e, t, n) {
  var r = t.updateQueue;
  if (((r = r !== null ? r.lastEffect : null), r !== null)) {
    var l = (r = r.next);
    do {
      if ((l.tag & e) === e) {
        var o = l.destroy;
        ((l.destroy = void 0), o !== void 0 && Go(t, n, o));
      }
      l = l.next;
    } while (l !== r);
  }
}
function _l(e, t) {
  if (
    ((t = t.updateQueue), (t = t !== null ? t.lastEffect : null), t !== null)
  ) {
    var n = (t = t.next);
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function Ko(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : (t.current = e);
  }
}
function dc(e) {
  var t = e.alternate;
  (t !== null && ((e.alternate = null), dc(t)),
    (e.child = null),
    (e.deletions = null),
    (e.sibling = null),
    e.tag === 5 &&
      ((t = e.stateNode),
      t !== null &&
        (delete t[Ve], delete t[rr], delete t[Fo], delete t[If], delete t[$f])),
    (e.stateNode = null),
    (e.return = null),
    (e.dependencies = null),
    (e.memoizedProps = null),
    (e.memoizedState = null),
    (e.pendingProps = null),
    (e.stateNode = null),
    (e.updateQueue = null));
}
function fc(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function Js(e) {
  e: for (;;) {
    for (; e.sibling === null; ) {
      if (e.return === null || fc(e.return)) return null;
      e = e.return;
    }
    for (
      e.sibling.return = e.return, e = e.sibling;
      e.tag !== 5 && e.tag !== 6 && e.tag !== 18;

    ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      ((e.child.return = e), (e = e.child));
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function qo(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6)
    ((e = e.stateNode),
      t
        ? n.nodeType === 8
          ? n.parentNode.insertBefore(e, t)
          : n.insertBefore(e, t)
        : (n.nodeType === 8
            ? ((t = n.parentNode), t.insertBefore(e, n))
            : ((t = n), t.appendChild(e)),
          (n = n._reactRootContainer),
          n != null || t.onclick !== null || (t.onclick = nl)));
  else if (r !== 4 && ((e = e.child), e !== null))
    for (qo(e, t, n), e = e.sibling; e !== null; )
      (qo(e, t, n), (e = e.sibling));
}
function Yo(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6)
    ((e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e));
  else if (r !== 4 && ((e = e.child), e !== null))
    for (Yo(e, t, n), e = e.sibling; e !== null; )
      (Yo(e, t, n), (e = e.sibling));
}
var ne = null,
  Fe = !1;
function lt(e, t, n) {
  for (n = n.child; n !== null; ) (pc(e, t, n), (n = n.sibling));
}
function pc(e, t, n) {
  if (Ue && typeof Ue.onCommitFiberUnmount == "function")
    try {
      Ue.onCommitFiberUnmount(wl, n);
    } catch {}
  switch (n.tag) {
    case 5:
      se || nn(n, t);
    case 6:
      var r = ne,
        l = Fe;
      ((ne = null),
        lt(e, t, n),
        (ne = r),
        (Fe = l),
        ne !== null &&
          (Fe
            ? ((e = ne),
              (n = n.stateNode),
              e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n))
            : ne.removeChild(n.stateNode)));
      break;
    case 18:
      ne !== null &&
        (Fe
          ? ((e = ne),
            (n = n.stateNode),
            e.nodeType === 8
              ? Xl(e.parentNode, n)
              : e.nodeType === 1 && Xl(e, n),
            Zn(e))
          : Xl(ne, n.stateNode));
      break;
    case 4:
      ((r = ne),
        (l = Fe),
        (ne = n.stateNode.containerInfo),
        (Fe = !0),
        lt(e, t, n),
        (ne = r),
        (Fe = l));
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (
        !se &&
        ((r = n.updateQueue), r !== null && ((r = r.lastEffect), r !== null))
      ) {
        l = r = r.next;
        do {
          var o = l,
            i = o.destroy;
          ((o = o.tag),
            i !== void 0 && (o & 2 || o & 4) && Go(n, t, i),
            (l = l.next));
        } while (l !== r);
      }
      lt(e, t, n);
      break;
    case 1:
      if (
        !se &&
        (nn(n, t),
        (r = n.stateNode),
        typeof r.componentWillUnmount == "function")
      )
        try {
          ((r.props = n.memoizedProps),
            (r.state = n.memoizedState),
            r.componentWillUnmount());
        } catch (s) {
          K(n, t, s);
        }
      lt(e, t, n);
      break;
    case 21:
      lt(e, t, n);
      break;
    case 22:
      n.mode & 1
        ? ((se = (r = se) || n.memoizedState !== null), lt(e, t, n), (se = r))
        : lt(e, t, n);
      break;
    default:
      lt(e, t, n);
  }
}
function ea(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    (n === null && (n = e.stateNode = new np()),
      t.forEach(function (r) {
        var l = fp.bind(null, e, r);
        n.has(r) || (n.add(r), r.then(l, l));
      }));
  }
}
function Re(e, t) {
  var n = t.deletions;
  if (n !== null)
    for (var r = 0; r < n.length; r++) {
      var l = n[r];
      try {
        var o = e,
          i = t,
          s = i;
        e: for (; s !== null; ) {
          switch (s.tag) {
            case 5:
              ((ne = s.stateNode), (Fe = !1));
              break e;
            case 3:
              ((ne = s.stateNode.containerInfo), (Fe = !0));
              break e;
            case 4:
              ((ne = s.stateNode.containerInfo), (Fe = !0));
              break e;
          }
          s = s.return;
        }
        if (ne === null) throw Error(x(160));
        (pc(o, i, l), (ne = null), (Fe = !1));
        var a = l.alternate;
        (a !== null && (a.return = null), (l.return = null));
      } catch (c) {
        K(l, t, c);
      }
    }
  if (t.subtreeFlags & 12854)
    for (t = t.child; t !== null; ) (mc(t, e), (t = t.sibling));
}
function mc(e, t) {
  var n = e.alternate,
    r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if ((Re(t, e), $e(e), r & 4)) {
        try {
          (Un(3, e, e.return), _l(3, e));
        } catch (g) {
          K(e, e.return, g);
        }
        try {
          Un(5, e, e.return);
        } catch (g) {
          K(e, e.return, g);
        }
      }
      break;
    case 1:
      (Re(t, e), $e(e), r & 512 && n !== null && nn(n, n.return));
      break;
    case 5:
      if (
        (Re(t, e),
        $e(e),
        r & 512 && n !== null && nn(n, n.return),
        e.flags & 32)
      ) {
        var l = e.stateNode;
        try {
          Kn(l, "");
        } catch (g) {
          K(e, e.return, g);
        }
      }
      if (r & 4 && ((l = e.stateNode), l != null)) {
        var o = e.memoizedProps,
          i = n !== null ? n.memoizedProps : o,
          s = e.type,
          a = e.updateQueue;
        if (((e.updateQueue = null), a !== null))
          try {
            (s === "input" && o.type === "radio" && o.name != null && Ma(l, o),
              xo(s, i));
            var c = xo(s, o);
            for (i = 0; i < a.length; i += 2) {
              var p = a[i],
                h = a[i + 1];
              p === "style"
                ? Ba(l, h)
                : p === "dangerouslySetInnerHTML"
                  ? Ia(l, h)
                  : p === "children"
                    ? Kn(l, h)
                    : ci(l, p, h, c);
            }
            switch (s) {
              case "input":
                ho(l, o);
                break;
              case "textarea":
                Aa(l, o);
                break;
              case "select":
                var m = l._wrapperState.wasMultiple;
                l._wrapperState.wasMultiple = !!o.multiple;
                var v = o.value;
                v != null
                  ? ln(l, !!o.multiple, v, !1)
                  : m !== !!o.multiple &&
                    (o.defaultValue != null
                      ? ln(l, !!o.multiple, o.defaultValue, !0)
                      : ln(l, !!o.multiple, o.multiple ? [] : "", !1));
            }
            l[rr] = o;
          } catch (g) {
            K(e, e.return, g);
          }
      }
      break;
    case 6:
      if ((Re(t, e), $e(e), r & 4)) {
        if (e.stateNode === null) throw Error(x(162));
        ((l = e.stateNode), (o = e.memoizedProps));
        try {
          l.nodeValue = o;
        } catch (g) {
          K(e, e.return, g);
        }
      }
      break;
    case 3:
      if (
        (Re(t, e), $e(e), r & 4 && n !== null && n.memoizedState.isDehydrated)
      )
        try {
          Zn(t.containerInfo);
        } catch (g) {
          K(e, e.return, g);
        }
      break;
    case 4:
      (Re(t, e), $e(e));
      break;
    case 13:
      (Re(t, e),
        $e(e),
        (l = e.child),
        l.flags & 8192 &&
          ((o = l.memoizedState !== null),
          (l.stateNode.isHidden = o),
          !o ||
            (l.alternate !== null && l.alternate.memoizedState !== null) ||
            (Ui = q())),
        r & 4 && ea(e));
      break;
    case 22:
      if (
        ((p = n !== null && n.memoizedState !== null),
        e.mode & 1 ? ((se = (c = se) || p), Re(t, e), (se = c)) : Re(t, e),
        $e(e),
        r & 8192)
      ) {
        if (
          ((c = e.memoizedState !== null),
          (e.stateNode.isHidden = c) && !p && e.mode & 1)
        )
          for (_ = e, p = e.child; p !== null; ) {
            for (h = _ = p; _ !== null; ) {
              switch (((m = _), (v = m.child), m.tag)) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Un(4, m, m.return);
                  break;
                case 1:
                  nn(m, m.return);
                  var w = m.stateNode;
                  if (typeof w.componentWillUnmount == "function") {
                    ((r = m), (n = m.return));
                    try {
                      ((t = r),
                        (w.props = t.memoizedProps),
                        (w.state = t.memoizedState),
                        w.componentWillUnmount());
                    } catch (g) {
                      K(r, n, g);
                    }
                  }
                  break;
                case 5:
                  nn(m, m.return);
                  break;
                case 22:
                  if (m.memoizedState !== null) {
                    na(h);
                    continue;
                  }
              }
              v !== null ? ((v.return = m), (_ = v)) : na(h);
            }
            p = p.sibling;
          }
        e: for (p = null, h = e; ; ) {
          if (h.tag === 5) {
            if (p === null) {
              p = h;
              try {
                ((l = h.stateNode),
                  c
                    ? ((o = l.style),
                      typeof o.setProperty == "function"
                        ? o.setProperty("display", "none", "important")
                        : (o.display = "none"))
                    : ((s = h.stateNode),
                      (a = h.memoizedProps.style),
                      (i =
                        a != null && a.hasOwnProperty("display")
                          ? a.display
                          : null),
                      (s.style.display = $a("display", i))));
              } catch (g) {
                K(e, e.return, g);
              }
            }
          } else if (h.tag === 6) {
            if (p === null)
              try {
                h.stateNode.nodeValue = c ? "" : h.memoizedProps;
              } catch (g) {
                K(e, e.return, g);
              }
          } else if (
            ((h.tag !== 22 && h.tag !== 23) ||
              h.memoizedState === null ||
              h === e) &&
            h.child !== null
          ) {
            ((h.child.return = h), (h = h.child));
            continue;
          }
          if (h === e) break e;
          for (; h.sibling === null; ) {
            if (h.return === null || h.return === e) break e;
            (p === h && (p = null), (h = h.return));
          }
          (p === h && (p = null),
            (h.sibling.return = h.return),
            (h = h.sibling));
        }
      }
      break;
    case 19:
      (Re(t, e), $e(e), r & 4 && ea(e));
      break;
    case 21:
      break;
    default:
      (Re(t, e), $e(e));
  }
}
function $e(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (fc(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(x(160));
      }
      switch (r.tag) {
        case 5:
          var l = r.stateNode;
          r.flags & 32 && (Kn(l, ""), (r.flags &= -33));
          var o = Js(e);
          Yo(e, o, l);
          break;
        case 3:
        case 4:
          var i = r.stateNode.containerInfo,
            s = Js(e);
          qo(e, s, i);
          break;
        default:
          throw Error(x(161));
      }
    } catch (a) {
      K(e, e.return, a);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function lp(e, t, n) {
  ((_ = e), hc(e));
}
function hc(e, t, n) {
  for (var r = (e.mode & 1) !== 0; _ !== null; ) {
    var l = _,
      o = l.child;
    if (l.tag === 22 && r) {
      var i = l.memoizedState !== null || Rr;
      if (!i) {
        var s = l.alternate,
          a = (s !== null && s.memoizedState !== null) || se;
        s = Rr;
        var c = se;
        if (((Rr = i), (se = a) && !c))
          for (_ = l; _ !== null; )
            ((i = _),
              (a = i.child),
              i.tag === 22 && i.memoizedState !== null
                ? ra(l)
                : a !== null
                  ? ((a.return = i), (_ = a))
                  : ra(l));
        for (; o !== null; ) ((_ = o), hc(o), (o = o.sibling));
        ((_ = l), (Rr = s), (se = c));
      }
      ta(e);
    } else
      l.subtreeFlags & 8772 && o !== null ? ((o.return = l), (_ = o)) : ta(e);
  }
}
function ta(e) {
  for (; _ !== null; ) {
    var t = _;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772)
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              se || _l(5, t);
              break;
            case 1:
              var r = t.stateNode;
              if (t.flags & 4 && !se)
                if (n === null) r.componentDidMount();
                else {
                  var l =
                    t.elementType === t.type
                      ? n.memoizedProps
                      : be(t.type, n.memoizedProps);
                  r.componentDidUpdate(
                    l,
                    n.memoizedState,
                    r.__reactInternalSnapshotBeforeUpdate,
                  );
                }
              var o = t.updateQueue;
              o !== null && Is(t, o, r);
              break;
            case 3:
              var i = t.updateQueue;
              if (i !== null) {
                if (((n = null), t.child !== null))
                  switch (t.child.tag) {
                    case 5:
                      n = t.child.stateNode;
                      break;
                    case 1:
                      n = t.child.stateNode;
                  }
                Is(t, i, n);
              }
              break;
            case 5:
              var s = t.stateNode;
              if (n === null && t.flags & 4) {
                n = s;
                var a = t.memoizedProps;
                switch (t.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    a.autoFocus && n.focus();
                    break;
                  case "img":
                    a.src && (n.src = a.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (t.memoizedState === null) {
                var c = t.alternate;
                if (c !== null) {
                  var p = c.memoizedState;
                  if (p !== null) {
                    var h = p.dehydrated;
                    h !== null && Zn(h);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(x(163));
          }
        se || (t.flags & 512 && Ko(t));
      } catch (m) {
        K(t, t.return, m);
      }
    }
    if (t === e) {
      _ = null;
      break;
    }
    if (((n = t.sibling), n !== null)) {
      ((n.return = t.return), (_ = n));
      break;
    }
    _ = t.return;
  }
}
function na(e) {
  for (; _ !== null; ) {
    var t = _;
    if (t === e) {
      _ = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      ((n.return = t.return), (_ = n));
      break;
    }
    _ = t.return;
  }
}
function ra(e) {
  for (; _ !== null; ) {
    var t = _;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            _l(4, t);
          } catch (a) {
            K(t, n, a);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var l = t.return;
            try {
              r.componentDidMount();
            } catch (a) {
              K(t, l, a);
            }
          }
          var o = t.return;
          try {
            Ko(t);
          } catch (a) {
            K(t, o, a);
          }
          break;
        case 5:
          var i = t.return;
          try {
            Ko(t);
          } catch (a) {
            K(t, i, a);
          }
      }
    } catch (a) {
      K(t, t.return, a);
    }
    if (t === e) {
      _ = null;
      break;
    }
    var s = t.sibling;
    if (s !== null) {
      ((s.return = t.return), (_ = s));
      break;
    }
    _ = t.return;
  }
}
var op = Math.ceil,
  pl = tt.ReactCurrentDispatcher,
  Bi = tt.ReactCurrentOwner,
  Te = tt.ReactCurrentBatchConfig,
  O = 0,
  te = null,
  Y = null,
  re = 0,
  we = 0,
  rn = Et(0),
  Z = 0,
  ur = null,
  It = 0,
  zl = 0,
  Vi = 0,
  Wn = null,
  me = null,
  Ui = 0,
  yn = 1 / 0,
  Qe = null,
  ml = !1,
  Xo = null,
  yt = null,
  br = !1,
  ft = null,
  hl = 0,
  Hn = 0,
  Zo = null,
  Hr = -1,
  Qr = 0;
function de() {
  return O & 6 ? q() : Hr !== -1 ? Hr : (Hr = q());
}
function wt(e) {
  return e.mode & 1
    ? O & 2 && re !== 0
      ? re & -re
      : Vf.transition !== null
        ? (Qr === 0 && (Qr = Ja()), Qr)
        : ((e = D),
          e !== 0 || ((e = window.event), (e = e === void 0 ? 16 : iu(e.type))),
          e)
    : 1;
}
function Ae(e, t, n, r) {
  if (50 < Hn) throw ((Hn = 0), (Zo = null), Error(x(185)));
  (dr(e, n, r),
    (!(O & 2) || e !== te) &&
      (e === te && (!(O & 2) && (zl |= n), Z === 4 && ct(e, re)),
      ye(e, r),
      n === 1 && O === 0 && !(t.mode & 1) && ((yn = q() + 500), El && Pt())));
}
function ye(e, t) {
  var n = e.callbackNode;
  Bd(e, t);
  var r = Zr(e, e === te ? re : 0);
  if (r === 0)
    (n !== null && fs(n), (e.callbackNode = null), (e.callbackPriority = 0));
  else if (((t = r & -r), e.callbackPriority !== t)) {
    if ((n != null && fs(n), t === 1))
      (e.tag === 0 ? Bf(la.bind(null, e)) : Pu(la.bind(null, e)),
        Af(function () {
          !(O & 6) && Pt();
        }),
        (n = null));
    else {
      switch (eu(r)) {
        case 1:
          n = hi;
          break;
        case 4:
          n = Xa;
          break;
        case 16:
          n = Xr;
          break;
        case 536870912:
          n = Za;
          break;
        default:
          n = Xr;
      }
      n = Cc(n, gc.bind(null, e));
    }
    ((e.callbackPriority = t), (e.callbackNode = n));
  }
}
function gc(e, t) {
  if (((Hr = -1), (Qr = 0), O & 6)) throw Error(x(327));
  var n = e.callbackNode;
  if (cn() && e.callbackNode !== n) return null;
  var r = Zr(e, e === te ? re : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || t) t = gl(e, r);
  else {
    t = r;
    var l = O;
    O |= 2;
    var o = yc();
    (te !== e || re !== t) && ((Qe = null), (yn = q() + 500), Ft(e, t));
    do
      try {
        ap();
        break;
      } catch (s) {
        vc(e, s);
      }
    while (!0);
    (zi(),
      (pl.current = o),
      (O = l),
      Y !== null ? (t = 0) : ((te = null), (re = 0), (t = Z)));
  }
  if (t !== 0) {
    if (
      (t === 2 && ((l = Po(e)), l !== 0 && ((r = l), (t = Jo(e, l)))), t === 1)
    )
      throw ((n = ur), Ft(e, 0), ct(e, r), ye(e, q()), n);
    if (t === 6) ct(e, r);
    else {
      if (
        ((l = e.current.alternate),
        !(r & 30) &&
          !ip(l) &&
          ((t = gl(e, r)),
          t === 2 && ((o = Po(e)), o !== 0 && ((r = o), (t = Jo(e, o)))),
          t === 1))
      )
        throw ((n = ur), Ft(e, 0), ct(e, r), ye(e, q()), n);
      switch (((e.finishedWork = l), (e.finishedLanes = r), t)) {
        case 0:
        case 1:
          throw Error(x(345));
        case 2:
          jt(e, me, Qe);
          break;
        case 3:
          if (
            (ct(e, r), (r & 130023424) === r && ((t = Ui + 500 - q()), 10 < t))
          ) {
            if (Zr(e, 0) !== 0) break;
            if (((l = e.suspendedLanes), (l & r) !== r)) {
              (de(), (e.pingedLanes |= e.suspendedLanes & l));
              break;
            }
            e.timeoutHandle = bo(jt.bind(null, e, me, Qe), t);
            break;
          }
          jt(e, me, Qe);
          break;
        case 4:
          if ((ct(e, r), (r & 4194240) === r)) break;
          for (t = e.eventTimes, l = -1; 0 < r; ) {
            var i = 31 - Me(r);
            ((o = 1 << i), (i = t[i]), i > l && (l = i), (r &= ~o));
          }
          if (
            ((r = l),
            (r = q() - r),
            (r =
              (120 > r
                ? 120
                : 480 > r
                  ? 480
                  : 1080 > r
                    ? 1080
                    : 1920 > r
                      ? 1920
                      : 3e3 > r
                        ? 3e3
                        : 4320 > r
                          ? 4320
                          : 1960 * op(r / 1960)) - r),
            10 < r)
          ) {
            e.timeoutHandle = bo(jt.bind(null, e, me, Qe), r);
            break;
          }
          jt(e, me, Qe);
          break;
        case 5:
          jt(e, me, Qe);
          break;
        default:
          throw Error(x(329));
      }
    }
  }
  return (ye(e, q()), e.callbackNode === n ? gc.bind(null, e) : null);
}
function Jo(e, t) {
  var n = Wn;
  return (
    e.current.memoizedState.isDehydrated && (Ft(e, t).flags |= 256),
    (e = gl(e, t)),
    e !== 2 && ((t = me), (me = n), t !== null && ei(t)),
    e
  );
}
function ei(e) {
  me === null ? (me = e) : me.push.apply(me, e);
}
function ip(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && ((n = n.stores), n !== null))
        for (var r = 0; r < n.length; r++) {
          var l = n[r],
            o = l.getSnapshot;
          l = l.value;
          try {
            if (!De(o(), l)) return !1;
          } catch {
            return !1;
          }
        }
    }
    if (((n = t.child), t.subtreeFlags & 16384 && n !== null))
      ((n.return = t), (t = n));
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      ((t.sibling.return = t.return), (t = t.sibling));
    }
  }
  return !0;
}
function ct(e, t) {
  for (
    t &= ~Vi,
      t &= ~zl,
      e.suspendedLanes |= t,
      e.pingedLanes &= ~t,
      e = e.expirationTimes;
    0 < t;

  ) {
    var n = 31 - Me(t),
      r = 1 << n;
    ((e[n] = -1), (t &= ~r));
  }
}
function la(e) {
  if (O & 6) throw Error(x(327));
  cn();
  var t = Zr(e, 0);
  if (!(t & 1)) return (ye(e, q()), null);
  var n = gl(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = Po(e);
    r !== 0 && ((t = r), (n = Jo(e, r)));
  }
  if (n === 1) throw ((n = ur), Ft(e, 0), ct(e, t), ye(e, q()), n);
  if (n === 6) throw Error(x(345));
  return (
    (e.finishedWork = e.current.alternate),
    (e.finishedLanes = t),
    jt(e, me, Qe),
    ye(e, q()),
    null
  );
}
function Wi(e, t) {
  var n = O;
  O |= 1;
  try {
    return e(t);
  } finally {
    ((O = n), O === 0 && ((yn = q() + 500), El && Pt()));
  }
}
function $t(e) {
  ft !== null && ft.tag === 0 && !(O & 6) && cn();
  var t = O;
  O |= 1;
  var n = Te.transition,
    r = D;
  try {
    if (((Te.transition = null), (D = 1), e)) return e();
  } finally {
    ((D = r), (Te.transition = n), (O = t), !(O & 6) && Pt());
  }
}
function Hi() {
  ((we = rn.current), U(rn));
}
function Ft(e, t) {
  ((e.finishedWork = null), (e.finishedLanes = 0));
  var n = e.timeoutHandle;
  if ((n !== -1 && ((e.timeoutHandle = -1), Mf(n)), Y !== null))
    for (n = Y.return; n !== null; ) {
      var r = n;
      switch ((Pi(r), r.tag)) {
        case 1:
          ((r = r.type.childContextTypes), r != null && rl());
          break;
        case 3:
          (gn(), U(ge), U(ae), Fi());
          break;
        case 5:
          bi(r);
          break;
        case 4:
          gn();
          break;
        case 13:
          U(H);
          break;
        case 19:
          U(H);
          break;
        case 10:
          Ti(r.type._context);
          break;
        case 22:
        case 23:
          Hi();
      }
      n = n.return;
    }
  if (
    ((te = e),
    (Y = e = xt(e.current, null)),
    (re = we = t),
    (Z = 0),
    (ur = null),
    (Vi = zl = It = 0),
    (me = Wn = null),
    Rt !== null)
  ) {
    for (t = 0; t < Rt.length; t++)
      if (((n = Rt[t]), (r = n.interleaved), r !== null)) {
        n.interleaved = null;
        var l = r.next,
          o = n.pending;
        if (o !== null) {
          var i = o.next;
          ((o.next = l), (r.next = i));
        }
        n.pending = r;
      }
    Rt = null;
  }
  return e;
}
function vc(e, t) {
  do {
    var n = Y;
    try {
      if ((zi(), (Vr.current = fl), dl)) {
        for (var r = Q.memoizedState; r !== null; ) {
          var l = r.queue;
          (l !== null && (l.pending = null), (r = r.next));
        }
        dl = !1;
      }
      if (
        ((Dt = 0),
        (ee = X = Q = null),
        (Vn = !1),
        (ir = 0),
        (Bi.current = null),
        n === null || n.return === null)
      ) {
        ((Z = 1), (ur = t), (Y = null));
        break;
      }
      e: {
        var o = e,
          i = n.return,
          s = n,
          a = t;
        if (
          ((t = re),
          (s.flags |= 32768),
          a !== null && typeof a == "object" && typeof a.then == "function")
        ) {
          var c = a,
            p = s,
            h = p.tag;
          if (!(p.mode & 1) && (h === 0 || h === 11 || h === 15)) {
            var m = p.alternate;
            m
              ? ((p.updateQueue = m.updateQueue),
                (p.memoizedState = m.memoizedState),
                (p.lanes = m.lanes))
              : ((p.updateQueue = null), (p.memoizedState = null));
          }
          var v = Hs(i);
          if (v !== null) {
            ((v.flags &= -257),
              Qs(v, i, s, o, t),
              v.mode & 1 && Ws(o, c, t),
              (t = v),
              (a = c));
            var w = t.updateQueue;
            if (w === null) {
              var g = new Set();
              (g.add(a), (t.updateQueue = g));
            } else w.add(a);
            break e;
          } else {
            if (!(t & 1)) {
              (Ws(o, c, t), Qi());
              break e;
            }
            a = Error(x(426));
          }
        } else if (W && s.mode & 1) {
          var E = Hs(i);
          if (E !== null) {
            (!(E.flags & 65536) && (E.flags |= 256),
              Qs(E, i, s, o, t),
              Ni(vn(a, s)));
            break e;
          }
        }
        ((o = a = vn(a, s)),
          Z !== 4 && (Z = 2),
          Wn === null ? (Wn = [o]) : Wn.push(o),
          (o = i));
        do {
          switch (o.tag) {
            case 3:
              ((o.flags |= 65536), (t &= -t), (o.lanes |= t));
              var d = ec(o, a, t);
              Ds(o, d);
              break e;
            case 1:
              s = a;
              var u = o.type,
                f = o.stateNode;
              if (
                !(o.flags & 128) &&
                (typeof u.getDerivedStateFromError == "function" ||
                  (f !== null &&
                    typeof f.componentDidCatch == "function" &&
                    (yt === null || !yt.has(f))))
              ) {
                ((o.flags |= 65536), (t &= -t), (o.lanes |= t));
                var y = tc(o, s, t);
                Ds(o, y);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      xc(n);
    } catch (C) {
      ((t = C), Y === n && n !== null && (Y = n = n.return));
      continue;
    }
    break;
  } while (!0);
}
function yc() {
  var e = pl.current;
  return ((pl.current = fl), e === null ? fl : e);
}
function Qi() {
  ((Z === 0 || Z === 3 || Z === 2) && (Z = 4),
    te === null || (!(It & 268435455) && !(zl & 268435455)) || ct(te, re));
}
function gl(e, t) {
  var n = O;
  O |= 2;
  var r = yc();
  (te !== e || re !== t) && ((Qe = null), Ft(e, t));
  do
    try {
      sp();
      break;
    } catch (l) {
      vc(e, l);
    }
  while (!0);
  if ((zi(), (O = n), (pl.current = r), Y !== null)) throw Error(x(261));
  return ((te = null), (re = 0), Z);
}
function sp() {
  for (; Y !== null; ) wc(Y);
}
function ap() {
  for (; Y !== null && !Rd(); ) wc(Y);
}
function wc(e) {
  var t = kc(e.alternate, e, we);
  ((e.memoizedProps = e.pendingProps),
    t === null ? xc(e) : (Y = t),
    (Bi.current = null));
}
function xc(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (((e = t.return), t.flags & 32768)) {
      if (((n = tp(n, t)), n !== null)) {
        ((n.flags &= 32767), (Y = n));
        return;
      }
      if (e !== null)
        ((e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null));
      else {
        ((Z = 6), (Y = null));
        return;
      }
    } else if (((n = ep(n, t, we)), n !== null)) {
      Y = n;
      return;
    }
    if (((t = t.sibling), t !== null)) {
      Y = t;
      return;
    }
    Y = t = e;
  } while (t !== null);
  Z === 0 && (Z = 5);
}
function jt(e, t, n) {
  var r = D,
    l = Te.transition;
  try {
    ((Te.transition = null), (D = 1), up(e, t, n, r));
  } finally {
    ((Te.transition = l), (D = r));
  }
  return null;
}
function up(e, t, n, r) {
  do cn();
  while (ft !== null);
  if (O & 6) throw Error(x(327));
  n = e.finishedWork;
  var l = e.finishedLanes;
  if (n === null) return null;
  if (((e.finishedWork = null), (e.finishedLanes = 0), n === e.current))
    throw Error(x(177));
  ((e.callbackNode = null), (e.callbackPriority = 0));
  var o = n.lanes | n.childLanes;
  if (
    (Vd(e, o),
    e === te && ((Y = te = null), (re = 0)),
    (!(n.subtreeFlags & 2064) && !(n.flags & 2064)) ||
      br ||
      ((br = !0),
      Cc(Xr, function () {
        return (cn(), null);
      })),
    (o = (n.flags & 15990) !== 0),
    n.subtreeFlags & 15990 || o)
  ) {
    ((o = Te.transition), (Te.transition = null));
    var i = D;
    D = 1;
    var s = O;
    ((O |= 4),
      (Bi.current = null),
      rp(e, n),
      mc(n, e),
      Tf(Lo),
      (Jr = !!jo),
      (Lo = jo = null),
      (e.current = n),
      lp(n),
      bd(),
      (O = s),
      (D = i),
      (Te.transition = o));
  } else e.current = n;
  if (
    (br && ((br = !1), (ft = e), (hl = l)),
    (o = e.pendingLanes),
    o === 0 && (yt = null),
    Md(n.stateNode),
    ye(e, q()),
    t !== null)
  )
    for (r = e.onRecoverableError, n = 0; n < t.length; n++)
      ((l = t[n]), r(l.value, { componentStack: l.stack, digest: l.digest }));
  if (ml) throw ((ml = !1), (e = Xo), (Xo = null), e);
  return (
    hl & 1 && e.tag !== 0 && cn(),
    (o = e.pendingLanes),
    o & 1 ? (e === Zo ? Hn++ : ((Hn = 0), (Zo = e))) : (Hn = 0),
    Pt(),
    null
  );
}
function cn() {
  if (ft !== null) {
    var e = eu(hl),
      t = Te.transition,
      n = D;
    try {
      if (((Te.transition = null), (D = 16 > e ? 16 : e), ft === null))
        var r = !1;
      else {
        if (((e = ft), (ft = null), (hl = 0), O & 6)) throw Error(x(331));
        var l = O;
        for (O |= 4, _ = e.current; _ !== null; ) {
          var o = _,
            i = o.child;
          if (_.flags & 16) {
            var s = o.deletions;
            if (s !== null) {
              for (var a = 0; a < s.length; a++) {
                var c = s[a];
                for (_ = c; _ !== null; ) {
                  var p = _;
                  switch (p.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Un(8, p, o);
                  }
                  var h = p.child;
                  if (h !== null) ((h.return = p), (_ = h));
                  else
                    for (; _ !== null; ) {
                      p = _;
                      var m = p.sibling,
                        v = p.return;
                      if ((dc(p), p === c)) {
                        _ = null;
                        break;
                      }
                      if (m !== null) {
                        ((m.return = v), (_ = m));
                        break;
                      }
                      _ = v;
                    }
                }
              }
              var w = o.alternate;
              if (w !== null) {
                var g = w.child;
                if (g !== null) {
                  w.child = null;
                  do {
                    var E = g.sibling;
                    ((g.sibling = null), (g = E));
                  } while (g !== null);
                }
              }
              _ = o;
            }
          }
          if (o.subtreeFlags & 2064 && i !== null) ((i.return = o), (_ = i));
          else
            e: for (; _ !== null; ) {
              if (((o = _), o.flags & 2048))
                switch (o.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Un(9, o, o.return);
                }
              var d = o.sibling;
              if (d !== null) {
                ((d.return = o.return), (_ = d));
                break e;
              }
              _ = o.return;
            }
        }
        var u = e.current;
        for (_ = u; _ !== null; ) {
          i = _;
          var f = i.child;
          if (i.subtreeFlags & 2064 && f !== null) ((f.return = i), (_ = f));
          else
            e: for (i = u; _ !== null; ) {
              if (((s = _), s.flags & 2048))
                try {
                  switch (s.tag) {
                    case 0:
                    case 11:
                    case 15:
                      _l(9, s);
                  }
                } catch (C) {
                  K(s, s.return, C);
                }
              if (s === i) {
                _ = null;
                break e;
              }
              var y = s.sibling;
              if (y !== null) {
                ((y.return = s.return), (_ = y));
                break e;
              }
              _ = s.return;
            }
        }
        if (
          ((O = l), Pt(), Ue && typeof Ue.onPostCommitFiberRoot == "function")
        )
          try {
            Ue.onPostCommitFiberRoot(wl, e);
          } catch {}
        r = !0;
      }
      return r;
    } finally {
      ((D = n), (Te.transition = t));
    }
  }
  return !1;
}
function oa(e, t, n) {
  ((t = vn(n, t)),
    (t = ec(e, t, 1)),
    (e = vt(e, t, 1)),
    (t = de()),
    e !== null && (dr(e, 1, t), ye(e, t)));
}
function K(e, t, n) {
  if (e.tag === 3) oa(e, e, n);
  else
    for (; t !== null; ) {
      if (t.tag === 3) {
        oa(t, e, n);
        break;
      } else if (t.tag === 1) {
        var r = t.stateNode;
        if (
          typeof t.type.getDerivedStateFromError == "function" ||
          (typeof r.componentDidCatch == "function" &&
            (yt === null || !yt.has(r)))
        ) {
          ((e = vn(n, e)),
            (e = tc(t, e, 1)),
            (t = vt(t, e, 1)),
            (e = de()),
            t !== null && (dr(t, 1, e), ye(t, e)));
          break;
        }
      }
      t = t.return;
    }
}
function cp(e, t, n) {
  var r = e.pingCache;
  (r !== null && r.delete(t),
    (t = de()),
    (e.pingedLanes |= e.suspendedLanes & n),
    te === e &&
      (re & n) === n &&
      (Z === 4 || (Z === 3 && (re & 130023424) === re && 500 > q() - Ui)
        ? Ft(e, 0)
        : (Vi |= n)),
    ye(e, t));
}
function Sc(e, t) {
  t === 0 &&
    (e.mode & 1
      ? ((t = Cr), (Cr <<= 1), !(Cr & 130023424) && (Cr = 4194304))
      : (t = 1));
  var n = de();
  ((e = Je(e, t)), e !== null && (dr(e, t, n), ye(e, n)));
}
function dp(e) {
  var t = e.memoizedState,
    n = 0;
  (t !== null && (n = t.retryLane), Sc(e, n));
}
function fp(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode,
        l = e.memoizedState;
      l !== null && (n = l.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(x(314));
  }
  (r !== null && r.delete(t), Sc(e, n));
}
var kc;
kc = function (e, t, n) {
  if (e !== null)
    if (e.memoizedProps !== t.pendingProps || ge.current) he = !0;
    else {
      if (!(e.lanes & n) && !(t.flags & 128)) return ((he = !1), Jf(e, t, n));
      he = !!(e.flags & 131072);
    }
  else ((he = !1), W && t.flags & 1048576 && Nu(t, il, t.index));
  switch (((t.lanes = 0), t.tag)) {
    case 2:
      var r = t.type;
      (Wr(e, t), (e = t.pendingProps));
      var l = pn(t, ae.current);
      (un(t, n), (l = Mi(null, t, r, e, l, n)));
      var o = Ai();
      return (
        (t.flags |= 1),
        typeof l == "object" &&
        l !== null &&
        typeof l.render == "function" &&
        l.$$typeof === void 0
          ? ((t.tag = 1),
            (t.memoizedState = null),
            (t.updateQueue = null),
            ve(r) ? ((o = !0), ll(t)) : (o = !1),
            (t.memoizedState =
              l.state !== null && l.state !== void 0 ? l.state : null),
            Li(t),
            (l.updater = Nl),
            (t.stateNode = l),
            (l._reactInternals = t),
            $o(t, r, e, n),
            (t = Uo(null, t, r, !0, o, n)))
          : ((t.tag = 0), W && o && Ei(t), ce(null, t, l, n), (t = t.child)),
        t
      );
    case 16:
      r = t.elementType;
      e: {
        switch (
          (Wr(e, t),
          (e = t.pendingProps),
          (l = r._init),
          (r = l(r._payload)),
          (t.type = r),
          (l = t.tag = mp(r)),
          (e = be(r, e)),
          l)
        ) {
          case 0:
            t = Vo(null, t, r, e, n);
            break e;
          case 1:
            t = qs(null, t, r, e, n);
            break e;
          case 11:
            t = Gs(null, t, r, e, n);
            break e;
          case 14:
            t = Ks(null, t, r, be(r.type, e), n);
            break e;
        }
        throw Error(x(306, r, ""));
      }
      return t;
    case 0:
      return (
        (r = t.type),
        (l = t.pendingProps),
        (l = t.elementType === r ? l : be(r, l)),
        Vo(e, t, r, l, n)
      );
    case 1:
      return (
        (r = t.type),
        (l = t.pendingProps),
        (l = t.elementType === r ? l : be(r, l)),
        qs(e, t, r, l, n)
      );
    case 3:
      e: {
        if ((oc(t), e === null)) throw Error(x(387));
        ((r = t.pendingProps),
          (o = t.memoizedState),
          (l = o.element),
          Ru(e, t),
          ul(t, r, null, n));
        var i = t.memoizedState;
        if (((r = i.element), o.isDehydrated))
          if (
            ((o = {
              element: r,
              isDehydrated: !1,
              cache: i.cache,
              pendingSuspenseBoundaries: i.pendingSuspenseBoundaries,
              transitions: i.transitions,
            }),
            (t.updateQueue.baseState = o),
            (t.memoizedState = o),
            t.flags & 256)
          ) {
            ((l = vn(Error(x(423)), t)), (t = Ys(e, t, r, n, l)));
            break e;
          } else if (r !== l) {
            ((l = vn(Error(x(424)), t)), (t = Ys(e, t, r, n, l)));
            break e;
          } else
            for (
              xe = gt(t.stateNode.containerInfo.firstChild),
                Se = t,
                W = !0,
                Oe = null,
                n = ju(t, null, r, n),
                t.child = n;
              n;

            )
              ((n.flags = (n.flags & -3) | 4096), (n = n.sibling));
        else {
          if ((mn(), r === l)) {
            t = et(e, t, n);
            break e;
          }
          ce(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return (
        bu(t),
        e === null && Ao(t),
        (r = t.type),
        (l = t.pendingProps),
        (o = e !== null ? e.memoizedProps : null),
        (i = l.children),
        Ro(r, l) ? (i = null) : o !== null && Ro(r, o) && (t.flags |= 32),
        lc(e, t),
        ce(e, t, i, n),
        t.child
      );
    case 6:
      return (e === null && Ao(t), null);
    case 13:
      return ic(e, t, n);
    case 4:
      return (
        Ri(t, t.stateNode.containerInfo),
        (r = t.pendingProps),
        e === null ? (t.child = hn(t, null, r, n)) : ce(e, t, r, n),
        t.child
      );
    case 11:
      return (
        (r = t.type),
        (l = t.pendingProps),
        (l = t.elementType === r ? l : be(r, l)),
        Gs(e, t, r, l, n)
      );
    case 7:
      return (ce(e, t, t.pendingProps, n), t.child);
    case 8:
      return (ce(e, t, t.pendingProps.children, n), t.child);
    case 12:
      return (ce(e, t, t.pendingProps.children, n), t.child);
    case 10:
      e: {
        if (
          ((r = t.type._context),
          (l = t.pendingProps),
          (o = t.memoizedProps),
          (i = l.value),
          I(sl, r._currentValue),
          (r._currentValue = i),
          o !== null)
        )
          if (De(o.value, i)) {
            if (o.children === l.children && !ge.current) {
              t = et(e, t, n);
              break e;
            }
          } else
            for (o = t.child, o !== null && (o.return = t); o !== null; ) {
              var s = o.dependencies;
              if (s !== null) {
                i = o.child;
                for (var a = s.firstContext; a !== null; ) {
                  if (a.context === r) {
                    if (o.tag === 1) {
                      ((a = Ye(-1, n & -n)), (a.tag = 2));
                      var c = o.updateQueue;
                      if (c !== null) {
                        c = c.shared;
                        var p = c.pending;
                        (p === null
                          ? (a.next = a)
                          : ((a.next = p.next), (p.next = a)),
                          (c.pending = a));
                      }
                    }
                    ((o.lanes |= n),
                      (a = o.alternate),
                      a !== null && (a.lanes |= n),
                      Do(o.return, n, t),
                      (s.lanes |= n));
                    break;
                  }
                  a = a.next;
                }
              } else if (o.tag === 10) i = o.type === t.type ? null : o.child;
              else if (o.tag === 18) {
                if (((i = o.return), i === null)) throw Error(x(341));
                ((i.lanes |= n),
                  (s = i.alternate),
                  s !== null && (s.lanes |= n),
                  Do(i, n, t),
                  (i = o.sibling));
              } else i = o.child;
              if (i !== null) i.return = o;
              else
                for (i = o; i !== null; ) {
                  if (i === t) {
                    i = null;
                    break;
                  }
                  if (((o = i.sibling), o !== null)) {
                    ((o.return = i.return), (i = o));
                    break;
                  }
                  i = i.return;
                }
              o = i;
            }
        (ce(e, t, l.children, n), (t = t.child));
      }
      return t;
    case 9:
      return (
        (l = t.type),
        (r = t.pendingProps.children),
        un(t, n),
        (l = je(l)),
        (r = r(l)),
        (t.flags |= 1),
        ce(e, t, r, n),
        t.child
      );
    case 14:
      return (
        (r = t.type),
        (l = be(r, t.pendingProps)),
        (l = be(r.type, l)),
        Ks(e, t, r, l, n)
      );
    case 15:
      return nc(e, t, t.type, t.pendingProps, n);
    case 17:
      return (
        (r = t.type),
        (l = t.pendingProps),
        (l = t.elementType === r ? l : be(r, l)),
        Wr(e, t),
        (t.tag = 1),
        ve(r) ? ((e = !0), ll(t)) : (e = !1),
        un(t, n),
        Ju(t, r, l),
        $o(t, r, l, n),
        Uo(null, t, r, !0, e, n)
      );
    case 19:
      return sc(e, t, n);
    case 22:
      return rc(e, t, n);
  }
  throw Error(x(156, t.tag));
};
function Cc(e, t) {
  return Ya(e, t);
}
function pp(e, t, n, r) {
  ((this.tag = e),
    (this.key = n),
    (this.sibling =
      this.child =
      this.return =
      this.stateNode =
      this.type =
      this.elementType =
        null),
    (this.index = 0),
    (this.ref = null),
    (this.pendingProps = t),
    (this.dependencies =
      this.memoizedState =
      this.updateQueue =
      this.memoizedProps =
        null),
    (this.mode = r),
    (this.subtreeFlags = this.flags = 0),
    (this.deletions = null),
    (this.childLanes = this.lanes = 0),
    (this.alternate = null));
}
function ze(e, t, n, r) {
  return new pp(e, t, n, r);
}
function Gi(e) {
  return ((e = e.prototype), !(!e || !e.isReactComponent));
}
function mp(e) {
  if (typeof e == "function") return Gi(e) ? 1 : 0;
  if (e != null) {
    if (((e = e.$$typeof), e === fi)) return 11;
    if (e === pi) return 14;
  }
  return 2;
}
function xt(e, t) {
  var n = e.alternate;
  return (
    n === null
      ? ((n = ze(e.tag, t, e.key, e.mode)),
        (n.elementType = e.elementType),
        (n.type = e.type),
        (n.stateNode = e.stateNode),
        (n.alternate = e),
        (e.alternate = n))
      : ((n.pendingProps = t),
        (n.type = e.type),
        (n.flags = 0),
        (n.subtreeFlags = 0),
        (n.deletions = null)),
    (n.flags = e.flags & 14680064),
    (n.childLanes = e.childLanes),
    (n.lanes = e.lanes),
    (n.child = e.child),
    (n.memoizedProps = e.memoizedProps),
    (n.memoizedState = e.memoizedState),
    (n.updateQueue = e.updateQueue),
    (t = e.dependencies),
    (n.dependencies =
      t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }),
    (n.sibling = e.sibling),
    (n.index = e.index),
    (n.ref = e.ref),
    n
  );
}
function Gr(e, t, n, r, l, o) {
  var i = 2;
  if (((r = e), typeof e == "function")) Gi(e) && (i = 1);
  else if (typeof e == "string") i = 5;
  else
    e: switch (e) {
      case Gt:
        return Ot(n.children, l, o, t);
      case di:
        ((i = 8), (l |= 8));
        break;
      case uo:
        return (
          (e = ze(12, n, t, l | 2)),
          (e.elementType = uo),
          (e.lanes = o),
          e
        );
      case co:
        return ((e = ze(13, n, t, l)), (e.elementType = co), (e.lanes = o), e);
      case fo:
        return ((e = ze(19, n, t, l)), (e.elementType = fo), (e.lanes = o), e);
      case ba:
        return Tl(n, l, o, t);
      default:
        if (typeof e == "object" && e !== null)
          switch (e.$$typeof) {
            case La:
              i = 10;
              break e;
            case Ra:
              i = 9;
              break e;
            case fi:
              i = 11;
              break e;
            case pi:
              i = 14;
              break e;
            case st:
              ((i = 16), (r = null));
              break e;
          }
        throw Error(x(130, e == null ? e : typeof e, ""));
    }
  return (
    (t = ze(i, n, t, l)),
    (t.elementType = e),
    (t.type = r),
    (t.lanes = o),
    t
  );
}
function Ot(e, t, n, r) {
  return ((e = ze(7, e, r, t)), (e.lanes = n), e);
}
function Tl(e, t, n, r) {
  return (
    (e = ze(22, e, r, t)),
    (e.elementType = ba),
    (e.lanes = n),
    (e.stateNode = { isHidden: !1 }),
    e
  );
}
function oo(e, t, n) {
  return ((e = ze(6, e, null, t)), (e.lanes = n), e);
}
function io(e, t, n) {
  return (
    (t = ze(4, e.children !== null ? e.children : [], e.key, t)),
    (t.lanes = n),
    (t.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation,
    }),
    t
  );
}
function hp(e, t, n, r, l) {
  ((this.tag = t),
    (this.containerInfo = e),
    (this.finishedWork =
      this.pingCache =
      this.current =
      this.pendingChildren =
        null),
    (this.timeoutHandle = -1),
    (this.callbackNode = this.pendingContext = this.context = null),
    (this.callbackPriority = 0),
    (this.eventTimes = $l(0)),
    (this.expirationTimes = $l(-1)),
    (this.entangledLanes =
      this.finishedLanes =
      this.mutableReadLanes =
      this.expiredLanes =
      this.pingedLanes =
      this.suspendedLanes =
      this.pendingLanes =
        0),
    (this.entanglements = $l(0)),
    (this.identifierPrefix = r),
    (this.onRecoverableError = l),
    (this.mutableSourceEagerHydrationData = null));
}
function Ki(e, t, n, r, l, o, i, s, a) {
  return (
    (e = new hp(e, t, n, s, a)),
    t === 1 ? ((t = 1), o === !0 && (t |= 8)) : (t = 0),
    (o = ze(3, null, null, t)),
    (e.current = o),
    (o.stateNode = e),
    (o.memoizedState = {
      element: r,
      isDehydrated: n,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null,
    }),
    Li(o),
    e
  );
}
function gp(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return {
    $$typeof: Qt,
    key: r == null ? null : "" + r,
    children: e,
    containerInfo: t,
    implementation: n,
  };
}
function Ec(e) {
  if (!e) return kt;
  e = e._reactInternals;
  e: {
    if (Vt(e) !== e || e.tag !== 1) throw Error(x(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (ve(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(x(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (ve(n)) return Eu(e, n, t);
  }
  return t;
}
function Pc(e, t, n, r, l, o, i, s, a) {
  return (
    (e = Ki(n, r, !0, e, l, o, i, s, a)),
    (e.context = Ec(null)),
    (n = e.current),
    (r = de()),
    (l = wt(n)),
    (o = Ye(r, l)),
    (o.callback = t ?? null),
    vt(n, o, l),
    (e.current.lanes = l),
    dr(e, l, r),
    ye(e, r),
    e
  );
}
function jl(e, t, n, r) {
  var l = t.current,
    o = de(),
    i = wt(l);
  return (
    (n = Ec(n)),
    t.context === null ? (t.context = n) : (t.pendingContext = n),
    (t = Ye(o, i)),
    (t.payload = { element: e }),
    (r = r === void 0 ? null : r),
    r !== null && (t.callback = r),
    (e = vt(l, t, i)),
    e !== null && (Ae(e, l, i, o), Br(e, l, i)),
    i
  );
}
function vl(e) {
  if (((e = e.current), !e.child)) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function ia(e, t) {
  if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function qi(e, t) {
  (ia(e, t), (e = e.alternate) && ia(e, t));
}
function vp() {
  return null;
}
var Nc =
  typeof reportError == "function"
    ? reportError
    : function (e) {
        console.error(e);
      };
function Yi(e) {
  this._internalRoot = e;
}
Ll.prototype.render = Yi.prototype.render = function (e) {
  var t = this._internalRoot;
  if (t === null) throw Error(x(409));
  jl(e, t, null, null);
};
Ll.prototype.unmount = Yi.prototype.unmount = function () {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    ($t(function () {
      jl(null, e, null, null);
    }),
      (t[Ze] = null));
  }
};
function Ll(e) {
  this._internalRoot = e;
}
Ll.prototype.unstable_scheduleHydration = function (e) {
  if (e) {
    var t = ru();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < ut.length && t !== 0 && t < ut[n].priority; n++);
    (ut.splice(n, 0, e), n === 0 && ou(e));
  }
};
function Xi(e) {
  return !(!e || (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11));
}
function Rl(e) {
  return !(
    !e ||
    (e.nodeType !== 1 &&
      e.nodeType !== 9 &&
      e.nodeType !== 11 &&
      (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "))
  );
}
function sa() {}
function yp(e, t, n, r, l) {
  if (l) {
    if (typeof r == "function") {
      var o = r;
      r = function () {
        var c = vl(i);
        o.call(c);
      };
    }
    var i = Pc(t, r, e, 0, null, !1, !1, "", sa);
    return (
      (e._reactRootContainer = i),
      (e[Ze] = i.current),
      tr(e.nodeType === 8 ? e.parentNode : e),
      $t(),
      i
    );
  }
  for (; (l = e.lastChild); ) e.removeChild(l);
  if (typeof r == "function") {
    var s = r;
    r = function () {
      var c = vl(a);
      s.call(c);
    };
  }
  var a = Ki(e, 0, !1, null, null, !1, !1, "", sa);
  return (
    (e._reactRootContainer = a),
    (e[Ze] = a.current),
    tr(e.nodeType === 8 ? e.parentNode : e),
    $t(function () {
      jl(t, a, n, r);
    }),
    a
  );
}
function bl(e, t, n, r, l) {
  var o = n._reactRootContainer;
  if (o) {
    var i = o;
    if (typeof l == "function") {
      var s = l;
      l = function () {
        var a = vl(i);
        s.call(a);
      };
    }
    jl(t, i, e, l);
  } else i = yp(n, t, e, l, r);
  return vl(i);
}
tu = function (e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = On(t.pendingLanes);
        n !== 0 &&
          (gi(t, n | 1), ye(t, q()), !(O & 6) && ((yn = q() + 500), Pt()));
      }
      break;
    case 13:
      ($t(function () {
        var r = Je(e, 1);
        if (r !== null) {
          var l = de();
          Ae(r, e, 1, l);
        }
      }),
        qi(e, 1));
  }
};
vi = function (e) {
  if (e.tag === 13) {
    var t = Je(e, 134217728);
    if (t !== null) {
      var n = de();
      Ae(t, e, 134217728, n);
    }
    qi(e, 134217728);
  }
};
nu = function (e) {
  if (e.tag === 13) {
    var t = wt(e),
      n = Je(e, t);
    if (n !== null) {
      var r = de();
      Ae(n, e, t, r);
    }
    qi(e, t);
  }
};
ru = function () {
  return D;
};
lu = function (e, t) {
  var n = D;
  try {
    return ((D = e), t());
  } finally {
    D = n;
  }
};
ko = function (e, t, n) {
  switch (t) {
    case "input":
      if ((ho(e, n), (t = n.name), n.type === "radio" && t != null)) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (
          n = n.querySelectorAll(
            "input[name=" + JSON.stringify("" + t) + '][type="radio"]',
          ),
            t = 0;
          t < n.length;
          t++
        ) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var l = Cl(r);
            if (!l) throw Error(x(90));
            (Oa(r), ho(r, l));
          }
        }
      }
      break;
    case "textarea":
      Aa(e, n);
      break;
    case "select":
      ((t = n.value), t != null && ln(e, !!n.multiple, t, !1));
  }
};
Wa = Wi;
Ha = $t;
var wp = { usingClientEntryPoint: !1, Events: [pr, Xt, Cl, Va, Ua, Wi] },
  jn = {
    findFiberByHostInstance: Lt,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom",
  },
  xp = {
    bundleType: jn.bundleType,
    version: jn.version,
    rendererPackageName: jn.rendererPackageName,
    rendererConfig: jn.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: tt.ReactCurrentDispatcher,
    findHostInstanceByFiber: function (e) {
      return ((e = Ka(e)), e === null ? null : e.stateNode);
    },
    findFiberByHostInstance: jn.findFiberByHostInstance || vp,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
  };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var Fr = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Fr.isDisabled && Fr.supportsFiber)
    try {
      ((wl = Fr.inject(xp)), (Ue = Fr));
    } catch {}
}
Ce.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = wp;
Ce.createPortal = function (e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!Xi(t)) throw Error(x(200));
  return gp(e, t, null, n);
};
Ce.createRoot = function (e, t) {
  if (!Xi(e)) throw Error(x(299));
  var n = !1,
    r = "",
    l = Nc;
  return (
    t != null &&
      (t.unstable_strictMode === !0 && (n = !0),
      t.identifierPrefix !== void 0 && (r = t.identifierPrefix),
      t.onRecoverableError !== void 0 && (l = t.onRecoverableError)),
    (t = Ki(e, 1, !1, null, null, n, !1, r, l)),
    (e[Ze] = t.current),
    tr(e.nodeType === 8 ? e.parentNode : e),
    new Yi(t)
  );
};
Ce.findDOMNode = function (e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function"
      ? Error(x(188))
      : ((e = Object.keys(e).join(",")), Error(x(268, e)));
  return ((e = Ka(t)), (e = e === null ? null : e.stateNode), e);
};
Ce.flushSync = function (e) {
  return $t(e);
};
Ce.hydrate = function (e, t, n) {
  if (!Rl(t)) throw Error(x(200));
  return bl(null, e, t, !0, n);
};
Ce.hydrateRoot = function (e, t, n) {
  if (!Xi(e)) throw Error(x(405));
  var r = (n != null && n.hydratedSources) || null,
    l = !1,
    o = "",
    i = Nc;
  if (
    (n != null &&
      (n.unstable_strictMode === !0 && (l = !0),
      n.identifierPrefix !== void 0 && (o = n.identifierPrefix),
      n.onRecoverableError !== void 0 && (i = n.onRecoverableError)),
    (t = Pc(t, null, e, 1, n ?? null, l, !1, o, i)),
    (e[Ze] = t.current),
    tr(e),
    r)
  )
    for (e = 0; e < r.length; e++)
      ((n = r[e]),
        (l = n._getVersion),
        (l = l(n._source)),
        t.mutableSourceEagerHydrationData == null
          ? (t.mutableSourceEagerHydrationData = [n, l])
          : t.mutableSourceEagerHydrationData.push(n, l));
  return new Ll(t);
};
Ce.render = function (e, t, n) {
  if (!Rl(t)) throw Error(x(200));
  return bl(null, e, t, !1, n);
};
Ce.unmountComponentAtNode = function (e) {
  if (!Rl(e)) throw Error(x(40));
  return e._reactRootContainer
    ? ($t(function () {
        bl(null, null, e, !1, function () {
          ((e._reactRootContainer = null), (e[Ze] = null));
        });
      }),
      !0)
    : !1;
};
Ce.unstable_batchedUpdates = Wi;
Ce.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
  if (!Rl(n)) throw Error(x(200));
  if (e == null || e._reactInternals === void 0) throw Error(x(38));
  return bl(e, t, n, !1, r);
};
Ce.version = "18.3.1-next-f1338f8080-20240426";
function _c() {
  if (
    !(
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
    )
  )
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(_c);
    } catch (e) {
      console.error(e);
    }
}
(_c(), (_a.exports = Ce));
var Sp = _a.exports,
  zc,
  aa = Sp;
((zc = aa.createRoot), aa.hydrateRoot);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const kp = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(),
  Tc = (...e) =>
    e
      .filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n)
      .join(" ")
      .trim();
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var Cp = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const Ep = F.forwardRef(
  (
    {
      color: e = "currentColor",
      size: t = 24,
      strokeWidth: n = 2,
      absoluteStrokeWidth: r,
      className: l = "",
      children: o,
      iconNode: i,
      ...s
    },
    a,
  ) =>
    F.createElement(
      "svg",
      {
        ref: a,
        ...Cp,
        width: t,
        height: t,
        stroke: e,
        strokeWidth: r ? (Number(n) * 24) / Number(t) : n,
        className: Tc("lucide", l),
        ...s,
      },
      [
        ...i.map(([c, p]) => F.createElement(c, p)),
        ...(Array.isArray(o) ? o : [o]),
      ],
    ),
);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const Ut = (e, t) => {
  const n = F.forwardRef(({ className: r, ...l }, o) =>
    F.createElement(Ep, {
      ref: o,
      iconNode: t,
      className: Tc(`lucide-${kp(e)}`, r),
      ...l,
    }),
  );
  return ((n.displayName = `${e}`), n);
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const Pp = Ut("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const Np = Ut("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }],
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const ua = Ut("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }],
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const _p = Ut("ExternalLink", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  [
    "path",
    {
      d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
      key: "a6xqqp",
    },
  ],
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const zp = Ut("RefreshCw", [
  [
    "path",
    { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" },
  ],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  [
    "path",
    { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" },
  ],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const Tp = Ut("ShoppingCart", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506",
    },
  ],
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const jp = Ut("Star", [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s",
    },
  ],
]);
var Lp = Object.defineProperty,
  Zi = (e, t) => Lp(e, "name", { value: t, configurable: !0 });
function ti(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
Zi(ti, "setRef");
function jc(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((l) => {
      const o = ti(l, t);
      return (!n && typeof o == "function" && (n = !0), o);
    });
    if (n)
      return () => {
        for (let l = 0; l < r.length; l++) {
          const o = r[l];
          typeof o == "function" ? o() : ti(e[l], null);
        }
      };
  };
}
Zi(jc, "composeRefs");
function Lc(...e) {
  return F.useCallback(jc(...e), e);
}
Zi(Lc, "useComposedRefs");
var Rp = Object.defineProperty,
  Ie = (e, t) => Rp(e, "name", { value: t, configurable: !0 });
function Rc(e) {
  const t = F.forwardRef((n, r) => {
    let { children: l, ...o } = n,
      i = null,
      s = !1;
    const a = [];
    (ni(l) && typeof Or == "function" && (l = Or(l._payload)),
      F.Children.forEach(l, (m) => {
        var v;
        if (Mc(m)) {
          s = !0;
          const w = m;
          let g = "child" in w.props ? w.props.child : w.props.children;
          (ni(g) && typeof Or == "function" && (g = Or(g._payload)),
            (i = Op(w, g)),
            a.push(
              (v = i == null ? void 0 : i.props) == null ? void 0 : v.children,
            ));
        } else a.push(m);
      }),
      i
        ? (i = F.cloneElement(i, void 0, a))
        : !s && F.Children.count(l) === 1 && F.isValidElement(l) && (i = l));
    const c = i ? Oc(i) : void 0,
      p = Lc(r, c);
    if (!i) {
      if (l || l === 0) throw new Error(s ? Dp(e) : Ap(e));
      return l;
    }
    const h = Fc(o, i.props ?? {});
    return (i.type !== F.Fragment && (h.ref = r ? p : c), F.cloneElement(i, h));
  });
  return ((t.displayName = `${e}.Slot`), t);
}
Ie(Rc, "createSlot");
var bp = Rc("Slot"),
  bc = Symbol.for("radix.slottable");
function Fp(e) {
  const t = Ie(
    (n) => ("child" in n ? n.children(n.child) : n.children),
    "Slottable",
  );
  return ((t.displayName = `${e}.Slottable`), (t.__radixId = bc), t);
}
Ie(Fp, "createSlottable");
var Op = Ie((e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return F.isValidElement(n)
      ? F.cloneElement(n, void 0, e.props.children(n.props.children))
      : null;
  }
  return F.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Fc(e, t) {
  const n = { ...t };
  for (const r in t) {
    const l = e[r],
      o = t[r];
    /^on[A-Z]/.test(r)
      ? l && o
        ? (n[r] = (...s) => {
            const a = o(...s);
            return (l(...s), a);
          })
        : l && (n[r] = l)
      : r === "style"
        ? (n[r] = { ...l, ...o })
        : r === "className" && (n[r] = [l, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
Ie(Fc, "mergeProps");
function Oc(e) {
  var r, l;
  let t =
      (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null
        ? void 0
        : r.get,
    n = t && "isReactWarning" in t && t.isReactWarning;
  return n
    ? e.ref
    : ((t =
        (l = Object.getOwnPropertyDescriptor(e, "ref")) == null
          ? void 0
          : l.get),
      (n = t && "isReactWarning" in t && t.isReactWarning),
      n ? e.props.ref : e.props.ref || e.ref);
}
Ie(Oc, "getElementRef");
function Mc(e) {
  return (
    F.isValidElement(e) &&
    typeof e.type == "function" &&
    "__radixId" in e.type &&
    e.type.__radixId === bc
  );
}
Ie(Mc, "isSlottable");
var Mp = Symbol.for("react.lazy");
function ni(e) {
  return (
    e != null &&
    typeof e == "object" &&
    "$$typeof" in e &&
    e.$$typeof === Mp &&
    "_payload" in e &&
    Ac(e._payload)
  );
}
Ie(ni, "isLazyComponent");
function Ac(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
Ie(Ac, "isPromiseLike");
var Ap = Ie(
    (e) =>
      `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`,
    "createSlotError",
  ),
  Dp = Ie(
    (e) =>
      `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`,
    "createSlottableError",
  ),
  Or = ud[" use ".trim().toString()];
function Dc(e) {
  var t,
    n,
    r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var l = e.length;
      for (t = 0; t < l; t++)
        e[t] && (n = Dc(e[t])) && (r && (r += " "), (r += n));
    } else for (n in e) e[n] && (r && (r += " "), (r += n));
  return r;
}
function Ic() {
  for (var e, t, n = 0, r = "", l = arguments.length; n < l; n++)
    (e = arguments[n]) && (t = Dc(e)) && (r && (r += " "), (r += t));
  return r;
}
const ca = (e) => (typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e),
  da = Ic,
  Ip = (e, t) => (n) => {
    var r;
    if ((t == null ? void 0 : t.variants) == null)
      return da(
        e,
        n == null ? void 0 : n.class,
        n == null ? void 0 : n.className,
      );
    const { variants: l, defaultVariants: o } = t,
      i = Object.keys(l).map((c) => {
        const p = n == null ? void 0 : n[c],
          h = o == null ? void 0 : o[c];
        if (p === null) return null;
        const m = ca(p) || ca(h);
        return l[c][m];
      }),
      s =
        n &&
        Object.entries(n).reduce((c, p) => {
          let [h, m] = p;
          return (m === void 0 || (c[h] = m), c);
        }, {}),
      a =
        t == null || (r = t.compoundVariants) === null || r === void 0
          ? void 0
          : r.reduce((c, p) => {
              let { class: h, className: m, ...v } = p;
              return Object.entries(v).every((w) => {
                let [g, E] = w;
                return Array.isArray(E)
                  ? E.includes({ ...o, ...s }[g])
                  : { ...o, ...s }[g] === E;
              })
                ? [...c, h, m]
                : c;
            }, []);
    return da(
      e,
      i,
      a,
      n == null ? void 0 : n.class,
      n == null ? void 0 : n.className,
    );
  },
  Ji = "-",
  $p = (e) => {
    const t = Vp(e),
      { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
    return {
      getClassGroupId: (i) => {
        const s = i.split(Ji);
        return (s[0] === "" && s.length !== 1 && s.shift(), $c(s, t) || Bp(i));
      },
      getConflictingClassGroupIds: (i, s) => {
        const a = n[i] || [];
        return s && r[i] ? [...a, ...r[i]] : a;
      },
    };
  },
  $c = (e, t) => {
    var i;
    if (e.length === 0) return t.classGroupId;
    const n = e[0],
      r = t.nextPart.get(n),
      l = r ? $c(e.slice(1), r) : void 0;
    if (l) return l;
    if (t.validators.length === 0) return;
    const o = e.join(Ji);
    return (i = t.validators.find(({ validator: s }) => s(o))) == null
      ? void 0
      : i.classGroupId;
  },
  fa = /^\[(.+)\]$/,
  Bp = (e) => {
    if (fa.test(e)) {
      const t = fa.exec(e)[1],
        n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
      if (n) return "arbitrary.." + n;
    }
  },
  Vp = (e) => {
    const { theme: t, prefix: n } = e,
      r = { nextPart: new Map(), validators: [] };
    return (
      Wp(Object.entries(e.classGroups), n).forEach(([o, i]) => {
        ri(i, r, o, t);
      }),
      r
    );
  },
  ri = (e, t, n, r) => {
    e.forEach((l) => {
      if (typeof l == "string") {
        const o = l === "" ? t : pa(t, l);
        o.classGroupId = n;
        return;
      }
      if (typeof l == "function") {
        if (Up(l)) {
          ri(l(r), t, n, r);
          return;
        }
        t.validators.push({ validator: l, classGroupId: n });
        return;
      }
      Object.entries(l).forEach(([o, i]) => {
        ri(i, pa(t, o), n, r);
      });
    });
  },
  pa = (e, t) => {
    let n = e;
    return (
      t.split(Ji).forEach((r) => {
        (n.nextPart.has(r) ||
          n.nextPart.set(r, { nextPart: new Map(), validators: [] }),
          (n = n.nextPart.get(r)));
      }),
      n
    );
  },
  Up = (e) => e.isThemeGetter,
  Wp = (e, t) =>
    t
      ? e.map(([n, r]) => {
          const l = r.map((o) =>
            typeof o == "string"
              ? t + o
              : typeof o == "object"
                ? Object.fromEntries(
                    Object.entries(o).map(([i, s]) => [t + i, s]),
                  )
                : o,
          );
          return [n, l];
        })
      : e,
  Hp = (e) => {
    if (e < 1) return { get: () => {}, set: () => {} };
    let t = 0,
      n = new Map(),
      r = new Map();
    const l = (o, i) => {
      (n.set(o, i), t++, t > e && ((t = 0), (r = n), (n = new Map())));
    };
    return {
      get(o) {
        let i = n.get(o);
        if (i !== void 0) return i;
        if ((i = r.get(o)) !== void 0) return (l(o, i), i);
      },
      set(o, i) {
        n.has(o) ? n.set(o, i) : l(o, i);
      },
    };
  },
  Bc = "!",
  Qp = (e) => {
    const { separator: t, experimentalParseClassName: n } = e,
      r = t.length === 1,
      l = t[0],
      o = t.length,
      i = (s) => {
        const a = [];
        let c = 0,
          p = 0,
          h;
        for (let E = 0; E < s.length; E++) {
          let d = s[E];
          if (c === 0) {
            if (d === l && (r || s.slice(E, E + o) === t)) {
              (a.push(s.slice(p, E)), (p = E + o));
              continue;
            }
            if (d === "/") {
              h = E;
              continue;
            }
          }
          d === "[" ? c++ : d === "]" && c--;
        }
        const m = a.length === 0 ? s : s.substring(p),
          v = m.startsWith(Bc),
          w = v ? m.substring(1) : m,
          g = h && h > p ? h - p : void 0;
        return {
          modifiers: a,
          hasImportantModifier: v,
          baseClassName: w,
          maybePostfixModifierPosition: g,
        };
      };
    return n ? (s) => n({ className: s, parseClassName: i }) : i;
  },
  Gp = (e) => {
    if (e.length <= 1) return e;
    const t = [];
    let n = [];
    return (
      e.forEach((r) => {
        r[0] === "[" ? (t.push(...n.sort(), r), (n = [])) : n.push(r);
      }),
      t.push(...n.sort()),
      t
    );
  },
  Kp = (e) => ({ cache: Hp(e.cacheSize), parseClassName: Qp(e), ...$p(e) }),
  qp = /\s+/,
  Yp = (e, t) => {
    const {
        parseClassName: n,
        getClassGroupId: r,
        getConflictingClassGroupIds: l,
      } = t,
      o = [],
      i = e.trim().split(qp);
    let s = "";
    for (let a = i.length - 1; a >= 0; a -= 1) {
      const c = i[a],
        {
          modifiers: p,
          hasImportantModifier: h,
          baseClassName: m,
          maybePostfixModifierPosition: v,
        } = n(c);
      let w = !!v,
        g = r(w ? m.substring(0, v) : m);
      if (!g) {
        if (!w) {
          s = c + (s.length > 0 ? " " + s : s);
          continue;
        }
        if (((g = r(m)), !g)) {
          s = c + (s.length > 0 ? " " + s : s);
          continue;
        }
        w = !1;
      }
      const E = Gp(p).join(":"),
        d = h ? E + Bc : E,
        u = d + g;
      if (o.includes(u)) continue;
      o.push(u);
      const f = l(g, w);
      for (let y = 0; y < f.length; ++y) {
        const C = f[y];
        o.push(d + C);
      }
      s = c + (s.length > 0 ? " " + s : s);
    }
    return s;
  };
function Xp() {
  let e = 0,
    t,
    n,
    r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Vc(t)) && (r && (r += " "), (r += n));
  return r;
}
const Vc = (e) => {
  if (typeof e == "string") return e;
  let t,
    n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Vc(e[r])) && (n && (n += " "), (n += t));
  return n;
};
function Zp(e, ...t) {
  let n,
    r,
    l,
    o = i;
  function i(a) {
    const c = t.reduce((p, h) => h(p), e());
    return ((n = Kp(c)), (r = n.cache.get), (l = n.cache.set), (o = s), s(a));
  }
  function s(a) {
    const c = r(a);
    if (c) return c;
    const p = Yp(a, n);
    return (l(a, p), p);
  }
  return function () {
    return o(Xp.apply(null, arguments));
  };
}
const B = (e) => {
    const t = (n) => n[e] || [];
    return ((t.isThemeGetter = !0), t);
  },
  Uc = /^\[(?:([a-z-]+):)?(.+)\]$/i,
  Jp = /^\d+\/\d+$/,
  em = new Set(["px", "full", "screen"]),
  tm = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/,
  nm =
    /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/,
  rm = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/,
  lm = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/,
  om =
    /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/,
  He = (e) => dn(e) || em.has(e) || Jp.test(e),
  ot = (e) => kn(e, "length", pm),
  dn = (e) => !!e && !Number.isNaN(Number(e)),
  so = (e) => kn(e, "number", dn),
  Ln = (e) => !!e && Number.isInteger(Number(e)),
  im = (e) => e.endsWith("%") && dn(e.slice(0, -1)),
  L = (e) => Uc.test(e),
  it = (e) => tm.test(e),
  sm = new Set(["length", "size", "percentage"]),
  am = (e) => kn(e, sm, Wc),
  um = (e) => kn(e, "position", Wc),
  cm = new Set(["image", "url"]),
  dm = (e) => kn(e, cm, hm),
  fm = (e) => kn(e, "", mm),
  Rn = () => !0,
  kn = (e, t, n) => {
    const r = Uc.exec(e);
    return r
      ? r[1]
        ? typeof t == "string"
          ? r[1] === t
          : t.has(r[1])
        : n(r[2])
      : !1;
  },
  pm = (e) => nm.test(e) && !rm.test(e),
  Wc = () => !1,
  mm = (e) => lm.test(e),
  hm = (e) => om.test(e),
  gm = () => {
    const e = B("colors"),
      t = B("spacing"),
      n = B("blur"),
      r = B("brightness"),
      l = B("borderColor"),
      o = B("borderRadius"),
      i = B("borderSpacing"),
      s = B("borderWidth"),
      a = B("contrast"),
      c = B("grayscale"),
      p = B("hueRotate"),
      h = B("invert"),
      m = B("gap"),
      v = B("gradientColorStops"),
      w = B("gradientColorStopPositions"),
      g = B("inset"),
      E = B("margin"),
      d = B("opacity"),
      u = B("padding"),
      f = B("saturate"),
      y = B("scale"),
      C = B("sepia"),
      k = B("skew"),
      N = B("space"),
      z = B("translate"),
      $ = () => ["auto", "contain", "none"],
      R = () => ["auto", "hidden", "clip", "visible", "scroll"],
      ue = () => ["auto", L, t],
      A = () => [L, t],
      nt = () => ["", He, ot],
      Nt = () => ["auto", dn, L],
      hr = () => [
        "bottom",
        "center",
        "left",
        "left-bottom",
        "left-top",
        "right",
        "right-bottom",
        "right-top",
        "top",
      ],
      rt = () => ["solid", "dashed", "dotted", "double", "none"],
      Wt = () => [
        "normal",
        "multiply",
        "screen",
        "overlay",
        "darken",
        "lighten",
        "color-dodge",
        "color-burn",
        "hard-light",
        "soft-light",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity",
      ],
      P = () => [
        "start",
        "end",
        "center",
        "between",
        "around",
        "evenly",
        "stretch",
      ],
      T = () => ["", "0", L],
      j = () => [
        "auto",
        "avoid",
        "all",
        "avoid-page",
        "page",
        "left",
        "right",
        "column",
      ],
      M = () => [dn, L];
    return {
      cacheSize: 500,
      separator: ":",
      theme: {
        colors: [Rn],
        spacing: [He, ot],
        blur: ["none", "", it, L],
        brightness: M(),
        borderColor: [e],
        borderRadius: ["none", "", "full", it, L],
        borderSpacing: A(),
        borderWidth: nt(),
        contrast: M(),
        grayscale: T(),
        hueRotate: M(),
        invert: T(),
        gap: A(),
        gradientColorStops: [e],
        gradientColorStopPositions: [im, ot],
        inset: ue(),
        margin: ue(),
        opacity: M(),
        padding: A(),
        saturate: M(),
        scale: M(),
        sepia: T(),
        skew: M(),
        space: A(),
        translate: A(),
      },
      classGroups: {
        aspect: [{ aspect: ["auto", "square", "video", L] }],
        container: ["container"],
        columns: [{ columns: [it] }],
        "break-after": [{ "break-after": j() }],
        "break-before": [{ "break-before": j() }],
        "break-inside": [
          { "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"] },
        ],
        "box-decoration": [{ "box-decoration": ["slice", "clone"] }],
        box: [{ box: ["border", "content"] }],
        display: [
          "block",
          "inline-block",
          "inline",
          "flex",
          "inline-flex",
          "table",
          "inline-table",
          "table-caption",
          "table-cell",
          "table-column",
          "table-column-group",
          "table-footer-group",
          "table-header-group",
          "table-row-group",
          "table-row",
          "flow-root",
          "grid",
          "inline-grid",
          "contents",
          "list-item",
          "hidden",
        ],
        float: [{ float: ["right", "left", "none", "start", "end"] }],
        clear: [{ clear: ["left", "right", "both", "none", "start", "end"] }],
        isolation: ["isolate", "isolation-auto"],
        "object-fit": [
          { object: ["contain", "cover", "fill", "none", "scale-down"] },
        ],
        "object-position": [{ object: [...hr(), L] }],
        overflow: [{ overflow: R() }],
        "overflow-x": [{ "overflow-x": R() }],
        "overflow-y": [{ "overflow-y": R() }],
        overscroll: [{ overscroll: $() }],
        "overscroll-x": [{ "overscroll-x": $() }],
        "overscroll-y": [{ "overscroll-y": $() }],
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        inset: [{ inset: [g] }],
        "inset-x": [{ "inset-x": [g] }],
        "inset-y": [{ "inset-y": [g] }],
        start: [{ start: [g] }],
        end: [{ end: [g] }],
        top: [{ top: [g] }],
        right: [{ right: [g] }],
        bottom: [{ bottom: [g] }],
        left: [{ left: [g] }],
        visibility: ["visible", "invisible", "collapse"],
        z: [{ z: ["auto", Ln, L] }],
        basis: [{ basis: ue() }],
        "flex-direction": [
          { flex: ["row", "row-reverse", "col", "col-reverse"] },
        ],
        "flex-wrap": [{ flex: ["wrap", "wrap-reverse", "nowrap"] }],
        flex: [{ flex: ["1", "auto", "initial", "none", L] }],
        grow: [{ grow: T() }],
        shrink: [{ shrink: T() }],
        order: [{ order: ["first", "last", "none", Ln, L] }],
        "grid-cols": [{ "grid-cols": [Rn] }],
        "col-start-end": [{ col: ["auto", { span: ["full", Ln, L] }, L] }],
        "col-start": [{ "col-start": Nt() }],
        "col-end": [{ "col-end": Nt() }],
        "grid-rows": [{ "grid-rows": [Rn] }],
        "row-start-end": [{ row: ["auto", { span: [Ln, L] }, L] }],
        "row-start": [{ "row-start": Nt() }],
        "row-end": [{ "row-end": Nt() }],
        "grid-flow": [
          { "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"] },
        ],
        "auto-cols": [{ "auto-cols": ["auto", "min", "max", "fr", L] }],
        "auto-rows": [{ "auto-rows": ["auto", "min", "max", "fr", L] }],
        gap: [{ gap: [m] }],
        "gap-x": [{ "gap-x": [m] }],
        "gap-y": [{ "gap-y": [m] }],
        "justify-content": [{ justify: ["normal", ...P()] }],
        "justify-items": [
          { "justify-items": ["start", "end", "center", "stretch"] },
        ],
        "justify-self": [
          { "justify-self": ["auto", "start", "end", "center", "stretch"] },
        ],
        "align-content": [{ content: ["normal", ...P(), "baseline"] }],
        "align-items": [
          { items: ["start", "end", "center", "baseline", "stretch"] },
        ],
        "align-self": [
          { self: ["auto", "start", "end", "center", "stretch", "baseline"] },
        ],
        "place-content": [{ "place-content": [...P(), "baseline"] }],
        "place-items": [
          { "place-items": ["start", "end", "center", "baseline", "stretch"] },
        ],
        "place-self": [
          { "place-self": ["auto", "start", "end", "center", "stretch"] },
        ],
        p: [{ p: [u] }],
        px: [{ px: [u] }],
        py: [{ py: [u] }],
        ps: [{ ps: [u] }],
        pe: [{ pe: [u] }],
        pt: [{ pt: [u] }],
        pr: [{ pr: [u] }],
        pb: [{ pb: [u] }],
        pl: [{ pl: [u] }],
        m: [{ m: [E] }],
        mx: [{ mx: [E] }],
        my: [{ my: [E] }],
        ms: [{ ms: [E] }],
        me: [{ me: [E] }],
        mt: [{ mt: [E] }],
        mr: [{ mr: [E] }],
        mb: [{ mb: [E] }],
        ml: [{ ml: [E] }],
        "space-x": [{ "space-x": [N] }],
        "space-x-reverse": ["space-x-reverse"],
        "space-y": [{ "space-y": [N] }],
        "space-y-reverse": ["space-y-reverse"],
        w: [{ w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", L, t] }],
        "min-w": [{ "min-w": [L, t, "min", "max", "fit"] }],
        "max-w": [
          {
            "max-w": [
              L,
              t,
              "none",
              "full",
              "min",
              "max",
              "fit",
              "prose",
              { screen: [it] },
              it,
            ],
          },
        ],
        h: [{ h: [L, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"] }],
        "min-h": [
          { "min-h": [L, t, "min", "max", "fit", "svh", "lvh", "dvh"] },
        ],
        "max-h": [
          { "max-h": [L, t, "min", "max", "fit", "svh", "lvh", "dvh"] },
        ],
        size: [{ size: [L, t, "auto", "min", "max", "fit"] }],
        "font-size": [{ text: ["base", it, ot] }],
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        "font-style": ["italic", "not-italic"],
        "font-weight": [
          {
            font: [
              "thin",
              "extralight",
              "light",
              "normal",
              "medium",
              "semibold",
              "bold",
              "extrabold",
              "black",
              so,
            ],
          },
        ],
        "font-family": [{ font: [Rn] }],
        "fvn-normal": ["normal-nums"],
        "fvn-ordinal": ["ordinal"],
        "fvn-slashed-zero": ["slashed-zero"],
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
        tracking: [
          {
            tracking: [
              "tighter",
              "tight",
              "normal",
              "wide",
              "wider",
              "widest",
              L,
            ],
          },
        ],
        "line-clamp": [{ "line-clamp": ["none", dn, so] }],
        leading: [
          {
            leading: [
              "none",
              "tight",
              "snug",
              "normal",
              "relaxed",
              "loose",
              He,
              L,
            ],
          },
        ],
        "list-image": [{ "list-image": ["none", L] }],
        "list-style-type": [{ list: ["none", "disc", "decimal", L] }],
        "list-style-position": [{ list: ["inside", "outside"] }],
        "placeholder-color": [{ placeholder: [e] }],
        "placeholder-opacity": [{ "placeholder-opacity": [d] }],
        "text-alignment": [
          { text: ["left", "center", "right", "justify", "start", "end"] },
        ],
        "text-color": [{ text: [e] }],
        "text-opacity": [{ "text-opacity": [d] }],
        "text-decoration": [
          "underline",
          "overline",
          "line-through",
          "no-underline",
        ],
        "text-decoration-style": [{ decoration: [...rt(), "wavy"] }],
        "text-decoration-thickness": [
          { decoration: ["auto", "from-font", He, ot] },
        ],
        "underline-offset": [{ "underline-offset": ["auto", He, L] }],
        "text-decoration-color": [{ decoration: [e] }],
        "text-transform": [
          "uppercase",
          "lowercase",
          "capitalize",
          "normal-case",
        ],
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        "text-wrap": [{ text: ["wrap", "nowrap", "balance", "pretty"] }],
        indent: [{ indent: A() }],
        "vertical-align": [
          {
            align: [
              "baseline",
              "top",
              "middle",
              "bottom",
              "text-top",
              "text-bottom",
              "sub",
              "super",
              L,
            ],
          },
        ],
        whitespace: [
          {
            whitespace: [
              "normal",
              "nowrap",
              "pre",
              "pre-line",
              "pre-wrap",
              "break-spaces",
            ],
          },
        ],
        break: [{ break: ["normal", "words", "all", "keep"] }],
        hyphens: [{ hyphens: ["none", "manual", "auto"] }],
        content: [{ content: ["none", L] }],
        "bg-attachment": [{ bg: ["fixed", "local", "scroll"] }],
        "bg-clip": [{ "bg-clip": ["border", "padding", "content", "text"] }],
        "bg-opacity": [{ "bg-opacity": [d] }],
        "bg-origin": [{ "bg-origin": ["border", "padding", "content"] }],
        "bg-position": [{ bg: [...hr(), um] }],
        "bg-repeat": [
          { bg: ["no-repeat", { repeat: ["", "x", "y", "round", "space"] }] },
        ],
        "bg-size": [{ bg: ["auto", "cover", "contain", am] }],
        "bg-image": [
          {
            bg: [
              "none",
              { "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"] },
              dm,
            ],
          },
        ],
        "bg-color": [{ bg: [e] }],
        "gradient-from-pos": [{ from: [w] }],
        "gradient-via-pos": [{ via: [w] }],
        "gradient-to-pos": [{ to: [w] }],
        "gradient-from": [{ from: [v] }],
        "gradient-via": [{ via: [v] }],
        "gradient-to": [{ to: [v] }],
        rounded: [{ rounded: [o] }],
        "rounded-s": [{ "rounded-s": [o] }],
        "rounded-e": [{ "rounded-e": [o] }],
        "rounded-t": [{ "rounded-t": [o] }],
        "rounded-r": [{ "rounded-r": [o] }],
        "rounded-b": [{ "rounded-b": [o] }],
        "rounded-l": [{ "rounded-l": [o] }],
        "rounded-ss": [{ "rounded-ss": [o] }],
        "rounded-se": [{ "rounded-se": [o] }],
        "rounded-ee": [{ "rounded-ee": [o] }],
        "rounded-es": [{ "rounded-es": [o] }],
        "rounded-tl": [{ "rounded-tl": [o] }],
        "rounded-tr": [{ "rounded-tr": [o] }],
        "rounded-br": [{ "rounded-br": [o] }],
        "rounded-bl": [{ "rounded-bl": [o] }],
        "border-w": [{ border: [s] }],
        "border-w-x": [{ "border-x": [s] }],
        "border-w-y": [{ "border-y": [s] }],
        "border-w-s": [{ "border-s": [s] }],
        "border-w-e": [{ "border-e": [s] }],
        "border-w-t": [{ "border-t": [s] }],
        "border-w-r": [{ "border-r": [s] }],
        "border-w-b": [{ "border-b": [s] }],
        "border-w-l": [{ "border-l": [s] }],
        "border-opacity": [{ "border-opacity": [d] }],
        "border-style": [{ border: [...rt(), "hidden"] }],
        "divide-x": [{ "divide-x": [s] }],
        "divide-x-reverse": ["divide-x-reverse"],
        "divide-y": [{ "divide-y": [s] }],
        "divide-y-reverse": ["divide-y-reverse"],
        "divide-opacity": [{ "divide-opacity": [d] }],
        "divide-style": [{ divide: rt() }],
        "border-color": [{ border: [l] }],
        "border-color-x": [{ "border-x": [l] }],
        "border-color-y": [{ "border-y": [l] }],
        "border-color-s": [{ "border-s": [l] }],
        "border-color-e": [{ "border-e": [l] }],
        "border-color-t": [{ "border-t": [l] }],
        "border-color-r": [{ "border-r": [l] }],
        "border-color-b": [{ "border-b": [l] }],
        "border-color-l": [{ "border-l": [l] }],
        "divide-color": [{ divide: [l] }],
        "outline-style": [{ outline: ["", ...rt()] }],
        "outline-offset": [{ "outline-offset": [He, L] }],
        "outline-w": [{ outline: [He, ot] }],
        "outline-color": [{ outline: [e] }],
        "ring-w": [{ ring: nt() }],
        "ring-w-inset": ["ring-inset"],
        "ring-color": [{ ring: [e] }],
        "ring-opacity": [{ "ring-opacity": [d] }],
        "ring-offset-w": [{ "ring-offset": [He, ot] }],
        "ring-offset-color": [{ "ring-offset": [e] }],
        shadow: [{ shadow: ["", "inner", "none", it, fm] }],
        "shadow-color": [{ shadow: [Rn] }],
        opacity: [{ opacity: [d] }],
        "mix-blend": [
          { "mix-blend": [...Wt(), "plus-lighter", "plus-darker"] },
        ],
        "bg-blend": [{ "bg-blend": Wt() }],
        filter: [{ filter: ["", "none"] }],
        blur: [{ blur: [n] }],
        brightness: [{ brightness: [r] }],
        contrast: [{ contrast: [a] }],
        "drop-shadow": [{ "drop-shadow": ["", "none", it, L] }],
        grayscale: [{ grayscale: [c] }],
        "hue-rotate": [{ "hue-rotate": [p] }],
        invert: [{ invert: [h] }],
        saturate: [{ saturate: [f] }],
        sepia: [{ sepia: [C] }],
        "backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
        "backdrop-blur": [{ "backdrop-blur": [n] }],
        "backdrop-brightness": [{ "backdrop-brightness": [r] }],
        "backdrop-contrast": [{ "backdrop-contrast": [a] }],
        "backdrop-grayscale": [{ "backdrop-grayscale": [c] }],
        "backdrop-hue-rotate": [{ "backdrop-hue-rotate": [p] }],
        "backdrop-invert": [{ "backdrop-invert": [h] }],
        "backdrop-opacity": [{ "backdrop-opacity": [d] }],
        "backdrop-saturate": [{ "backdrop-saturate": [f] }],
        "backdrop-sepia": [{ "backdrop-sepia": [C] }],
        "border-collapse": [{ border: ["collapse", "separate"] }],
        "border-spacing": [{ "border-spacing": [i] }],
        "border-spacing-x": [{ "border-spacing-x": [i] }],
        "border-spacing-y": [{ "border-spacing-y": [i] }],
        "table-layout": [{ table: ["auto", "fixed"] }],
        caption: [{ caption: ["top", "bottom"] }],
        transition: [
          {
            transition: [
              "none",
              "all",
              "",
              "colors",
              "opacity",
              "shadow",
              "transform",
              L,
            ],
          },
        ],
        duration: [{ duration: M() }],
        ease: [{ ease: ["linear", "in", "out", "in-out", L] }],
        delay: [{ delay: M() }],
        animate: [{ animate: ["none", "spin", "ping", "pulse", "bounce", L] }],
        transform: [{ transform: ["", "gpu", "none"] }],
        scale: [{ scale: [y] }],
        "scale-x": [{ "scale-x": [y] }],
        "scale-y": [{ "scale-y": [y] }],
        rotate: [{ rotate: [Ln, L] }],
        "translate-x": [{ "translate-x": [z] }],
        "translate-y": [{ "translate-y": [z] }],
        "skew-x": [{ "skew-x": [k] }],
        "skew-y": [{ "skew-y": [k] }],
        "transform-origin": [
          {
            origin: [
              "center",
              "top",
              "top-right",
              "right",
              "bottom-right",
              "bottom",
              "bottom-left",
              "left",
              "top-left",
              L,
            ],
          },
        ],
        accent: [{ accent: ["auto", e] }],
        appearance: [{ appearance: ["none", "auto"] }],
        cursor: [
          {
            cursor: [
              "auto",
              "default",
              "pointer",
              "wait",
              "text",
              "move",
              "help",
              "not-allowed",
              "none",
              "context-menu",
              "progress",
              "cell",
              "crosshair",
              "vertical-text",
              "alias",
              "copy",
              "no-drop",
              "grab",
              "grabbing",
              "all-scroll",
              "col-resize",
              "row-resize",
              "n-resize",
              "e-resize",
              "s-resize",
              "w-resize",
              "ne-resize",
              "nw-resize",
              "se-resize",
              "sw-resize",
              "ew-resize",
              "ns-resize",
              "nesw-resize",
              "nwse-resize",
              "zoom-in",
              "zoom-out",
              L,
            ],
          },
        ],
        "caret-color": [{ caret: [e] }],
        "pointer-events": [{ "pointer-events": ["none", "auto"] }],
        resize: [{ resize: ["none", "y", "x", ""] }],
        "scroll-behavior": [{ scroll: ["auto", "smooth"] }],
        "scroll-m": [{ "scroll-m": A() }],
        "scroll-mx": [{ "scroll-mx": A() }],
        "scroll-my": [{ "scroll-my": A() }],
        "scroll-ms": [{ "scroll-ms": A() }],
        "scroll-me": [{ "scroll-me": A() }],
        "scroll-mt": [{ "scroll-mt": A() }],
        "scroll-mr": [{ "scroll-mr": A() }],
        "scroll-mb": [{ "scroll-mb": A() }],
        "scroll-ml": [{ "scroll-ml": A() }],
        "scroll-p": [{ "scroll-p": A() }],
        "scroll-px": [{ "scroll-px": A() }],
        "scroll-py": [{ "scroll-py": A() }],
        "scroll-ps": [{ "scroll-ps": A() }],
        "scroll-pe": [{ "scroll-pe": A() }],
        "scroll-pt": [{ "scroll-pt": A() }],
        "scroll-pr": [{ "scroll-pr": A() }],
        "scroll-pb": [{ "scroll-pb": A() }],
        "scroll-pl": [{ "scroll-pl": A() }],
        "snap-align": [{ snap: ["start", "end", "center", "align-none"] }],
        "snap-stop": [{ snap: ["normal", "always"] }],
        "snap-type": [{ snap: ["none", "x", "y", "both"] }],
        "snap-strictness": [{ snap: ["mandatory", "proximity"] }],
        touch: [{ touch: ["auto", "none", "manipulation"] }],
        "touch-x": [{ "touch-pan": ["x", "left", "right"] }],
        "touch-y": [{ "touch-pan": ["y", "up", "down"] }],
        "touch-pz": ["touch-pinch-zoom"],
        select: [{ select: ["none", "text", "all", "auto"] }],
        "will-change": [
          { "will-change": ["auto", "scroll", "contents", "transform", L] },
        ],
        fill: [{ fill: [e, "none"] }],
        "stroke-w": [{ stroke: [He, ot, so] }],
        stroke: [{ stroke: [e, "none"] }],
        sr: ["sr-only", "not-sr-only"],
        "forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }],
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: [
          "inset-x",
          "inset-y",
          "start",
          "end",
          "top",
          "right",
          "bottom",
          "left",
        ],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": [
          "fvn-ordinal",
          "fvn-slashed-zero",
          "fvn-figure",
          "fvn-spacing",
          "fvn-fraction",
        ],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: [
          "rounded-s",
          "rounded-e",
          "rounded-t",
          "rounded-r",
          "rounded-b",
          "rounded-l",
          "rounded-ss",
          "rounded-se",
          "rounded-ee",
          "rounded-es",
          "rounded-tl",
          "rounded-tr",
          "rounded-br",
          "rounded-bl",
        ],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": [
          "border-w-s",
          "border-w-e",
          "border-w-t",
          "border-w-r",
          "border-w-b",
          "border-w-l",
        ],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": [
          "border-color-s",
          "border-color-e",
          "border-color-t",
          "border-color-r",
          "border-color-b",
          "border-color-l",
        ],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        "scroll-m": [
          "scroll-mx",
          "scroll-my",
          "scroll-ms",
          "scroll-me",
          "scroll-mt",
          "scroll-mr",
          "scroll-mb",
          "scroll-ml",
        ],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": [
          "scroll-px",
          "scroll-py",
          "scroll-ps",
          "scroll-pe",
          "scroll-pt",
          "scroll-pr",
          "scroll-pb",
          "scroll-pl",
        ],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"],
      },
      conflictingClassGroupModifiers: { "font-size": ["leading"] },
    };
  },
  vm = Zp(gm);
function _e(...e) {
  return vm(Ic(e));
}
const ym = Ip(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
    {
      variants: {
        variant: {
          default: "bg-primary text-primary-foreground",
          destructive: "bg-destructive text-destructive-foreground",
          outline: "border border-input bg-background",
          secondary: "bg-secondary text-secondary-foreground",
          ghost: "",
          link: "text-primary underline-offset-4",
        },
        size: {
          default: "h-10 px-4 py-2",
          sm: "h-9 rounded-md px-3",
          lg: "h-11 rounded-md px-8",
          icon: "h-10 w-10",
        },
      },
      defaultVariants: { variant: "default", size: "default" },
    },
  ),
  Qn = F.forwardRef(
    ({ className: e, variant: t, size: n, asChild: r = !1, ...l }, o) => {
      const i = r ? bp : "button";
      return S.jsx(i, {
        className: _e(ym({ variant: t, size: n, className: e })),
        ref: o,
        ...l,
      });
    },
  );
Qn.displayName = "Button";
function wm({ question: e, selected: t, onSelect: n, animKey: r }) {
  return S.jsxs(
    "div",
    {
      className: "animate-fade-up",
      style: { animationFillMode: "both" },
      children: [
        S.jsxs("div", {
          className: "mb-8",
          children: [
            S.jsxs("span", {
              className:
                "font-dm text-xs font-semibold tracking-[0.18em] uppercase text-muted-foreground",
              children: ["Question ", e.number, " of 6"],
            }),
            S.jsx("h2", {
              className: "ssf-hero-title mt-3 text-foreground",
              children: e.question,
            }),
          ],
        }),
        S.jsx("div", {
          className: _e(
            "grid gap-3",
            e.options.length === 2
              ? "grid-cols-1 sm:grid-cols-2"
              : "grid-cols-1",
          ),
          children: e.options.map((l, o) => {
            const i = t === l.value;
            return S.jsxs(
              "button",
              {
                onClick: () => n(l.value),
                className: _e(
                  "option-card text-left px-6 py-5 rounded border cursor-pointer",
                  "flex items-center justify-between gap-4",
                  i
                    ? "selected border-primary bg-primary/8 shadow-sm"
                    : "border-border bg-card",
                ),
                style: { animationDelay: `${o * 60}ms` },
                children: [
                  S.jsxs("div", {
                    className: "flex items-start gap-4",
                    children: [
                      S.jsx("span", {
                        className: _e(
                          "mt-0.5 flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center font-dm text-xs font-semibold",
                          i
                            ? "border-primary bg-primary text-primary-foreground"
                            : "border-muted-foreground/30 text-muted-foreground",
                        ),
                        children: String.fromCharCode(65 + o),
                      }),
                      S.jsxs("div", {
                        children: [
                          S.jsx("p", {
                            className: _e(
                              "font-dm font-medium text-base",
                              i ? "text-primary" : "text-foreground",
                            ),
                            children: l.label,
                          }),
                          l.detail &&
                            S.jsx("p", {
                              className:
                                "font-dm text-sm text-muted-foreground mt-0.5 leading-snug",
                              children: l.detail,
                            }),
                        ],
                      }),
                    ],
                  }),
                  S.jsx("div", {
                    className: _e(
                      "flex-shrink-0 w-5 h-5 rounded-full border-2",
                      i
                        ? "border-primary bg-primary scale-110"
                        : "border-muted-foreground/30",
                    ),
                    children:
                      i &&
                      S.jsx("div", {
                        className:
                          "w-full h-full rounded-full flex items-center justify-center",
                        children: S.jsx("div", {
                          className:
                            "w-2 h-2 rounded-full bg-primary-foreground",
                        }),
                      }),
                  }),
                ],
              },
              l.value,
            );
          }),
        }),
      ],
    },
    r,
  );
}
const xm = {
    violin: "Violin",
    viola: "Viola",
    cello: "Cello",
    doublebass: "Double Bass",
  },
  Sm = {
    beginner: "Beginner",
    advancing: "Advancing Musician",
    professional: "Professional Player",
  };
function km(e) {
  const t = (r) =>
      new Date(r.getFullYear(), r.getMonth(), r.getDate()).getTime(),
    n = Math.round((t(new Date()) - t(e)) / 864e5);
  return n <= 0
    ? "today"
    : n === 1
      ? "yesterday"
      : e.toLocaleDateString("en-AU", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
}
const Cm = ["Best Match", "Great Alternative", "Also Consider"],
  Em = [
    "bg-primary text-primary-foreground",
    "bg-secondary text-secondary-foreground border border-border",
    "bg-muted text-muted-foreground border border-border",
  ];
async function Pm(e) {
  const t = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: e, quantity: 1 }] }),
  });
  if (!t.ok) {
    const r = await t.json().catch(() => null);
    throw new Error(
      (r == null ? void 0 : r.description) ||
        (r == null ? void 0 : r.message) ||
        "Couldn't add that to your cart.",
    );
  }
  const n = window.jQuery;
  try {
    const r = n == null ? void 0 : n(".js-drawer-open-right");
    r != null && r.length && r.click();
  } catch {}
}
function Nm({
  recommendations: e,
  answers: t,
  pricesUpdatedAt: n,
  onRetake: r,
}) {
  const l = t.instrument ? xm[t.instrument] : "your instrument",
    o = t.level ? Sm[t.level] : "",
    [i, s] = F.useState({}),
    a = F.useRef({});
  F.useEffect(() => {
    const p = a.current;
    return () => {
      Object.values(p).forEach(clearTimeout);
    };
  }, []);
  async function c(p) {
    if (p.variantId) {
      s((h) => ({ ...h, [p.name]: "adding" }));
      try {
        (await Pm(p.variantId),
          s((h) => ({ ...h, [p.name]: "added" })),
          clearTimeout(a.current[p.name]),
          (a.current[p.name] = setTimeout(() => {
            s((h) => ({ ...h, [p.name]: "idle" }));
          }, 1800)));
      } catch {
        s((h) => ({ ...h, [p.name]: "error" }));
      }
    }
  }
  return S.jsxs("div", {
    className: "animate-fade-up",
    children: [
      S.jsxs("div", {
        className: "mb-10",
        children: [
          S.jsx("span", {
            className:
              "font-dm text-xs font-semibold tracking-[0.18em] uppercase text-muted-foreground",
            children: "Your Results",
          }),
          S.jsxs("h2", {
            className: "ssf-hero-title mt-3 text-foreground",
            children: ["Your perfect ", l, " strings"],
          }),
          o &&
            S.jsxs("p", {
              className: "font-dm text-sm text-muted-foreground mt-2",
              children: [
                "Tailored for a ",
                o.toLowerCase(),
                " — ",
                t.tone === "bright" ? "bright tone" : "warm tone",
                ",",
                " ",
                t.context === "orchestral"
                  ? "orchestral setting"
                  : "solo playing",
              ],
            }),
        ],
      }),
      S.jsx("div", {
        className: "space-y-4 mb-10",
        children: e.map((p, h) => {
          const m = !!p.variantId && p.available !== !1,
            v = i[p.name] ?? "idle";
          return S.jsxs(
            "div",
            {
              className: _e(
                "rounded border bg-card overflow-hidden animate-fade-up",
                h === 0 && "border-primary/40 shadow-sm",
              ),
              style: { animationDelay: `${h * 100}ms` },
              children: [
                S.jsxs("div", {
                  className: "flex items-center justify-between px-5 pt-4 pb-2",
                  children: [
                    S.jsx("span", {
                      className: _e(
                        "font-dm text-[11px] font-semibold tracking-[0.12em] uppercase px-2.5 py-1 rounded-full",
                        Em[h],
                      ),
                      children: Cm[h],
                    }),
                    S.jsx("div", {
                      className: "flex items-center gap-1",
                      children: Array.from({ length: 3 - h }).map((w, g) =>
                        S.jsx(
                          jp,
                          {
                            className: _e(
                              "w-3.5 h-3.5",
                              h === 0
                                ? "fill-gold text-gold"
                                : "fill-muted-foreground/30 text-muted-foreground/30",
                            ),
                          },
                          g,
                        ),
                      ),
                    }),
                  ],
                }),
                S.jsxs("div", {
                  className: "px-5 pb-5",
                  children: [
                    S.jsxs("div", {
                      className: "flex items-start justify-between gap-4 mb-2",
                      children: [
                        S.jsxs("div", {
                          children: [
                            S.jsx("p", {
                              className:
                                "font-dm text-[11px] font-medium tracking-wider uppercase text-muted-foreground mb-1",
                              children: p.brand,
                            }),
                            S.jsx("h3", {
                              className:
                                "font-playfair text-lg font-normal text-foreground leading-snug",
                              children: p.name,
                            }),
                            S.jsxs("p", {
                              className:
                                "font-dm text-sm italic text-muted-foreground mt-0.5",
                              children: ['"', p.tagline, '"'],
                            }),
                          ],
                        }),
                        S.jsxs("div", {
                          className: "text-right flex-shrink-0",
                          children: [
                            S.jsx("p", {
                              className:
                                "font-playfair text-xl font-normal text-foreground",
                              children: p.price,
                            }),
                            S.jsx("p", {
                              className:
                                "font-dm text-xs text-muted-foreground",
                              children: "AUD",
                            }),
                          ],
                        }),
                      ],
                    }),
                    S.jsx("p", {
                      className:
                        "font-dm text-sm text-muted-foreground leading-relaxed mt-3",
                      children: p.description,
                    }),
                    S.jsxs("div", {
                      className: "flex flex-wrap gap-1.5 mt-3",
                      children: [
                        S.jsx("span", {
                          className: _e(
                            "font-dm text-[11px] px-2 py-0.5 rounded-full border",
                            p.tone === "bright"
                              ? "border-amber-300/50 text-amber-700 bg-amber-50 dark:text-amber-400 dark:bg-amber-950/30"
                              : p.tone === "warm"
                                ? "border-rose-300/50 text-rose-700 bg-rose-50 dark:text-rose-400 dark:bg-rose-950/30"
                                : "border-border text-muted-foreground bg-muted",
                          ),
                          children:
                            p.tone === "bright"
                              ? "Bright tone"
                              : p.tone === "warm"
                                ? "Warm tone"
                                : "Balanced tone",
                        }),
                        p.suitedFor
                          .slice(0, 2)
                          .map((w) =>
                            S.jsx(
                              "span",
                              {
                                className:
                                  "font-dm text-[11px] px-2 py-0.5 rounded-full border border-border text-muted-foreground bg-muted",
                                children: w,
                              },
                              w,
                            ),
                          ),
                        p.available === !1 &&
                          S.jsx("span", {
                            className:
                              "font-dm text-[11px] px-2 py-0.5 rounded-full border border-border text-muted-foreground bg-muted",
                            children: "Out of stock",
                          }),
                      ],
                    }),
                    S.jsxs("div", {
                      className: "mt-4 flex flex-wrap items-center gap-3",
                      children: [
                        m &&
                          S.jsx("button", {
                            type: "button",
                            disabled: v === "adding",
                            onClick: () => c(p),
                            className: "ssf-btn-pdp",
                            children:
                              v === "added"
                                ? S.jsxs(S.Fragment, {
                                    children: [
                                      S.jsx(Pp, { className: "w-3.5 h-3.5" }),
                                      "Added",
                                    ],
                                  })
                                : S.jsxs(S.Fragment, {
                                    children: [
                                      S.jsx(Tp, { className: "w-3.5 h-3.5" }),
                                      v === "adding"
                                        ? "Adding…"
                                        : "Add to Cart",
                                    ],
                                  }),
                          }),
                        S.jsxs("a", {
                          href: p.url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          className: _e(
                            "inline-flex items-center gap-2 font-dm text-sm font-medium",
                            m
                              ? "text-muted-foreground"
                              : h === 0
                                ? "text-primary"
                                : "text-muted-foreground",
                          ),
                          children: [
                            "View product",
                            S.jsx(_p, { className: "w-3.5 h-3.5" }),
                          ],
                        }),
                        v === "error" &&
                          S.jsx("span", {
                            className: "font-dm text-[11px] text-destructive",
                            children: `Couldn't add to cart — try "View product" instead.`,
                          }),
                      ],
                    }),
                  ],
                }),
              ],
            },
            p.name,
          );
        }),
      }),
      S.jsxs("div", {
        className:
          "border-t border-border pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4",
        children: [
          S.jsxs("div", {
            className: "max-w-sm",
            children: [
              S.jsxs("p", {
                className:
                  "font-dm text-xs text-muted-foreground leading-relaxed",
                children: [
                  "Not sure? Simply for Strings will fit any strings purchased from them to your instrument ",
                  S.jsx("strong", { children: "for free" }),
                  ".",
                ],
              }),
              n
                ? S.jsxs("p", {
                    className:
                      "font-dm text-[11px] text-muted-foreground/70 mt-2",
                    children: ["Prices updated ", km(n)],
                  })
                : null,
            ],
          }),
          S.jsxs(Qn, {
            variant: "outline",
            size: "sm",
            onClick: r,
            className: "flex items-center gap-2 font-dm text-sm shrink-0",
            children: [S.jsx(zp, { className: "w-3.5 h-3.5" }), "Retake Quiz"],
          }),
        ],
      }),
    ],
  });
}
const _m = "ssf-price-catalog";
function zm() {
  if (typeof document > "u") return;
  const e = document.getElementById(_m);
  if (e != null && e.textContent)
    try {
      return JSON.parse(e.textContent);
    } catch {
      return;
    }
}
function Tm() {
  const e = F.useMemo(zm, []),
    t = e != null && e.prices ? Object.entries(e.prices) : [],
    n = t.length
      ? Object.fromEntries(
          t
            .filter(
              ([, l]) =>
                typeof (l == null ? void 0 : l.price) == "string" &&
                l.price.length > 0,
            )
            .map(([l, o]) => [
              l,
              {
                price: o.price,
                available: o.available !== !1,
                variantId: o.variantId ?? null,
                image: o.image ?? null,
                url: o.url ?? null,
              },
            ]),
        )
      : void 0,
    r = e != null && e.syncedAtUnix ? new Date(e.syncedAtUnix * 1e3) : void 0;
  return {
    livePrices: n,
    syncedAt: r && !Number.isNaN(r.getTime()) ? r : void 0,
    isLoading: !1,
  };
}
const jm = [
    {
      name: "D'Addario Prelude Violin String Set 4/4",
      brand: "D'Addario",
      price: "$48.00",
      url: "/products/prelude-violin-string-set-4-4",
      tagline: "The go-to student string",
      description:
        "Solid steel core strings optimised for warmth and playability. Clear sound, quick response, and excellent durability — perfect for beginners establishing their tone.",
      suitedFor: ["Students", "Beginners"],
      tone: "bright",
      level: ["beginner"],
    },
    {
      name: "Pirastro Piranito Violin String Set 4/4",
      brand: "Pirastro",
      price: "$80.45",
      url: "/products/piranito-violin-string-set-4-4",
      tagline: "Entry-level with German quality",
      description:
        "Pirastro's entry-level offering delivers a balanced tone with reliable intonation. A great first step into quality German string-making for young players.",
      suitedFor: ["Beginners", "Students"],
      tone: "balanced",
      level: ["beginner"],
    },
    {
      name: "Pirastro Tonica Violin String Set 4/4",
      brand: "Pirastro",
      price: "$85.30",
      url: "/products/tonica-violin-string-set-4-4",
      tagline: "Bright, open, and responsive",
      description:
        "Nylon-core strings that reward players at every stage. Open, direct sound with a bright character and quick response — ideal for those progressing beyond steel strings.",
      suitedFor: ["Advancing students", "Orchestral players"],
      tone: "bright",
      level: ["beginner", "advancing"],
    },
    {
      name: "D'Addario Helicore Violin String Set 4/4",
      brand: "D'Addario",
      price: "$101.70",
      url: "/products/helicore-violin-string-set-4-4",
      tagline: "Focused tone, quick response",
      description:
        "Multi-strand steel core with a focused, clear tone. Quick response under the bow makes these ideal for orchestral playing, with excellent tuning stability.",
      suitedFor: ["Advancing students", "Orchestral players"],
      tone: "bright",
      level: ["advancing"],
    },
    {
      name: "Thomastik Dominant Violin String Set 4/4",
      brand: "Thomastik",
      price: "$131.45",
      url: "/products/dominant-violin-string-set-4-4",
      tagline: "The industry benchmark",
      description:
        "The world's most trusted violin string. Multi-strand nylon core produces a full, mellow sound with rich overtones comparable to gut — without gut's instability. Used by players at every level.",
      suitedFor: ["All levels", "Orchestral", "Classical"],
      tone: "warm",
      level: ["advancing", "professional"],
    },
    {
      name: "Larsen Violin String Set 4/4",
      brand: "Larsen",
      price: "$140.35",
      url: "/products/larsen-violin-string-set-4-4",
      tagline: "Danish craftsmanship, expressive tone",
      description:
        "Larsen strings are renowned for their expressive tone and tonal depth. A warm, rich sound with excellent bow response — a favourite among advancing players seeking more colour.",
      suitedFor: ["Advancing players", "Classical"],
      tone: "warm",
      level: ["advancing", "professional"],
    },
    {
      name: "Larsen Tzigane Violin String Set 4/4",
      brand: "Larsen",
      price: "$145.20",
      url: "/products/larsen-tzigane-violin-string-set",
      tagline: "Designed for folk and gypsy styles",
      description:
        "Named after the Romani violin tradition, the Tzigane is engineered for brilliance and projection in folk and crossover styles. Powerful and penetrating — perfect for players who push outside classical boundaries.",
      suitedFor: ["Folk players", "Soloists"],
      tone: "bright",
      level: ["advancing", "professional"],
    },
    {
      name: "Larsen Virtuoso Violin String Set 4/4",
      brand: "Larsen",
      price: "$149.05",
      url: "/products/larsen-virtuoso-violin-string-set",
      tagline: "Soloist-grade projection",
      description:
        "Built for the concert stage. The Virtuoso delivers powerful projection with a brilliant, focused tone ideal for cutting through an orchestra as a soloist.",
      suitedFor: ["Soloists", "Professional players"],
      tone: "bright",
      level: ["professional"],
    },
    {
      name: "Pirastro Evah Pirazzi Violin String Set 4/4",
      brand: "Pirastro",
      price: "$208.10",
      url: "/products/evah-pirazzi-violin-string-set-4-4-e-ball-end",
      tagline: "The soloist's favourite",
      description:
        "The most-used professional violin string in the world. Complex, warm tone with enormous dynamic range and outstanding projection. Used by Joshua Bell and countless professionals.",
      suitedFor: ["Soloists", "Professional players", "Orchestral leaders"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Evah Pirazzi Gold Violin String Set 4/4",
      brand: "Pirastro",
      price: "$233.10",
      url: "/products/evah-pirazzi-gold-violin-string-set-e-ball-end-g-silver",
      tagline: "Gold-wound warmth and depth",
      description:
        "The gold E string variant of the legendary Evah Pirazzi. Deeper, richer overtones with even more warmth — the pinnacle for players who prize a dark, complex tone.",
      suitedFor: ["Professional soloists", "Warm tone seekers"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Obligato Violin String Set 4/4",
      brand: "Pirastro",
      price: "$217.35",
      url: "/products/obligato-violin-string-set-4-4-e-steel-ball-end",
      tagline: "Gut-like warmth in a modern string",
      description:
        "The closest synthetic strings come to the gut string experience. Rich overtones, a velvety warm tone, and exceptional tonal complexity — beloved for Baroque and chamber music.",
      suitedFor: ["Baroque players", "Chamber musicians", "Warm tone seekers"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Eudoxa Violin String Set 4/4 (E — Ball End)",
      brand: "Pirastro",
      price: "$254.35",
      url: "/products/eudoxa-violin-string-set-e-ball-end",
      tagline: "True wound gut — the historical sound",
      description:
        "A genuine sheep gut core wound in aluminium and silver. Eudoxa has been the reference gut string since 1919: warm, vocal and endlessly complex, with the soft attack and low tension Baroque repertoire is written for. Gut needs more tuning than synthetics — the tone is the reward.",
      suitedFor: ["Baroque players", "Gut core", "Historical performance"],
      tone: "warm",
      level: ["advancing", "professional"],
      gut: !0,
    },
    {
      name: "Pirastro Passione Violin String Set 4/4 (E — Ball End)",
      brand: "Pirastro",
      price: "$326.50",
      url: "/products/passione-violin-string-set-e-ball-end",
      tagline: "Modern gut — rich tone, far more stable",
      description:
        "A real gut core built with modern winding techniques, so you get gut's depth, warmth and expressive range with much better tuning stability. The most practical way into gut strings for players who perform regularly.",
      suitedFor: ["Baroque players", "Gut core", "Chamber musicians"],
      tone: "warm",
      level: ["advancing", "professional"],
      gut: !0,
    },
    {
      name: "Pirastro Oliv Violin String Set 4/4 (sold as singles)",
      brand: "Pirastro",
      price: "$409.45",
      url: "/collections/shop?q=Oliv%20Violin%20String",
      priceKey: "oliv-violin-set-singles",
      tagline: "Pirastro's finest gut string",
      description:
        "Gold and silver wound over a premium gut core — brilliant, velvety and unmatched for tonal colour. Simply for Strings stocks Oliv as individual strings so you can choose your gauges; the price shown is for a full set of four.",
      suitedFor: ["Baroque players", "Gut core", "Soloists"],
      tone: "warm",
      level: ["professional"],
      gut: !0,
    },
  ],
  Lm = [
    {
      name: "Thomastik Alphayue Viola String Set",
      brand: "Thomastik",
      price: "$125.70",
      url: "/products/thomastik-alphayue-viola-string-set-3-4",
      tagline: "Bright and clear for beginners",
      description:
        "A student-friendly synthetic string with a bright, clear tone. Excellent tuning stability and quick response — ideal for beginners developing their ear and technique.",
      suitedFor: ["Beginners", "Students"],
      tone: "bright",
      level: ["beginner"],
    },
    {
      name: 'Pirastro Piranito Viola String Set 15"–16.5"',
      brand: "Pirastro",
      price: "$118.85",
      url: "/products/piranito-viola-string-set",
      tagline: "Reliable entry-level tone",
      description:
        "Pirastro's student offering for viola. A dependable, even tone with the quality control you'd expect from one of the world's leading string makers.",
      suitedFor: ["Beginners", "Students"],
      tone: "balanced",
      level: ["beginner"],
    },
    {
      name: 'Pirastro Tonica Viola String Set 15"–16.5"',
      brand: "Pirastro",
      price: "$141.05",
      url: "/products/tonica-viola-string-set",
      tagline: "Open sound, quick response",
      description:
        "Nylon-core strings with a bright, even tone across the instrument. Great for advancing students seeking more tonal character from their playing.",
      suitedFor: ["Advancing students", "Orchestral players"],
      tone: "bright",
      level: ["beginner", "advancing"],
    },
    {
      name: `D'Addario Helicore Viola String Set 15"–16"`,
      brand: "D'Addario",
      price: "$150.70",
      url: "/products/helicore-viola-string-set",
      tagline: "Steel precision, quick response",
      description:
        "Multi-strand steel core viola strings with excellent clarity and focus. Great for orchestra sections where intonation precision and response speed matter.",
      suitedFor: ["Advancing players", "Orchestral players"],
      tone: "bright",
      level: ["advancing"],
    },
    {
      name: 'Larsen Aurora Viola String Set 15"–16.5"',
      brand: "Larsen",
      price: "$157.75",
      url: "/products/larsen-aurora-viola-string-set",
      tagline: "Warm clarity for advancing players",
      description:
        "Larsen's mid-tier viola string delivers the brand's signature tonal warmth at an accessible price. A meaningful upgrade for advancing players wanting more expressive colour.",
      suitedFor: ["Advancing players", "Classical"],
      tone: "warm",
      level: ["advancing"],
    },
    {
      name: "D'Addario Kaplan Amo Viola String Set",
      brand: "D'Addario",
      price: "$172.75",
      url: "/products/kaplan-amo-viola-string-set",
      tagline: "Rich warmth and depth",
      description:
        "The Kaplan Amo is built for players who want a warm, dark viola tone. Deep resonance and rich overtones make it a standout choice for chamber and orchestral playing.",
      suitedFor: ["Orchestral players", "Chamber musicians"],
      tone: "warm",
      level: ["advancing", "professional"],
    },
    {
      name: "D'Addario Kaplan Vivo Viola String Set",
      brand: "D'Addario",
      price: "$172.75",
      url: "/products/kaplan-vivo-viola-string-set",
      tagline: "Brilliant projection for soloists",
      description:
        "The Kaplan Vivo is the brighter counterpart to the Amo. Excellent projection and articulation — ideal for soloists who need to carry above an ensemble.",
      suitedFor: ["Soloists", "Advancing players"],
      tone: "bright",
      level: ["advancing", "professional"],
    },
    {
      name: 'Thomastik Dominant Viola String Set 15"–16.5"',
      brand: "Thomastik",
      price: "$231.30",
      url: "/products/dominant-viola-string-set",
      tagline: "The trusted professional standard",
      description:
        "The benchmark viola string. Multi-strand nylon core producing a sweet, mellow tone with the versatility to suit orchestral sections and soloists alike.",
      suitedFor: ["All levels", "Orchestral", "Classical"],
      tone: "warm",
      level: ["advancing", "professional"],
    },
    {
      name: 'Warchal Brilliant Viola String Set 15"–16"',
      brand: "Warchal",
      price: "$171.10",
      url: "/products/warchal-brilliant-viola-string-set",
      tagline: "Handcrafted brilliance",
      description:
        "Slovak-made strings with a crisp, brilliant character. Excellent bow sensitivity and quick response — a distinctive choice for soloists who want to stand out.",
      suitedFor: ["Soloists", "Folk players"],
      tone: "bright",
      level: ["advancing", "professional"],
    },
    {
      name: 'Pirastro Evah Pirazzi Viola String Set 15"–16.5"',
      brand: "Pirastro",
      price: "$306.15",
      url: "/products/evah-pirazzi-viola-string-set",
      tagline: "Power, complexity, and projection",
      description:
        "Professional-grade strings with enormous dynamic range and complex, warm tone. One of the most popular choices among professional viola players worldwide.",
      suitedFor: ["Professional players", "Soloists"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: 'Thomastik Peter Infeld Viola Set 15"–16.5"',
      brand: "Thomastik",
      price: "$377.20",
      url: "/products/peter-infeld-viola-set",
      tagline: "Complex, sweet, and refined",
      description:
        "Among the finest viola strings available. The PI set rewards the professional player with a complex, sweet tone and exceptional playability in all musical contexts.",
      suitedFor: ["Professional players", "Classical", "Chamber"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: 'Thomastik Rondo Viola String Set 15"–16.5"',
      brand: "Thomastik",
      price: "$341.70",
      url: "/products/thomastik-rondo-viola-string-set",
      tagline: "The pinnacle of modern string-making",
      description:
        "Thomastik's flagship viola string. Warm, powerful, and supremely balanced — designed for the concert soloist who demands nothing but the very best.",
      suitedFor: ["Professional soloists", "Orchestral leaders"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Thomastik Dynamo Viola String Set",
      brand: "Thomastik",
      price: "$371.45",
      url: "/products/thomastik-dynamo-viola-string-set",
      tagline: "The most neutral, organic sound",
      description:
        "Thomastik's newest and most advanced viola string. Players describe a tone that doesn't sound metallic or synthetic — just pure, organic viola. The ultimate expression of modern string technology.",
      suitedFor: ["Professional players", "Solo and orchestral"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: 'Pirastro Passione Viola String Set 15"–16.5"',
      brand: "Pirastro",
      price: "$371.85",
      url: "/products/passione-viola-string-set",
      tagline: "Modern gut — rich tone, far more stable",
      description:
        "A genuine gut core with modern windings. Deep, warm and remarkably expressive on the viola, with far better tuning stability than traditional gut — the practical choice for Baroque and early music players who perform often.",
      suitedFor: ["Baroque players", "Gut core", "Chamber musicians"],
      tone: "warm",
      level: ["advancing", "professional"],
      gut: !0,
    },
    {
      name: 'Pirastro Eudoxa Viola String Set 15"–16.5" (sold as singles)',
      brand: "Pirastro",
      price: "$398.20",
      url: "/collections/shop?q=Eudoxa%20Viola%20String",
      priceKey: "eudoxa-viola-set-singles",
      tagline: "True wound gut — the historical sound",
      description:
        "Wound sheep gut, the reference for historical performance since 1919. Soft attack, low tension and a warm, vocal tone made for Baroque repertoire. Stocked as individual strings so you can pick your gauges; the price shown is for a full set of four.",
      suitedFor: ["Baroque players", "Gut core", "Historical performance"],
      tone: "warm",
      level: ["advancing", "professional"],
      gut: !0,
    },
  ],
  Rm = [
    {
      name: "Jargar Young Talent Cello String Set",
      brand: "Jargar",
      price: "$251.55",
      url: "/products/jargar-young-talent-cello-string-set-3-4",
      tagline: "Mellow, even tone for students",
      description:
        "Danish strings designed for young and advancing cellists. A mellow, even tone that is quick to respond and encourages musical exploration without breaking the bank.",
      suitedFor: ["Beginners", "Young players"],
      tone: "warm",
      level: ["beginner"],
    },
    {
      name: "D'Addario Helicore Cello String Set 4/4",
      brand: "D'Addario",
      price: "$297.50",
      url: "/products/daddario-helicore-4-4-cello-set-medium",
      tagline: "Focused, clear, and reliable",
      description:
        "Multi-strand steel core strings with a focused, clear tone and remarkable tuning stability. A dependable choice for advancing cellists in orchestra settings.",
      suitedFor: ["Advancing players", "Orchestral players"],
      tone: "bright",
      level: ["advancing"],
    },
    {
      name: "Larsen Cello String Set 4/4 Soloist",
      brand: "Larsen",
      price: "$580.70",
      url: "/products/larsen-soloist-cello-string-set-4-4",
      tagline: "Powerful warmth for the concert stage",
      description:
        "Larsen's standard soloist cello string. Strong, warm tone with excellent projection — crafted for cellists who need to be heard over an orchestra.",
      suitedFor: ["Soloists", "Professional players"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Thomastik Versum Cello String Set 4/4",
      brand: "Thomastik",
      price: "$609.45",
      url: "/products/versum-cello-string-set-4-4",
      tagline: "Versatile professional quality",
      description:
        "A sophisticated cello string with a complex, multilayered tone. The Versum adapts beautifully to both orchestral and solo contexts — a professional workhorse.",
      suitedFor: ["Professional players", "Orchestral and solo"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Obligato Cello String Set 4/4",
      brand: "Pirastro",
      price: "$735.86",
      url: "/products/obligato-cello-string-set-4-4",
      tagline: "Gut-like warmth in a modern string",
      description:
        "Rich, velvety tone with gut-string character. Beloved for Baroque music and chamber playing — the Obligato conjures warmth and intimacy like few strings can.",
      suitedFor: ["Baroque players", "Chamber musicians"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Evah Pirazzi Cello String Set 4/4",
      brand: "Pirastro",
      price: "$718.80",
      url: "/products/evah-pirazzi-cello-string-set",
      tagline: "Warm, powerful, expressive",
      description:
        "A professional favourite worldwide. Deep, warm tone with extraordinary dynamic range — ideal for the modern cello soloist and leading orchestral players.",
      suitedFor: ["Soloists", "Professional players"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Larsen Magnacore Cello String Set 4/4",
      brand: "Larsen",
      price: "$698.75",
      url: "/products/larsen-magnacore-cello-string-set",
      tagline: "Powerful clarity and balance",
      description:
        "Larsen's flagship orchestral cello string, engineered for maximum power and clarity in orchestral settings. The Magnacore delivers a balanced tone that projects beautifully across the hall.",
      suitedFor: ["Orchestral players", "Professional players"],
      tone: "balanced",
      level: ["professional"],
    },
    {
      name: "Larsen Il Cannone Cello String Set 4/4 (Direct & Focused)",
      brand: "Larsen",
      price: "$740.40",
      url: "/products/larsen-il-cannone-cello-string-set-4-4-direct-and-focused",
      tagline: "Cannon-like projection for soloists",
      description:
        "Named for its cannon-like projection. The Direct & Focused variant has a bright, penetrating tone designed to cut through any ensemble. A landmark soloist string.",
      suitedFor: ["Soloists", "Professional players"],
      tone: "bright",
      level: ["professional"],
    },
    {
      name: "Larsen Il Cannone Cello String Set 4/4 (Warm & Broad)",
      brand: "Larsen",
      price: "$740.40",
      url: "/products/larsen-il-cannone-cello-string-set-4-4-warm-and-broad",
      tagline: "Rich warmth with extraordinary depth",
      description:
        "The Warm & Broad variant of Il Cannone offers a deeper, more resonant tone for cellists who want warmth alongside projection. Exceptional for Romantic repertoire.",
      suitedFor: ["Soloists", "Romantic repertoire"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Evah Pirazzi Gold Cello String Set",
      brand: "Pirastro",
      price: "$770.55",
      url: "/products/evah-pirazzi-gold-cello-string-set",
      tagline: "The ultimate warm professional string",
      description:
        "Gold-wound for maximum warmth and tonal complexity. The EP Gold is the choice of cellists who want the deepest, most nuanced tone available at the professional level.",
      suitedFor: ["Professional soloists", "Warm tone seekers"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Thomastik Rondo Cello String Set 4/4",
      brand: "Thomastik",
      price: "$865.70",
      url: "/products/thomastik-rondo-cello-string-set-4-4",
      tagline: "The apex of cello string technology",
      description:
        "Thomastik's premier cello offering — a warm, balanced, and profoundly resonant string that sits at the very top of the market. For the professional who will accept nothing less.",
      suitedFor: ["Top professional players"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Passione Cello String Set 4/4 (sold as singles)",
      brand: "Pirastro",
      price: "$692.35",
      url: "/collections/shop?q=Passione%20Cello%20String",
      priceKey: "passione-cello-set-singles",
      tagline: "Modern gut — rich tone, far more stable",
      description:
        "A genuine gut core with modern windings, giving the cello a deep, singing warmth with far better tuning stability than traditional gut. Simply for Strings stocks Passione cello as individual strings; the price shown is for a full set of four.",
      suitedFor: ["Baroque players", "Gut core", "Chamber musicians"],
      tone: "warm",
      level: ["advancing", "professional"],
      gut: !0,
    },
    {
      name: "Pirastro Eudoxa Cello String Set 4/4 (sold as singles)",
      brand: "Pirastro",
      price: "$727.65",
      url: "/collections/shop?q=Eudoxa%20Cello%20String",
      priceKey: "eudoxa-cello-set-singles",
      tagline: "True wound gut — the historical sound",
      description:
        "Wound sheep gut, the historical benchmark. Soft under the bow with a warm, complex, deeply vocal tone that suits Baroque and early Classical repertoire perfectly. Stocked as individual strings so you can choose gauges; the price shown is for a full set of four.",
      suitedFor: ["Baroque players", "Gut core", "Historical performance"],
      tone: "warm",
      level: ["advancing", "professional"],
      gut: !0,
    },
  ],
  bm = [
    {
      name: "D'Addario Prelude Double Bass String Set 3/4",
      brand: "D'Addario",
      price: "$230.30",
      url: "/products/daddario-prelude-bass-string-set-3-4",
      tagline: "The student standard",
      description:
        "Steel core strings designed specifically for students. Reliable tone, exceptional durability, and excellent value — the starting point for every young bassist.",
      suitedFor: ["Beginners", "Students"],
      tone: "bright",
      level: ["beginner"],
    },
    {
      name: "D'Addario Helicore Double Bass String Set 3/4",
      brand: "D'Addario",
      price: "$387.70",
      url: "/products/helicore-double-bass-string-set-3-4-hybrid",
      tagline: "Balanced hybrid for all settings",
      description:
        "Multi-strand steel core with excellent arco and pizzicato response. The Helicore Hybrid is one of the most versatile bass strings available — suitable for orchestral and folk playing.",
      suitedFor: ["Advancing players", "Orchestral", "Folk"],
      tone: "balanced",
      level: ["advancing"],
    },
    {
      name: "Thomastik Superflex Double Bass String Set 3/4",
      brand: "Thomastik",
      price: "$437.65",
      url: "/products/thomastik-superflex-double-bass-string-set-3-4",
      tagline: "Flexible and warm for all styles",
      description:
        "A warm, flexible string that is particularly forgiving for advancing players. Excellent pizzicato response alongside a warm arco tone makes this a versatile choice.",
      suitedFor: ["Advancing players", "Folk and jazz crossover"],
      tone: "warm",
      level: ["advancing"],
    },
    {
      name: "D'Addario Kaplan Double Bass String Set 3/4 (Medium)",
      brand: "D'Addario",
      price: "$467.40",
      url: "/products/kaplan-double-bass-string-set-3-4",
      tagline: "Powerful projection with warmth",
      description:
        "The Kaplan series brings a rich, warm tone with excellent projection — ideal for players who want more colour and depth from their instrument without sacrificing clarity.",
      suitedFor: ["Advancing players", "Orchestral"],
      tone: "warm",
      level: ["advancing", "professional"],
    },
    {
      name: "Thomastik Spirocore Double Bass String Set 3/4",
      brand: "Thomastik",
      price: "$539.40",
      url: "/products/thomastik-spirocore-double-bass-string-set-3-4",
      tagline: "The world's most popular bass string",
      description:
        "A steel spiral core string that has dominated orchestral double bass for decades. Bright, powerful tone with outstanding projection — the professional orchestral standard.",
      suitedFor: ["Orchestral players", "Professional players"],
      tone: "bright",
      level: ["professional"],
    },
    {
      name: "Thomastik Belcanto Double Bass String Set 3/4",
      brand: "Thomastik",
      price: "$636.30",
      url: "/products/belcanto-orchestral-double-bass-string-set",
      tagline: "Beautiful singing tone for soloists",
      description:
        '"Belcanto" — beautiful singing. This string is engineered for a singing, lyrical tone with warmth and presence perfect for solo passages and concerto playing.',
      suitedFor: ["Soloists", "Professional players"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Obligato Double Bass String Set",
      brand: "Pirastro",
      price: "$697.90",
      url: "/products/obligato-double-bass-string-set",
      tagline: "Gut-like warmth for Baroque and Classical",
      description:
        "Synthetic core with a deeply warm tone reminiscent of gut strings. Ideal for Baroque and Classical-era repertoire where a soft, round tone is paramount.",
      suitedFor: ["Baroque players", "Classical"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Pirastro Evah Pirazzi Double Bass String Set 3/4",
      brand: "Pirastro",
      price: "$761.95",
      url: "/products/evah-pirazzi-double-bass-string-set",
      tagline: "Full power, expressive depth",
      description:
        "The EP for double bass delivers the same world-class quality as the violin and cello variants. A complex, warm tone with enormous power — the choice of leading professional bassists.",
      suitedFor: ["Professional players", "Soloists"],
      tone: "warm",
      level: ["professional"],
    },
    {
      name: "Thomastik Peter Infeld Double Bass String Set 3/4",
      brand: "Thomastik",
      price: "$701.60",
      url: "/products/thomastik-peter-infeld-double-bass-string-set-3-4",
      tagline: "The most refined double bass string",
      description:
        "Thomastik's finest double bass offering. A sweet, complex tone with exceptional playability and dynamic range — for the principal bassist who demands the absolute best.",
      suitedFor: ["Top professional players", "Principal bassists"],
      tone: "warm",
      level: ["professional"],
    },
  ];
function Fm(e) {
  switch (e) {
    case "violin":
      return jm;
    case "viola":
      return Lm;
    case "cello":
      return Rm;
    case "doublebass":
      return bm;
  }
}
function Om(e, t) {
  if (e === "c") return 9999;
  if (t === "cello" || t === "doublebass") {
    if (e === "a") return 300;
    if (e === "b") return 500;
  }
  return e === "a" ? 100 : e === "b" ? 200 : 9999;
}
function Mm(e) {
  const t = e.replace(/[~,]/g, "").match(/\d+(\.\d+)?/);
  return t ? parseFloat(t[0]) : 0;
}
function ma(e) {
  var t;
  return (
    ((t = e.split("/products/")[1]) == null ? void 0 : t.split(/[?#]/)[0]) ?? ""
  );
}
function Am(e, t) {
  return t
    ? e
        .filter((n) => t[n.priceKey ?? ma(n.url)] !== void 0)
        .map((n) => {
          const r = t[n.priceKey ?? ma(n.url)];
          return {
            ...n,
            price: r.price || n.price,
            url: r.url || n.url,
            variantId: r.variantId ?? void 0,
            image: r.image ?? n.image,
            available: r.available,
          };
        })
    : e;
}
function Dm(e, t) {
  const {
    instrument: n,
    level: r,
    context: l,
    style: o,
    tone: i,
    budget: s,
  } = e;
  if (!n) return [];
  const a = Am(Fm(n), t),
    c = s ? Om(s, n) : 9999,
    p = a.map((g) => {
      let E = 0;
      return (
        r && g.level.includes(r) && (E += 4),
        i === "bright" && g.tone === "bright" && (E += 3),
        i === "warm" && g.tone === "warm" && (E += 3),
        g.tone === "balanced" && (E += 1),
        l === "soloist"
          ? g.suitedFor.some((d) => d.toLowerCase().includes("soloist")) &&
            (E += 2)
          : l === "orchestral" &&
            g.suitedFor.some((d) => d.toLowerCase().includes("orchestral")) &&
            (E += 2),
        o === "baroque"
          ? (g.gut && (E += r === "beginner" ? -4 : 6),
            g.suitedFor.some((d) => d.toLowerCase().includes("baroque")) &&
              (E += 2))
          : o === "folk"
            ? g.suitedFor.some((d) => d.toLowerCase().includes("folk")) &&
              (E += 2)
            : o === "classical" &&
              g.suitedFor.some((d) => d.toLowerCase().includes("classical")) &&
              (E += 1),
        { string: g, score: E, price: Mm(g.price) }
      );
    }),
    h = p.filter((g) => g.price <= c),
    m = h.length > 0 ? h : p;
  m.sort((g, E) => E.score - g.score || E.price - g.price);
  const v = [],
    w = new Set();
  if (o === "baroque" && r !== "beginner") {
    const g = m.find((E) => E.string.gut && E.price <= c);
    g && (v.push(g), w.add(g.string.brand));
  }
  for (const g of m) {
    if (v.length === 3) break;
    w.has(g.string.brand) || (v.push(g), w.add(g.string.brand));
  }
  if (v.length < 3)
    for (const g of m) {
      if (v.length === 3) break;
      v.includes(g) || v.push(g);
    }
  return v.map((g) => g.string);
}
const Im = [
  {
    id: "level",
    number: 1,
    question: "How would you consider your level of playing?",
    options: [
      {
        value: "beginner",
        label: "Beginner",
        detail: "Still learning the fundamentals",
      },
      {
        value: "advancing",
        label: "Advancing Musician",
        detail: "Playing for a few years, developing technique",
      },
      {
        value: "professional",
        label: "Professional Player",
        detail: "Performing, teaching, or studying at a high level",
      },
    ],
  },
  {
    id: "instrument",
    number: 2,
    question: "Which instrument do you play?",
    options: [
      { value: "violin", label: "Violin" },
      { value: "viola", label: "Viola" },
      { value: "cello", label: "Cello" },
      { value: "doublebass", label: "Double Bass" },
    ],
  },
  {
    id: "context",
    number: 3,
    question: "Do you do more orchestral playing, or are you a soloist?",
    options: [
      {
        value: "orchestral",
        label: "Orchestral",
        detail: "Section or ensemble playing",
      },
      {
        value: "soloist",
        label: "Soloist",
        detail: "Concerto, recital, or featured playing",
      },
    ],
  },
  {
    id: "style",
    number: 4,
    question: "Which style of playing fits closest with yours?",
    options: [
      {
        value: "classical",
        label: "Classical",
        detail: "Standard concert repertoire",
      },
      {
        value: "baroque",
        label: "Baroque",
        detail: "Historical and early music performance",
      },
      {
        value: "folk",
        label: "Folk",
        detail: "Traditional, fiddle, or crossover styles",
      },
    ],
  },
  {
    id: "tone",
    number: 5,
    question: "Which tone do you prefer?",
    options: [
      {
        value: "bright",
        label: "Bright",
        detail: "Crisp, clear, and projecting",
      },
      { value: "warm", label: "Warm", detail: "Rich, dark, and resonant" },
    ],
  },
];
function ha(e) {
  return {
    id: "budget",
    number: 6,
    question: "How much are you hoping to spend on your string set?",
    options:
      e === "cello" || e === "doublebass"
        ? [
            {
              value: "a",
              label: "Up to $300",
              detail: "Student & entry-level range",
            },
            {
              value: "b",
              label: "Up to $500",
              detail: "Mid-range advancing options",
            },
            {
              value: "c",
              label: "$500+ — Price is not a factor",
              detail: "Professional quality strings",
            },
          ]
        : [
            {
              value: "a",
              label: "Up to $100",
              detail: "Student & entry-level range",
            },
            {
              value: "b",
              label: "Up to $200",
              detail: "Mid-range advancing options",
            },
            {
              value: "c",
              label: "$200+ — Price is not a factor",
              detail: "Professional quality strings",
            },
          ],
  };
}
function $m() {
  const [e, t] = F.useState("intro"),
    [n, r] = F.useState(0),
    [l, o] = F.useState({}),
    [i, s] = F.useState(0),
    a = F.useRef(null),
    { livePrices: c, syncedAt: p } = Tm(),
    h = F.useMemo(() => {
      const k = [...Im];
      return (
        l.instrument ? k.push(ha(l.instrument)) : k.push(ha("violin")),
        k
      );
    }, [l.instrument]),
    m = h.length,
    v = h[n],
    w = l[v == null ? void 0 : v.id],
    g = e === "result" ? 100 : Math.round((n / m) * 100);
  function E(k) {
    o((N) => ({ ...N, [v.id]: k }));
  }
  function d() {
    n < m - 1 ? (s((k) => k + 1), r((k) => k + 1)) : t("result");
  }
  function u() {
    n > 0 ? (s((k) => k + 1), r((k) => k - 1)) : t("intro");
  }
  function f() {
    (t("quiz"), r(0), o({}), s(0));
  }
  function y() {
    (t("intro"),
      r(0),
      o({}),
      s(0),
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          var k;
          (k = a.current) == null ||
            k.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }));
  }
  const C = F.useMemo(() => (e !== "result" ? [] : Dm(l, c)), [e, l, c]);
  return S.jsxs("div", {
    ref: a,
    className:
      "ssf-app min-h-[calc(100vh-230px)] bg-background relative overflow-hidden",
    children: [
      S.jsx("div", {
        className: "pointer-events-none absolute inset-0 opacity-[0.035]",
        style: {
          backgroundImage:
            "radial-gradient(circle at 25% 25%, hsl(var(--primary)) 0%, transparent 50%), radial-gradient(circle at 75% 75%, hsl(var(--gold)) 0%, transparent 50%)",
        },
      }),
      S.jsxs("div", {
        className: "relative z-10 min-h-[calc(100vh-330px)] flex flex-col",
        children: [
          e !== "intro" &&
            S.jsx("div", {
              className: "h-px bg-border relative overflow-hidden",
              children: S.jsx("div", {
                className:
                  "progress-line absolute left-0 top-0 h-full bg-primary",
                style: { width: `${g}%` },
              }),
            }),
          S.jsx("main", {
            className: "flex-1 flex items-center justify-center px-4 py-12",
            children: S.jsxs("div", {
              className: "w-full max-w-2xl",
              children: [
                e === "intro" &&
                  S.jsxs("div", {
                    className:
                      "animate-fade-up text-center min-[750px]:text-left",
                    children: [
                      S.jsx("div", {
                        className: "inline-block mb-6",
                        children: S.jsx("span", {
                          className:
                            "font-dm text-xs font-semibold tracking-[0.18em] uppercase text-primary border border-primary/30 rounded-full px-3 py-1",
                          children: "String Finder",
                        }),
                      }),
                      S.jsxs("h1", {
                        className: "ssf-hero-title text-foreground mb-4",
                        children: [
                          "Find your",
                          " ",
                          S.jsx("span", {
                            className: "italic text-primary font-georgia",
                            children: "perfect",
                          }),
                          // S.jsx("br", {}),
                          " string set.",
                        ],
                      }),
                      S.jsx("p", {
                        className: "ssf-newsletter-text mb-3 min-[750px]:max-w-md",
                        children:
                          "Knowing which strings are the best fit for you can be tricky - there are so many to choose from!",
                      }),
                      S.jsx("p", {
                        className: "ssf-newsletter-text mb-10 min-[750px]:max-w-md",
                        children:
                          "From beginner-friendly strings to concert-professional sets, we'll find the right recommendation to suit your playing.",
                      }),
                      S.jsxs(Qn, {
                        onClick: f,
                        size: "lg",
                        className:
                          "font-dm font-medium tracking-wide px-8 py-5 text-base",
                        children: [
                          "Begin",
                          S.jsx(ua, { className: "w-4 h-4 ml-2" }),
                        ],
                      }),
                      S.jsx("div", {
                        className:
                          "mt-14 flex items-center gap-6 justify-center min-[750px]:justify-start text-muted-foreground/25",
                        children: ["Violin", "Viola", "Cello", "Bass"].map(
                          (k) =>
                            S.jsx(
                              "span",
                              {
                                className: "font-playfair text-xs italic",
                                children: k,
                              },
                              k,
                            ),
                        ),
                      }),
                    ],
                  }),
                e === "quiz" &&
                  v &&
                  S.jsxs("div", {
                    children: [
                      S.jsx(wm, {
                        question: v,
                        selected: w,
                        onSelect: E,
                        animKey: i,
                      }),
                      S.jsxs("div", {
                        className: "flex items-center justify-between mt-8",
                        children: [
                          S.jsxs(Qn, {
                            variant: "ghost",
                            size: "sm",
                            onClick: u,
                            className:
                              "font-dm text-sm text-muted-foreground flex items-center gap-1.5",
                            children: [
                              S.jsx(Np, { className: "w-3.5 h-3.5" }),
                              n === 0 ? "Back" : "Previous",
                            ],
                          }),
                          S.jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                              S.jsx("div", {
                                className: "flex items-center gap-1.5 mr-3",
                                children: h.map((k, N) =>
                                  S.jsx(
                                    "div",
                                    {
                                      className: _e(
                                        "rounded-full transition-all duration-300",
                                        N === n
                                          ? "w-4 h-1.5 bg-primary"
                                          : N < n
                                            ? "w-1.5 h-1.5 bg-primary/40"
                                            : "w-1.5 h-1.5 bg-muted-foreground/20",
                                      ),
                                    },
                                    N,
                                  ),
                                ),
                              }),
                              S.jsxs(Qn, {
                                size: "sm",
                                onClick: d,
                                disabled: !w,
                                className:
                                  "font-dm font-medium flex items-center gap-1.5 disabled:opacity-40",
                                children: [
                                  n === m - 1 ? "See Results" : "Next",
                                  S.jsx(ua, { className: "w-3.5 h-3.5" }),
                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                e === "result" &&
                  S.jsx(Nm, {
                    recommendations: C,
                    answers: l,
                    pricesUpdatedAt: p,
                    onRetake: y,
                  }),
              ],
            }),
          }),
        ],
      }),
    ],
  });
}
const Bm = () => S.jsx($m, {});
zc(document.getElementById("root")).render(S.jsx(Bm, {}));
